'use strict'
import md5 from 'js-md5'
import Vue from 'vue'
// import VueLocalStorage from 'vue-localstorage'
export default {
  isSearch: function(str) {
    //只能输入数字字母和中文
    return /^[A-Za-z0-9\u4e00-\u9fa5\.]+$/.test(str)
  },
  isString: function(str, num) {
    if (typeof str !== 'string') return false
    if (str.trim().length < 6 || str.trim().length > 20) return false
    if (str.trim().length != num && num) {
      return false
    }
    return true
  },
  isInt: function(num) {
    // if (typeof num !== 'number') return false
    return /^[0-9]+$/.test(num)
  },
  isInteger: function(str) {
    //整数
    return /^-?\d+$/.test(str)
  },
  isPositiveInteger: function(str) {
    //正整数
    return /^[1-9]\d*$/.test(str)
  },
  credit: function(num) {
    // 社会统一信用证号
    return /[0-9A-Z]{18}/.test(num)
  },
  phonecode: function(num) {
    // 电话
    return /^0\d{2,3}-?\d{7,8}$/.test(num)
  },
  telphone: function(num) {
    // 手机号
    return /^1[3456789]\d{9}$/.test(num)
  },
  isEmail: function(str) {
    // 邮箱
    // return /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/.test(str)
    return /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/.test(str)
    // return /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(str)
  },
  bankaccount: function(num) {
    // 银行账号
    return /^([1-9]{1})(\d{14}|\d{18})$/.test(num)
  },
  maxLength: function(str, len = 140) {
    if (!this.isString(str)) return false
    if (str.length >= ~~len) return false
    return true
  },
  minLength: function(str, len = 1) {
    if (!this.isString(str)) return false
    if (str.length < ~~len) return false
    return true
  },
  isMoney: function(num) {
    // 人民币
    if (!num) return false
    return /^[0-9]+(.[0-9]{1,2})?$/.test(num)
  },
  isZeroOrNum: function(num) {
    if (!num) return false
    return /^(0|[1-9][0-9]*)$/.test(num)
  },
  isFloatNum: function(num) {
    if (!num) return false
    return /^(-?\d+)(\.\d+)?$/.test(num)
  },
  isID: function(num) {
    // 身份证
    if (!num) return false
    return /^\d{15}|\d{18}$/.test(num)
  },
  isIp: function(ip) {
    //ip
    var reg = /^(\d|[1-9]\d|1\d{2}|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d{2}|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d{2}|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d{2}|2[0-4]\d|25[0-5])$/
    return reg.test(ip)
  },
  isPort: function(port) {
    //端口号
    var reg = /^([0-9]|[1-9]\d{1,3}|[1-5]\d{4}|6[0-4]\d{4}|65[0-4]\d{2}|655[0-2]\d|6553[0-5])$/
    return reg.test(port)
  },
  isAccount: function(account) {
    if (!account) return false
    return /^[a-zA-Z][a-zA-Z0-9_]{5,13}$/.test(account)
  },
  isName: function(str) {
    if (!str) return false
    return /^[\u4e00-\u9fa5]{0,}$/.test(str)
  },
  isAlipay: function(str) {
    //支付宝
    if (/^(1)[0-9]{10}$/.test(str)) {
      //手机号
      return true
    } else if (/^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(str)) {
      //邮箱
      return true
    } else {
      return false
    }
  },
  isPsd(str) {
    if (!str) return false
    return /^(?!([a-zA-Z]+|[a-z\d]+|[a-z~`@#\$%\^&\*\(\)_\-\+=\{\[\}\]\|\\:;\"\'<,>\.\?\/\!]+|[A-Z\d]+|[A-Z~`@#\$%\^&\*\(\)_\-\+=\{\[\}\]\|\\:;\"\'<,>\.\?\/\!]+|[\d~`@#\$%\^&\*\(\)_\-\+=\{\[\}\]\|\\:;\"\'<,>\.\?\/\!]+)$)[a-zA-Z\d~`@#\$%\^&\*\(\)_\-\+=\{\[\}\]\|\\:;\"\'<,>\.\?\/\!]+$/.test(str)
  },
  is16Binary(str) {
    // 16进制校验
    if (!str) return false
    return /^([0-9A-F]{4})$/.test(str)
  },
  regRule: {
    idCard: /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/,
    phone: /^1[34578]\d{9}$/,
    nGInteger: /^\d+$/, // 排序号
    code: /^[0-9a-zA-Z]+$/, // 編号
    isComponent: /^[a-zA-Z]+$/, // 字母
    number: /^[0-9]+$/ //数字
  },
  zhDatetime: function(t) {
    //格式化时间
    if (t == '' || t == null || t == undefined) {
      return ''
    } else {
      var d = new Date()
      d.setTime(t)
      var Y = d.getFullYear()
      var M = d.getMonth() + 1
      var D = d.getDate()
      var h = d.getHours()
      var m = d.getMinutes()
      var s = d.getSeconds()
      M = M > 9 ? M : '0' + M
      D = D > 9 ? D : '0' + D
      h = h > 9 ? h : '0' + h
      m = m > 9 ? m : '0' + m
      s = s > 9 ? s : '0' + s
      return Y + '-' + M + '-' + D + ' ' + h + ':' + m + ':' + s
    }
  },
  zhDatetime1: function(t) {
    //格式化时间
    if (t == '' || t == null || t == undefined) {
      return ''
    } else {
      var d = new Date()
      d.setTime(t)
      var Y = d.getFullYear()
      var M = d.getMonth() + 1
      var D = d.getDate()
      var h = d.getHours()
      var m = d.getMinutes()
      var s = d.getSeconds()
      M = M > 9 ? M : '0' + M
      D = D > 9 ? D : '0' + D
      h = h > 9 ? h : '0' + h
      m = m > 9 ? m : '0' + m
      s = s > 9 ? s : '0' + s
      return h + ':' + m
    }
  },
  zhDate: function(t) {
    //格式化时间
    if (t == '' || t == null || t == undefined) {
      return ''
    } else {
      var d = new Date()
      d.setTime(t)
      var Y = d.getFullYear()
      var M = d.getMonth() + 1
      var D = d.getDate()
      var h = d.getHours()
      var m = d.getMinutes()
      var s = d.getSeconds()
      M = M > 9 ? M : '0' + M
      D = D > 9 ? D : '0' + D
      h = h > 9 ? h : '0' + h
      m = m > 9 ? m : '0' + m
      s = s > 9 ? s : '0' + s
      return Y + '-' + M + '-' + D
    }
  },
  zhDate2: function(t) {
    //格式化时间
    if (t == '' || t == null || t == undefined) {
      return ''
    } else {
      var d = new Date()
      d.setTime(t)
      var Y = d.getFullYear()
      var M = d.getMonth() + 1
      var D = d.getDate()
      var h = d.getHours()
      var m = d.getMinutes()
      var s = d.getSeconds()
      M = M > 9 ? M : '0' + M
      D = D > 9 ? D : '0' + D
      h = h > 9 ? h : '0' + h
      m = m > 9 ? m : '0' + m
      s = s > 9 ? s : '0' + s
      return Y + '' + M + '' + D
    }
  },
  zhDate3: function(t) {
    //格式化时间
    if (t == '' || t == null || t == undefined) {
      return ''
    } else {
      var d = new Date()
      d.setTime(t)
      var Y = d.getFullYear()
      var M = d.getMonth() + 1
      var D = d.getDate()
      var h = d.getHours()
      var m = d.getMinutes()
      var s = d.getSeconds()
      M = M > 9 ? M : '0' + M
      D = D > 9 ? D : '0' + D
      h = h > 9 ? h : '0' + h
      m = m > 9 ? m : '0' + m
      s = s > 9 ? s : '0' + s
      return Y + '_' + M + '_' + D
    }
  },
  zhDate4: function(t) {
    //格式化时间--年
    if (t == '' || t == null || t == undefined) {
      return ''
    } else {
      var d = new Date()
      d.setTime(t)
      var Y = d.getFullYear()
      var M = d.getMonth() + 1
      var D = d.getDate()
      var h = d.getHours()
      var m = d.getMinutes()
      var s = d.getSeconds()
      M = M > 9 ? M : '0' + M
      D = D > 9 ? D : '0' + D
      h = h > 9 ? h : '0' + h
      m = m > 9 ? m : '0' + m
      s = s > 9 ? s : '0' + s
      return Y
    }
  },
  zhDate5: function(t) {
    //格式化时间  年-月
    if (t == '' || t == null || t == undefined) {
      return ''
    } else {
      var d = new Date()
      d.setTime(t)
      var Y = d.getFullYear()
      var M = d.getMonth() + 1
      var D = d.getDate()
      var h = d.getHours()
      var m = d.getMinutes()
      var s = d.getSeconds()
      M = M > 9 ? M : '0' + M
      D = D > 9 ? D : '0' + D
      h = h > 9 ? h : '0' + h
      m = m > 9 ? m : '0' + m
      s = s > 9 ? s : '0' + s
      return Y + '-' + M
    }
  },

  // 获取日期范围相关 -- 开始
  /*
   *获取本月1号到今天的日期
   *返回值："起始时间,结束时间"
   */
  monthFirst: function() {
    var returnBegDateStr = new Date() //当前时间
    var returnEndDateStr = new Date() //当前时间
    returnBegDateStr.setDate(1) // 设置为本月第一天
    return [this.zhDate(returnBegDateStr) + ' 00:00:00', this.zhDate(returnEndDateStr) + ' 23:59:59']
  },
  /*
   *获取今日的起始和结束时间
   *返回值："起始时间,结束时间"
   */
  toDayStr: function() {
    var returnBegDateStr = ''
    var returnEndDateStr = ''
    var date = new Date() //当前时间
    var year = date.getFullYear()
    var month = date.getMonth() + 1
    var day = date.getDate()
    //var hour = date.getHours();
    //var minutes = date.getMinutes();
    //var second = date.getSeconds();
    month = month < 10 ? '0' + month : month
    day = day < 10 ? '0' + day : day
    returnBegDateStr = year + '-' + month + '-' + day + ' 00:00:00' //起始时间
    returnEndDateStr = year + '-' + month + '-' + day + ' 23:59:59' //结束时间
    return [returnBegDateStr, returnEndDateStr]
  },

  /*
   *获取本周的起始和结束时间
   *返回值："起始时间,结束时间"
   */
  thisWeekStr: function(val) {
    var returnBegDateStr = ''
    var returnEndDateStr = ''
    if (val) {
      var date = new Date(val) // 自定义时间
    } else {
      var date = new Date() //当前时间
    }
    var week = date.getDay() //获取今天星期几
    var monday = this.GetDate2(week - 1, 1, date) //获取星期一
    var sunday = this.GetDate2(7 - week, 2, date) //获取星期天
    //起始时间的年月日
    var year1 = monday.getFullYear()
    var month1 = monday.getMonth() + 1
    var day1 = monday.getDate()
    //结束时间的年月日
    var year2 = sunday.getFullYear()
    var month2 = sunday.getMonth() + 1
    var day2 = sunday.getDate()
    //处理起始时间小于10的追加"0"在前面
    month1 = month1 < 10 ? '0' + month1 : month1
    day1 = day1 < 10 ? '0' + day1 : day1
    //处理结束时间小于10的追加"0"在前面
    month2 = month2 < 10 ? '0' + month2 : month2
    day2 = day2 < 10 ? '0' + day2 : day2

    returnBegDateStr = year1 + '-' + month1 + '-' + day1 + ' 00:00:00' //起始时间
    returnEndDateStr = year2 + '-' + month2 + '-' + day2 + ' 23:59:59' //结束时间
    return [returnBegDateStr, returnEndDateStr]
  },

  /*
   *获取本月的起始和结束时间
   *返回值："起始时间,结束时间"
   */
  thisMonthStr: function() {
    var returnBegDateStr = ''
    var returnEndDateStr = ''
    var date = new Date() //当前时间
    var year = date.getFullYear()
    var month = date.getMonth()

    var min = new Date(year, month, 1) //本月月初
    var max = new Date(year, month + 1, 0) //本月月底

    //起始时间的年月日
    var year1 = min.getFullYear()
    var month1 = min.getMonth() + 1
    var day1 = min.getDate()
    //结束时间的年月日
    var year2 = max.getFullYear()
    var month2 = max.getMonth() + 1
    var day2 = max.getDate()
    //处理起始时间小于10的追加"0"在前面
    month1 = month1 < 10 ? '0' + month1 : month1
    day1 = day1 < 10 ? '0' + day1 : day1
    //处理结束时间小于10的追加"0"在前面
    month2 = month2 < 10 ? '0' + month2 : month2
    day2 = day2 < 10 ? '0' + day2 : day2

    returnBegDateStr = year1 + '-' + month1 + '-' + day1 + ' 00:00:00' //起始时间
    returnEndDateStr = year2 + '-' + month2 + '-' + day2 + ' 23:59:59' //结束时间
    return [returnBegDateStr, returnEndDateStr]
  },
  /*
   *获取当前日期前N天或后N日期(N = day)
   *type:1：前；2：后
   */
  GetDate: function(day, type) {
    var zdate = new Date()
    var edate
    if (type === 1) {
      edate = new Date(zdate.getTime() - day * 24 * 60 * 60 * 1000)
    } else {
      edate = new Date(zdate.getTime() + day * 24 * 60 * 60 * 1000)
    }
    return edate
  },

  /*
   *获取传入的日期前N天或后N日期(N = day)
   *type:1：前；2：后
   *date：传入的日期
   */
  GetDate2: function(day, type, date) {
    var zdate
    if (date === null || date === undefined) {
      zdate = new Date()
    } else {
      zdate = date
    }
    var edate
    if (type === 1) {
      edate = new Date(zdate.getTime() - day * 24 * 60 * 60 * 1000)
    } else {
      edate = new Date(zdate.getTime() + day * 24 * 60 * 60 * 1000)
    }
    return edate
  },

  // 获取日期范围相关 -- 结束

  filteremoji: function(str) {
    //过滤表情
    var emojiReg = /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/gi
    var msgHdnValue = str
    //替换emoji表情，以及末尾空格，和&nbsp;空格
    msgHdnValue = msgHdnValue
      .replace(emojiReg, '')
      .replace(/(\s*$)/g, '')
      .trim()
    return msgHdnValue
  },
  filteremojifun(self, e, name, ruleForm) {
    //限制输入表情
    if (ruleForm) {
      self[ruleForm][name] = this.filteremoji(e)
    } else {
      self[name] = this.filteremoji(e)
    }
  },
  setStorage(name, value) {
    return localStorage.setItem(name, value)
  },
  getStorage(name) {
    return localStorage.getItem(name)
  },
  delStorage(name) {
    return localStorage.removeItem(name)
  },
  delAllStorage() {
    return localStorage.clear()
  },
  setSession(name, value) {
    //暂时存储
    return sessionStorage.setItem(name, value)
  },
  getSession(name) {
    //暂时存储
    return sessionStorage.getItem(name)
  },
  delSession(name) {
    //暂时存储
    return sessionStorage.removeItem(name)
  },
  delAllSession() {
    return sessionStorage.clear()
  },
  getToken() {
    return sessionStorage.getItem('TOKEN')
  },
  setToken(token) {
    this.setSession('TOKEN', token)
  },
  removeToken() {
    return sessionStorage.removeItem('TOKEN')
  },
  //设置cookie
  setCookie(c_name, c_pwd, exdays, c_remeberFlag) {
    var exdate = new Date() //获取时间
    exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays) //保存的天数
    //字符串拼接cookie
    window.document.cookie = 'USERNAME' + '=' + c_name + ';path=/;expires=' + exdate.toGMTString()
    window.document.cookie = 'PASSWORD' + '=' + c_pwd + ';path=/;expires=' + exdate.toGMTString()
    window.document.cookie = 'REMEBERFLAG' + '=' + c_remeberFlag + ';path=/;expires=' + exdate.toGMTString()
  },
  //读取cookie
  getCookie(self) {
    if (document.cookie.length > 0) {
      var arr = document.cookie.split('; ') //这里显示的格式需要切割一下自己可输出看下
      // console.log(arr)
      for (var i = 0; i < arr.length; i++) {
        var arr2 = arr[i].split('=') //再次切割
        //判断查找相对应的值
        // console.log(arr2)
        if (arr2[0] == 'USERNAME') {
          self.ruleForm.userName = arr2[1] //保存到保存数据的地方
        } else if (arr2[0] == 'PASSWORD') {
          self.ruleForm.pwd = arr2[1]
        } else if (arr2[0] == 'REMEBERFLAG') {
          self.rememberPassword = arr2[1] == 'true'
        }
      }
    }
  },
  //清除cookie
  clearCookie() {
    this.setCookie('', '', -1) //修改2值都为空，天数为负1天就好了
  },
  calcuMD5(pwd) {
    pwd = md5(md5(pwd) + 'bby')
    return pwd
  },
  getCityList() {
    const citys = [
      {
        id: 1,
        pid: 0,
        city_code: '101010100',
        city_name: '北京',
        post_code: '100000',
        area_code: '010',
        ctime: '2019-07-11 17:30:06'
      },
      {
        id: 2,
        pid: 0,
        city_code: '',
        city_name: '安徽',
        post_code: null,
        area_code: null,
        ctime: null
      },
      {
        id: 3,
        pid: 0,
        city_code: '',
        city_name: '福建',
        post_code: null,
        area_code: null,
        ctime: null
      },
      {
        id: 4,
        pid: 0,
        city_code: '',
        city_name: '甘肃',
        post_code: null,
        area_code: null,
        ctime: null
      },
      {
        id: 5,
        pid: 0,
        city_code: '',
        city_name: '广东',
        post_code: null,
        area_code: null,
        ctime: null
      },
      {
        id: 6,
        pid: 0,
        city_code: '',
        city_name: '广西',
        post_code: null,
        area_code: null,
        ctime: null
      },
      {
        id: 7,
        pid: 0,
        city_code: '',
        city_name: '贵州',
        post_code: null,
        area_code: null,
        ctime: null
      },
      {
        id: 8,
        pid: 0,
        city_code: '',
        city_name: '海南',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 17:03:37'
      },
      {
        id: 9,
        pid: 0,
        city_code: '',
        city_name: '河北',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 17:30:06'
      },
      {
        id: 10,
        pid: 0,
        city_code: '',
        city_name: '河南',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 17:30:07'
      },
      {
        id: 11,
        pid: 0,
        city_code: '',
        city_name: '黑龙江',
        post_code: null,
        area_code: null,
        ctime: null
      },
      {
        id: 12,
        pid: 0,
        city_code: '',
        city_name: '湖北',
        post_code: null,
        area_code: null,
        ctime: null
      },
      {
        id: 13,
        pid: 0,
        city_code: '',
        city_name: '湖南',
        post_code: null,
        area_code: null,
        ctime: null
      },
      {
        id: 14,
        pid: 0,
        city_code: '',
        city_name: '吉林',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 17:30:07'
      },
      {
        id: 15,
        pid: 0,
        city_code: '',
        city_name: '江苏',
        post_code: null,
        area_code: null,
        ctime: null
      },
      {
        id: 16,
        pid: 0,
        city_code: '',
        city_name: '江西',
        post_code: null,
        area_code: null,
        ctime: null
      },
      {
        id: 17,
        pid: 0,
        city_code: '',
        city_name: '辽宁',
        post_code: null,
        area_code: null,
        ctime: null
      },
      {
        id: 18,
        pid: 0,
        city_code: '',
        city_name: '内蒙古',
        post_code: null,
        area_code: null,
        ctime: null
      },
      {
        id: 19,
        pid: 0,
        city_code: '',
        city_name: '宁夏',
        post_code: null,
        area_code: null,
        ctime: null
      },
      {
        id: 20,
        pid: 0,
        city_code: '',
        city_name: '青海',
        post_code: null,
        area_code: null,
        ctime: null
      },
      {
        id: 21,
        pid: 0,
        city_code: '',
        city_name: '山东',
        post_code: null,
        area_code: null,
        ctime: null
      },
      {
        id: 22,
        pid: 0,
        city_code: '',
        city_name: '山西',
        post_code: null,
        area_code: null,
        ctime: null
      },
      {
        id: 23,
        pid: 0,
        city_code: '',
        city_name: '陕西',
        post_code: null,
        area_code: null,
        ctime: null
      },
      {
        id: 24,
        pid: 0,
        city_code: '101020100',
        city_name: '上海',
        post_code: '200000',
        area_code: '021',
        ctime: '2019-07-11 17:30:08'
      },
      {
        id: 25,
        pid: 0,
        city_code: '',
        city_name: '四川',
        post_code: null,
        area_code: null,
        ctime: null
      },
      {
        id: 26,
        pid: 0,
        city_code: '101030100',
        city_name: '天津',
        post_code: '300000',
        area_code: '022',
        ctime: '2019-07-11 17:30:08'
      },
      {
        id: 27,
        pid: 0,
        city_code: '',
        city_name: '西藏',
        post_code: null,
        area_code: null,
        ctime: null
      },
      {
        id: 28,
        pid: 0,
        city_code: '',
        city_name: '新疆',
        post_code: null,
        area_code: null,
        ctime: null
      },
      {
        id: 29,
        pid: 0,
        city_code: '',
        city_name: '云南',
        post_code: null,
        area_code: null,
        ctime: null
      },
      {
        id: 30,
        pid: 0,
        city_code: '',
        city_name: '浙江',
        post_code: null,
        area_code: null,
        ctime: null
      },
      {
        id: 31,
        pid: 0,
        city_code: '101040100',
        city_name: '重庆',
        post_code: null,
        area_code: '023',
        ctime: '2019-07-11 17:30:08'
      },
      {
        id: 32,
        pid: 0,
        city_code: '101320101',
        city_name: '香港',
        post_code: '999077',
        area_code: '+852',
        ctime: '2019-07-11 17:03:38'
      },
      {
        id: 33,
        pid: 0,
        city_code: '101330101',
        city_name: '澳门',
        post_code: '999078',
        area_code: '+853',
        ctime: '2019-07-11 17:03:39'
      },
      {
        id: 34,
        pid: 0,
        city_code: '',
        city_name: '台湾',
        post_code: null,
        area_code: null,
        ctime: null
      },
      {
        id: 35,
        pid: 2,
        city_code: '101220601',
        city_name: '安庆',
        post_code: '246000',
        area_code: '0556',
        ctime: '2019-07-11 17:30:10'
      },
      {
        id: 36,
        pid: 2,
        city_code: '101220201',
        city_name: '蚌埠',
        post_code: '233000',
        area_code: '0552',
        ctime: '2019-07-11 17:30:10'
      },
      {
        id: 37,
        pid: 3400,
        city_code: '101220105',
        city_name: '巢湖市',
        post_code: '238000',
        area_code: '0551',
        ctime: '2019-07-11 17:03:40'
      },
      {
        id: 38,
        pid: 2,
        city_code: '101221701',
        city_name: '池州',
        post_code: '247100',
        area_code: '0566',
        ctime: '2019-07-11 17:30:10'
      },
      {
        id: 39,
        pid: 2,
        city_code: '101221101',
        city_name: '滁州',
        post_code: '239000',
        area_code: '0550',
        ctime: '2019-07-11 17:30:10'
      },
      {
        id: 40,
        pid: 2,
        city_code: '101220801',
        city_name: '阜阳',
        post_code: '236000',
        area_code: '0558',
        ctime: '2019-07-11 17:30:10'
      },
      {
        id: 41,
        pid: 2,
        city_code: '101221201',
        city_name: '淮北',
        post_code: '235000',
        area_code: '0561',
        ctime: '2019-07-11 17:30:11'
      },
      {
        id: 42,
        pid: 2,
        city_code: '101220401',
        city_name: '淮南',
        post_code: '232000',
        area_code: '0554',
        ctime: '2019-07-11 17:30:11'
      },
      {
        id: 43,
        pid: 2,
        city_code: '101221001',
        city_name: '黄山市',
        post_code: '245000',
        area_code: '0559',
        ctime: '2019-07-11 21:23:56'
      },
      {
        id: 44,
        pid: 2,
        city_code: '101221501',
        city_name: '六安',
        post_code: '237000',
        area_code: '0564',
        ctime: '2019-07-11 17:30:11'
      },
      {
        id: 45,
        pid: 2,
        city_code: '101220501',
        city_name: '马鞍山',
        post_code: '243000',
        area_code: '0555',
        ctime: '2019-07-11 17:30:11'
      },
      {
        id: 46,
        pid: 2,
        city_code: '101220701',
        city_name: '宿州',
        post_code: '234000',
        area_code: '0557',
        ctime: '2019-07-11 17:30:11'
      },
      {
        id: 47,
        pid: 2,
        city_code: '101221301',
        city_name: '铜陵',
        post_code: '244000',
        area_code: '0562',
        ctime: '2019-07-11 17:30:12'
      },
      {
        id: 48,
        pid: 2,
        city_code: '101220301',
        city_name: '芜湖市',
        post_code: '241000',
        area_code: '0553',
        ctime: '2019-07-11 21:23:57'
      },
      {
        id: 49,
        pid: 2,
        city_code: '101221401',
        city_name: '宣城',
        post_code: '242000',
        area_code: '0563',
        ctime: '2019-07-11 17:30:12'
      },
      {
        id: 50,
        pid: 2,
        city_code: '101220901',
        city_name: '亳州',
        post_code: '236800',
        area_code: '0558',
        ctime: '2019-07-11 17:30:12'
      },
      {
        id: 52,
        pid: 3,
        city_code: '101230101',
        city_name: '福州',
        post_code: '350000',
        area_code: '0591',
        ctime: '2019-07-11 17:30:12'
      },
      {
        id: 53,
        pid: 3,
        city_code: '101230701',
        city_name: '龙岩',
        post_code: '364000',
        area_code: '0597',
        ctime: '2019-07-11 17:30:12'
      },
      {
        id: 54,
        pid: 3,
        city_code: '101230901',
        city_name: '南平',
        post_code: '353000',
        area_code: '0599',
        ctime: '2019-07-11 17:30:12'
      },
      {
        id: 55,
        pid: 3,
        city_code: '101230301',
        city_name: '宁德',
        post_code: '352000',
        area_code: '0593',
        ctime: '2019-07-11 17:30:13'
      },
      {
        id: 56,
        pid: 3,
        city_code: '101230401',
        city_name: '莆田',
        post_code: '351100',
        area_code: '0594',
        ctime: '2019-07-11 17:30:13'
      },
      {
        id: 57,
        pid: 3,
        city_code: '101230501',
        city_name: '泉州',
        post_code: '362000',
        area_code: '0595',
        ctime: '2019-07-11 17:30:13'
      },
      {
        id: 58,
        pid: 3,
        city_code: '101230801',
        city_name: '三明',
        post_code: '365000',
        area_code: '0598',
        ctime: '2019-07-11 17:30:13'
      },
      {
        id: 59,
        pid: 3,
        city_code: '101230201',
        city_name: '厦门',
        post_code: '361000',
        area_code: '0592',
        ctime: '2019-07-11 17:30:13'
      },
      {
        id: 60,
        pid: 3,
        city_code: '101230601',
        city_name: '漳州',
        post_code: '363000',
        area_code: '0596',
        ctime: '2019-07-11 17:30:14'
      },
      {
        id: 61,
        pid: 4,
        city_code: '101160101',
        city_name: '兰州',
        post_code: '730000',
        area_code: '0931',
        ctime: '2019-07-11 17:30:14'
      },
      {
        id: 62,
        pid: 4,
        city_code: '101161301',
        city_name: '白银市',
        post_code: '730900',
        area_code: '0943',
        ctime: '2019-07-11 17:30:14'
      },
      {
        id: 63,
        pid: 4,
        city_code: '101160201',
        city_name: '定西',
        post_code: '743000',
        area_code: '0932',
        ctime: '2019-07-11 17:30:14'
      },
      {
        id: 65,
        pid: 4,
        city_code: '101161401',
        city_name: '嘉峪关',
        post_code: '735100',
        area_code: '0937',
        ctime: '2019-07-11 17:30:15'
      },
      {
        id: 66,
        pid: 4,
        city_code: '101160601',
        city_name: '金昌',
        post_code: '737100',
        area_code: '0935',
        ctime: '2019-07-11 17:30:15'
      },
      {
        id: 67,
        pid: 4,
        city_code: '101160801',
        city_name: '酒泉',
        post_code: '735000',
        area_code: '0937',
        ctime: '2019-07-11 17:30:15'
      },
      {
        id: 68,
        pid: 4,
        city_code: '101161101',
        city_name: '临夏市',
        post_code: '731100',
        area_code: '0930',
        ctime: '2019-07-11 17:30:15'
      },
      {
        id: 69,
        pid: 4,
        city_code: '101161010',
        city_name: '陇南市',
        post_code: '746000',
        area_code: '0939',
        ctime: '2019-07-11 17:03:41'
      },
      {
        id: 70,
        pid: 4,
        city_code: '101160301',
        city_name: '平凉',
        post_code: '744000',
        area_code: '0933',
        ctime: '2019-07-11 17:30:16'
      },
      {
        id: 71,
        pid: 4,
        city_code: '101160401',
        city_name: '庆阳',
        post_code: '745000',
        area_code: '0934',
        ctime: '2019-07-11 17:30:16'
      },
      {
        id: 72,
        pid: 4,
        city_code: '101160901',
        city_name: '天水',
        post_code: '741000',
        area_code: '0938',
        ctime: '2019-07-11 17:30:17'
      },
      {
        id: 73,
        pid: 4,
        city_code: '101160501',
        city_name: '武威',
        post_code: '733000',
        area_code: '0935',
        ctime: '2019-07-11 17:30:18'
      },
      {
        id: 74,
        pid: 4,
        city_code: '101160701',
        city_name: '张掖',
        post_code: '734000',
        area_code: '0936',
        ctime: '2019-07-11 17:30:19'
      },
      {
        id: 75,
        pid: 5,
        city_code: '101280101',
        city_name: '广州',
        post_code: '510000',
        area_code: '020',
        ctime: '2019-07-11 17:30:21'
      },
      {
        id: 76,
        pid: 5,
        city_code: '101280601',
        city_name: '深圳',
        post_code: '518000',
        area_code: '0755',
        ctime: '2019-07-11 17:30:21'
      },
      {
        id: 77,
        pid: 5,
        city_code: '101281501',
        city_name: '潮州',
        post_code: '521000',
        area_code: '0768',
        ctime: '2019-07-11 17:30:21'
      },
      {
        id: 78,
        pid: 5,
        city_code: '101281601',
        city_name: '东莞',
        post_code: '523000',
        area_code: '0769',
        ctime: '2019-07-11 17:30:22'
      },
      {
        id: 79,
        pid: 5,
        city_code: '101280800',
        city_name: '佛山',
        post_code: '528000',
        area_code: '0757',
        ctime: '2019-07-11 17:30:22'
      },
      {
        id: 80,
        pid: 5,
        city_code: '101281201',
        city_name: '河源',
        post_code: '517000',
        area_code: '0762',
        ctime: '2019-07-11 17:30:22'
      },
      {
        id: 81,
        pid: 5,
        city_code: '101280301',
        city_name: '惠州',
        post_code: '516000',
        area_code: '0752',
        ctime: '2019-07-11 17:30:23'
      },
      {
        id: 82,
        pid: 5,
        city_code: '101281101',
        city_name: '江门',
        post_code: '529000',
        area_code: '0750',
        ctime: '2019-07-11 17:30:25'
      },
      {
        id: 83,
        pid: 5,
        city_code: '101281901',
        city_name: '揭阳',
        post_code: '522000',
        area_code: '0663',
        ctime: '2019-07-11 17:30:26'
      },
      {
        id: 84,
        pid: 5,
        city_code: '101282001',
        city_name: '茂名',
        post_code: '525000',
        area_code: '0668',
        ctime: '2019-07-11 17:30:26'
      },
      {
        id: 85,
        pid: 5,
        city_code: '101280401',
        city_name: '梅州',
        post_code: '514021',
        area_code: '0753',
        ctime: '2019-07-11 17:30:27'
      },
      {
        id: 86,
        pid: 5,
        city_code: '101281301',
        city_name: '清远',
        post_code: '511500',
        area_code: '0763',
        ctime: '2019-07-11 17:30:28'
      },
      {
        id: 87,
        pid: 5,
        city_code: '101280501',
        city_name: '汕头',
        post_code: '515000',
        area_code: '0754',
        ctime: '2019-07-11 17:30:28'
      },
      {
        id: 88,
        pid: 5,
        city_code: '101282101',
        city_name: '汕尾',
        post_code: '516600',
        area_code: '0660',
        ctime: '2019-07-11 17:30:29'
      },
      {
        id: 89,
        pid: 5,
        city_code: '101280201',
        city_name: '韶关',
        post_code: '512000',
        area_code: '0751',
        ctime: '2019-07-11 17:30:29'
      },
      {
        id: 90,
        pid: 5,
        city_code: '101281801',
        city_name: '阳江',
        post_code: '529500',
        area_code: '0662',
        ctime: '2019-07-11 17:30:30'
      },
      {
        id: 91,
        pid: 5,
        city_code: '101281401',
        city_name: '云浮',
        post_code: '527300',
        area_code: '0766',
        ctime: '2019-07-11 17:30:30'
      },
      {
        id: 92,
        pid: 5,
        city_code: '101281001',
        city_name: '湛江',
        post_code: '524000',
        area_code: '0759',
        ctime: '2019-07-11 17:30:30'
      },
      {
        id: 93,
        pid: 5,
        city_code: '101280901',
        city_name: '肇庆',
        post_code: '526000',
        area_code: '0758',
        ctime: '2019-07-11 17:30:30'
      },
      {
        id: 94,
        pid: 5,
        city_code: '101281701',
        city_name: '中山市',
        post_code: '528400',
        area_code: '0760',
        ctime: '2019-07-11 21:23:58'
      },
      {
        id: 95,
        pid: 5,
        city_code: '101280701',
        city_name: '珠海',
        post_code: '519000',
        area_code: '0756',
        ctime: '2019-07-11 17:30:32'
      },
      {
        id: 96,
        pid: 6,
        city_code: '101300101',
        city_name: '南宁',
        post_code: '530000',
        area_code: '0771',
        ctime: '2019-07-11 17:30:33'
      },
      {
        id: 97,
        pid: 6,
        city_code: '101300501',
        city_name: '桂林',
        post_code: '541000',
        area_code: '0773',
        ctime: '2019-07-11 17:30:34'
      },
      {
        id: 98,
        pid: 6,
        city_code: '101301001',
        city_name: '百色',
        post_code: '533000',
        area_code: '0776',
        ctime: '2019-07-11 17:30:35'
      },
      {
        id: 99,
        pid: 6,
        city_code: '101301301',
        city_name: '北海',
        post_code: '536000',
        area_code: '0779',
        ctime: '2019-07-11 17:30:37'
      },
      {
        id: 100,
        pid: 6,
        city_code: '101300201',
        city_name: '崇左',
        post_code: '532200',
        area_code: '0771',
        ctime: '2019-07-11 17:30:37'
      },
      {
        id: 101,
        pid: 6,
        city_code: '101301401',
        city_name: '防城港',
        post_code: '538000',
        area_code: '0770',
        ctime: '2019-07-11 17:30:37'
      },
      {
        id: 102,
        pid: 6,
        city_code: '101300801',
        city_name: '贵港',
        post_code: '537100',
        area_code: '0775',
        ctime: '2019-07-11 17:30:38'
      },
      {
        id: 103,
        pid: 6,
        city_code: '101301201',
        city_name: '河池',
        post_code: '547000',
        area_code: '0778',
        ctime: '2019-07-11 17:30:39'
      },
      {
        id: 104,
        pid: 6,
        city_code: '101300701',
        city_name: '贺州',
        post_code: '542800',
        area_code: '0774',
        ctime: '2019-07-11 17:30:41'
      },
      {
        id: 105,
        pid: 6,
        city_code: '101300401',
        city_name: '来宾',
        post_code: '546100',
        area_code: '0772',
        ctime: '2019-07-11 17:30:41'
      },
      {
        id: 106,
        pid: 6,
        city_code: '101300301',
        city_name: '柳州',
        post_code: '545000',
        area_code: '0772',
        ctime: '2019-07-11 17:30:41'
      },
      {
        id: 107,
        pid: 6,
        city_code: '101301101',
        city_name: '钦州',
        post_code: '535000',
        area_code: '0777',
        ctime: '2019-07-11 17:30:42'
      },
      {
        id: 108,
        pid: 6,
        city_code: '101300601',
        city_name: '梧州',
        post_code: '543000',
        area_code: '0774',
        ctime: '2019-07-11 17:30:43'
      },
      {
        id: 109,
        pid: 6,
        city_code: '101300901',
        city_name: '玉林',
        post_code: '537000',
        area_code: '0775',
        ctime: '2019-07-11 17:30:43'
      },
      {
        id: 110,
        pid: 7,
        city_code: '101260101',
        city_name: '贵阳',
        post_code: '550000',
        area_code: '0851',
        ctime: '2019-07-11 17:30:45'
      },
      {
        id: 111,
        pid: 7,
        city_code: '101260301',
        city_name: '安顺',
        post_code: '561000',
        area_code: '0851',
        ctime: '2019-07-11 17:30:45'
      },
      {
        id: 112,
        pid: 7,
        city_code: '101260701',
        city_name: '毕节',
        post_code: '551700',
        area_code: '0857',
        ctime: '2019-07-11 17:30:45'
      },
      {
        id: 113,
        pid: 7,
        city_code: '101260803',
        city_name: '六盘水',
        post_code: '553000',
        area_code: '0858',
        ctime: '2019-07-11 17:30:46'
      },
      {
        id: 114,
        pid: 7,
        city_code: '101260506',
        city_name: '黔东南',
        post_code: '556000',
        area_code: '0855',
        ctime: '2019-07-11 17:03:42'
      },
      {
        id: 115,
        pid: 7,
        city_code: '101260413',
        city_name: '黔南',
        post_code: '558000',
        area_code: '0854',
        ctime: '2019-07-11 17:03:44'
      },
      {
        id: 116,
        pid: 7,
        city_code: '101260906',
        city_name: '黔西南',
        post_code: '562400',
        area_code: '0859',
        ctime: '2019-07-11 17:03:45'
      },
      {
        id: 117,
        pid: 7,
        city_code: '101260601',
        city_name: '铜仁市',
        post_code: '554300',
        area_code: '0856',
        ctime: '2019-07-11 17:30:46'
      },
      {
        id: 118,
        pid: 7,
        city_code: '101260201',
        city_name: '遵义',
        post_code: '563100',
        area_code: '0851',
        ctime: '2019-07-11 17:30:46'
      },
      {
        id: 119,
        pid: 8,
        city_code: '101310101',
        city_name: '海口',
        post_code: '570100',
        area_code: '0898',
        ctime: '2019-07-11 17:30:46'
      },
      {
        id: 120,
        pid: 8,
        city_code: '101310201',
        city_name: '三亚',
        post_code: '572000',
        area_code: '0898',
        ctime: '2019-07-11 17:30:46'
      },
      {
        id: 121,
        pid: 8,
        city_code: '101310207',
        city_name: '白沙县',
        post_code: '572800',
        area_code: '0898',
        ctime: '2019-07-11 17:03:46'
      },
      {
        id: 122,
        pid: 8,
        city_code: '101310214',
        city_name: '保亭县',
        post_code: '572300',
        area_code: '0898',
        ctime: '2019-07-11 17:03:47'
      },
      {
        id: 123,
        pid: 8,
        city_code: '101310206',
        city_name: '昌江县',
        post_code: '572700',
        area_code: '0898',
        ctime: '2019-07-11 17:03:48'
      },
      {
        id: 124,
        pid: 8,
        city_code: '101310204',
        city_name: '澄迈县',
        post_code: '571900',
        area_code: '0898',
        ctime: '2019-07-11 17:03:49'
      },
      {
        id: 125,
        pid: 8,
        city_code: '101310209',
        city_name: '定安县',
        post_code: '571200',
        area_code: '0898',
        ctime: '2019-07-11 17:03:51'
      },
      {
        id: 126,
        pid: 8,
        city_code: '101310202',
        city_name: '东方',
        post_code: '572600',
        area_code: '0898',
        ctime: '2019-07-11 17:30:47'
      },
      {
        id: 127,
        pid: 8,
        city_code: '101310221',
        city_name: '乐东县',
        post_code: '572500',
        area_code: '0898',
        ctime: '2019-07-11 17:03:52'
      },
      {
        id: 128,
        pid: 8,
        city_code: '101310203',
        city_name: '临高县',
        post_code: '571800',
        area_code: '0898',
        ctime: '2019-07-11 17:03:53'
      },
      {
        id: 129,
        pid: 8,
        city_code: '101310216',
        city_name: '陵水县',
        post_code: '572400',
        area_code: '0898',
        ctime: '2019-07-11 17:03:55'
      },
      {
        id: 130,
        pid: 8,
        city_code: '101310211',
        city_name: '琼海',
        post_code: '571400',
        area_code: '0898',
        ctime: '2019-07-11 17:30:47'
      },
      {
        id: 131,
        pid: 8,
        city_code: '101310208',
        city_name: '琼中',
        post_code: '572900',
        area_code: '0898',
        ctime: '2019-07-11 17:30:47'
      },
      {
        id: 132,
        pid: 8,
        city_code: '101310210',
        city_name: '屯昌县',
        post_code: '571600',
        area_code: '0898',
        ctime: '2019-07-11 17:03:56'
      },
      {
        id: 133,
        pid: 8,
        city_code: '101310215',
        city_name: '万宁',
        post_code: '571500',
        area_code: '0898',
        ctime: '2019-07-11 17:30:47'
      },
      {
        id: 134,
        pid: 8,
        city_code: '101310212',
        city_name: '文昌',
        post_code: '571300',
        area_code: '0898',
        ctime: '2019-07-11 17:30:48'
      },
      {
        id: 135,
        pid: 8,
        city_code: '101310222',
        city_name: '五指山',
        post_code: '572200',
        area_code: '0898',
        ctime: '2019-07-11 17:30:48'
      },
      {
        id: 136,
        pid: 8,
        city_code: '101310205',
        city_name: '儋州',
        post_code: '571700',
        area_code: '0898',
        ctime: '2019-07-11 17:30:48'
      },
      {
        id: 137,
        pid: 9,
        city_code: '101090101',
        city_name: '石家庄',
        post_code: '050000',
        area_code: '0311',
        ctime: '2019-07-11 17:30:48'
      },
      {
        id: 138,
        pid: 9,
        city_code: '101090201',
        city_name: '保定',
        post_code: '071000',
        area_code: '0312',
        ctime: '2019-07-11 17:30:49'
      },
      {
        id: 139,
        pid: 9,
        city_code: '101090701',
        city_name: '沧州',
        post_code: '061000',
        area_code: '0317',
        ctime: '2019-07-11 17:30:49'
      },
      {
        id: 140,
        pid: 9,
        city_code: '101090402',
        city_name: '承德市',
        post_code: '067000',
        area_code: '0314',
        ctime: '2019-07-11 21:24:00'
      },
      {
        id: 141,
        pid: 9,
        city_code: '101091001',
        city_name: '邯郸市',
        post_code: '056000',
        area_code: '0310',
        ctime: '2019-07-11 17:30:49'
      },
      {
        id: 142,
        pid: 9,
        city_code: '101090801',
        city_name: '衡水',
        post_code: '053000',
        area_code: '0318',
        ctime: '2019-07-11 17:30:49'
      },
      {
        id: 143,
        pid: 9,
        city_code: '101090601',
        city_name: '廊坊',
        post_code: '065000',
        area_code: '0316',
        ctime: '2019-07-11 17:30:51'
      },
      {
        id: 144,
        pid: 9,
        city_code: '101091101',
        city_name: '秦皇岛',
        post_code: '066000',
        area_code: '0335',
        ctime: '2019-07-11 17:30:51'
      },
      {
        id: 145,
        pid: 9,
        city_code: '101090501',
        city_name: '唐山',
        post_code: '063000',
        area_code: '0315',
        ctime: '2019-07-11 17:30:51'
      },
      {
        id: 146,
        pid: 9,
        city_code: '101090901',
        city_name: '邢台市',
        post_code: '054000',
        area_code: '0319',
        ctime: '2019-07-11 17:30:52'
      },
      {
        id: 147,
        pid: 9,
        city_code: '101090301',
        city_name: '张家口',
        post_code: '075000',
        area_code: '0313',
        ctime: '2019-07-11 17:30:52'
      },
      {
        id: 148,
        pid: 10,
        city_code: '101180101',
        city_name: '郑州',
        post_code: '450000',
        area_code: '0371',
        ctime: '2019-07-11 17:30:53'
      },
      {
        id: 149,
        pid: 10,
        city_code: '101180901',
        city_name: '洛阳',
        post_code: '471000',
        area_code: '0379',
        ctime: '2019-07-11 17:30:53'
      },
      {
        id: 150,
        pid: 10,
        city_code: '101180801',
        city_name: '开封市',
        post_code: '475000',
        area_code: '(+86)0371',
        ctime: '2019-07-11 17:30:54'
      },
      {
        id: 151,
        pid: 10,
        city_code: '101180201',
        city_name: '安阳市',
        post_code: '455000',
        area_code: '0372',
        ctime: '2019-07-11 17:30:54'
      },
      {
        id: 152,
        pid: 10,
        city_code: '101181201',
        city_name: '鹤壁',
        post_code: '458000',
        area_code: '0392',
        ctime: '2019-07-11 17:30:55'
      },
      {
        id: 153,
        pid: 10,
        city_code: '101181801',
        city_name: '济源市',
        post_code: '459000（或454650）',
        area_code: '0391',
        ctime: '2019-07-11 17:30:55'
      },
      {
        id: 154,
        pid: 10,
        city_code: '101181101',
        city_name: '焦作',
        post_code: '454150',
        area_code: '0391',
        ctime: '2019-07-11 17:30:56'
      },
      {
        id: 155,
        pid: 10,
        city_code: '101180701',
        city_name: '南阳',
        post_code: '473000',
        area_code: '0377',
        ctime: '2019-07-11 17:30:56'
      },
      {
        id: 156,
        pid: 10,
        city_code: '101180501',
        city_name: '平顶山',
        post_code: '467000',
        area_code: '0375',
        ctime: '2019-07-11 17:30:57'
      },
      {
        id: 157,
        pid: 10,
        city_code: '101181701',
        city_name: '三门峡',
        post_code: '472000',
        area_code: '0398',
        ctime: '2019-07-11 17:30:58'
      },
      {
        id: 158,
        pid: 10,
        city_code: '101181001',
        city_name: '商丘',
        post_code: '476000',
        area_code: '0370',
        ctime: '2019-07-11 17:30:58'
      },
      {
        id: 159,
        pid: 10,
        city_code: '101180301',
        city_name: '新乡市',
        post_code: '453000',
        area_code: '0373',
        ctime: '2019-07-11 17:30:59'
      },
      {
        id: 160,
        pid: 10,
        city_code: '101180601',
        city_name: '信阳',
        post_code: '464000',
        area_code: '0376',
        ctime: '2019-07-11 17:31:00'
      },
      {
        id: 161,
        pid: 10,
        city_code: '101180401',
        city_name: '许昌市',
        post_code: '461000',
        area_code: '0374',
        ctime: '2019-07-11 17:31:00'
      },
      {
        id: 162,
        pid: 10,
        city_code: '101181401',
        city_name: '周口',
        post_code: '466000',
        area_code: '0394',
        ctime: '2019-07-11 17:31:01'
      },
      {
        id: 163,
        pid: 10,
        city_code: '101181601',
        city_name: '驻马店',
        post_code: '463000',
        area_code: '0396',
        ctime: '2019-07-11 17:31:01'
      },
      {
        id: 164,
        pid: 10,
        city_code: '101181501',
        city_name: '漯河',
        post_code: '462000',
        area_code: '0395',
        ctime: '2019-07-11 17:31:02'
      },
      {
        id: 165,
        pid: 10,
        city_code: '101181301',
        city_name: '濮阳市',
        post_code: '457000',
        area_code: '0393',
        ctime: '2019-07-11 17:31:04'
      },
      {
        id: 166,
        pid: 11,
        city_code: '101050101',
        city_name: '哈尔滨',
        post_code: '150000',
        area_code: '0451',
        ctime: '2019-07-11 17:31:04'
      },
      {
        id: 167,
        pid: 11,
        city_code: '101050901',
        city_name: '大庆',
        post_code: '163000',
        area_code: '0459',
        ctime: '2019-07-11 17:31:04'
      },
      {
        id: 168,
        pid: 11,
        city_code: '101050701',
        city_name: '大兴安岭',
        post_code: '165000',
        area_code: '0457',
        ctime: '2019-07-11 17:03:57'
      },
      {
        id: 169,
        pid: 11,
        city_code: '101051201',
        city_name: '鹤岗',
        post_code: '154100',
        area_code: '0468',
        ctime: '2019-07-11 17:31:04'
      },
      {
        id: 170,
        pid: 11,
        city_code: '101050601',
        city_name: '黑河',
        post_code: '164300',
        area_code: '0456',
        ctime: '2019-07-11 17:31:05'
      },
      {
        id: 171,
        pid: 11,
        city_code: '101051101',
        city_name: '鸡西',
        post_code: '158100',
        area_code: '0467',
        ctime: '2019-07-11 17:31:05'
      },
      {
        id: 172,
        pid: 11,
        city_code: '101050401',
        city_name: '佳木斯',
        post_code: '154000',
        area_code: '0454',
        ctime: '2019-07-11 17:31:05'
      },
      {
        id: 173,
        pid: 11,
        city_code: '101050301',
        city_name: '牡丹江',
        post_code: '157000',
        area_code: '0453',
        ctime: '2019-07-11 17:31:06'
      },
      {
        id: 174,
        pid: 11,
        city_code: '101051002',
        city_name: '七台河',
        post_code: '154600',
        area_code: '0464',
        ctime: '2019-07-11 17:31:07'
      },
      {
        id: 175,
        pid: 11,
        city_code: '101050201',
        city_name: '齐齐哈尔',
        post_code: '161000',
        area_code: '0452',
        ctime: '2019-07-11 17:31:07'
      },
      {
        id: 176,
        pid: 11,
        city_code: '101051301',
        city_name: '双鸭山',
        post_code: '155100',
        area_code: '0469',
        ctime: '2019-07-11 17:31:07'
      },
      {
        id: 177,
        pid: 11,
        city_code: '101050501',
        city_name: '绥化',
        post_code: '152000',
        area_code: '0455',
        ctime: '2019-07-11 17:31:07'
      },
      {
        id: 178,
        pid: 11,
        city_code: '101050801',
        city_name: '伊春市',
        post_code: '153000',
        area_code: '0458',
        ctime: '2019-07-11 17:31:07'
      },
      {
        id: 179,
        pid: 12,
        city_code: '101200101',
        city_name: '武汉',
        post_code: '430000',
        area_code: '027',
        ctime: '2019-07-11 17:31:08'
      },
      {
        id: 180,
        pid: 12,
        city_code: '101201601',
        city_name: '仙桃',
        post_code: '433000',
        area_code: '0728',
        ctime: '2019-07-11 17:31:08'
      },
      {
        id: 181,
        pid: 12,
        city_code: '101200301',
        city_name: '鄂州',
        post_code: '436000',
        area_code: '0711',
        ctime: '2019-07-11 17:31:08'
      },
      {
        id: 182,
        pid: 12,
        city_code: '101200501',
        city_name: '黄冈',
        post_code: '438000',
        area_code: '0713',
        ctime: '2019-07-11 17:31:08'
      },
      {
        id: 183,
        pid: 12,
        city_code: '101200601',
        city_name: '黄石',
        post_code: '435000',
        area_code: '0714',
        ctime: '2019-07-11 17:31:09'
      },
      {
        id: 184,
        pid: 12,
        city_code: '101201401',
        city_name: '荆门',
        post_code: '448000',
        area_code: '0724',
        ctime: '2019-07-11 17:31:09'
      },
      {
        id: 185,
        pid: 12,
        city_code: '101200801',
        city_name: '荆州市',
        post_code: '434000',
        area_code: '0716',
        ctime: '2019-07-11 17:31:09'
      },
      {
        id: 186,
        pid: 12,
        city_code: '101201701',
        city_name: '潜江市',
        post_code: '433100',
        area_code: '0728',
        ctime: '2019-07-11 17:31:09'
      },
      {
        id: 187,
        pid: 12,
        city_code: '101201201',
        city_name: '神农架',
        post_code: '442400',
        area_code: '0719',
        ctime: '2019-07-11 21:24:00'
      },
      {
        id: 188,
        pid: 12,
        city_code: '101201101',
        city_name: '十堰',
        post_code: '442000',
        area_code: '0719',
        ctime: '2019-07-11 17:31:11'
      },
      {
        id: 189,
        pid: 12,
        city_code: '101201301',
        city_name: '随州',
        post_code: '441300',
        area_code: '0722',
        ctime: '2019-07-11 17:31:11'
      },
      {
        id: 190,
        pid: 12,
        city_code: '101201501',
        city_name: '天门市',
        post_code: '431700',
        area_code: '0728',
        ctime: '2019-07-11 17:31:12'
      },
      {
        id: 191,
        pid: 12,
        city_code: '101200701',
        city_name: '咸宁',
        post_code: '437000',
        area_code: '0715',
        ctime: '2019-07-11 17:31:13'
      },
      {
        id: 192,
        pid: 12,
        city_code: '101200201',
        city_name: '襄阳',
        post_code: '441000',
        area_code: '0710',
        ctime: '2019-07-11 17:31:13'
      },
      {
        id: 193,
        pid: 12,
        city_code: '101200401',
        city_name: '孝感',
        post_code: '432000',
        area_code: '0712',
        ctime: '2019-07-11 17:31:13'
      },
      {
        id: 194,
        pid: 12,
        city_code: '101200901',
        city_name: '宜昌',
        post_code: '443000',
        area_code: '0717',
        ctime: '2019-07-11 17:31:13'
      },
      {
        id: 195,
        pid: 12,
        city_code: '101201001',
        city_name: '恩施市',
        post_code: '445000',
        area_code: '0718',
        ctime: '2019-07-11 17:03:58'
      },
      {
        id: 196,
        pid: 13,
        city_code: '101250101',
        city_name: '长沙市',
        post_code: '410000',
        area_code: '0731',
        ctime: '2019-07-11 21:24:01'
      },
      {
        id: 197,
        pid: 13,
        city_code: '101251101',
        city_name: '张家界',
        post_code: '427000',
        area_code: '0744',
        ctime: '2019-07-11 17:31:14'
      },
      {
        id: 198,
        pid: 13,
        city_code: '101250601',
        city_name: '常德',
        post_code: '415000',
        area_code: '0736',
        ctime: '2019-07-11 17:31:14'
      },
      {
        id: 199,
        pid: 13,
        city_code: '101250501',
        city_name: '郴州',
        post_code: '423000',
        area_code: '0735',
        ctime: '2019-07-11 17:31:15'
      },
      {
        id: 200,
        pid: 13,
        city_code: '101250401',
        city_name: '衡阳市',
        post_code: '421000',
        area_code: '0734',
        ctime: '2019-07-11 21:24:01'
      },
      {
        id: 201,
        pid: 13,
        city_code: '101251201',
        city_name: '怀化',
        post_code: '418000',
        area_code: '0745',
        ctime: '2019-07-11 17:31:16'
      },
      {
        id: 202,
        pid: 13,
        city_code: '101250801',
        city_name: '娄底',
        post_code: '417000',
        area_code: '0738',
        ctime: '2019-07-11 17:31:17'
      },
      {
        id: 203,
        pid: 13,
        city_code: '101250901',
        city_name: '邵阳市',
        post_code: '422000',
        area_code: '0739',
        ctime: '2019-07-11 21:24:01'
      },
      {
        id: 204,
        pid: 13,
        city_code: '101250201',
        city_name: '湘潭市',
        post_code: '411100',
        area_code: '0731',
        ctime: '2019-07-11 17:31:17'
      },
      {
        id: 205,
        pid: 13,
        city_code: '101251509',
        city_name: '湘西',
        post_code: '416000',
        area_code: '0743',
        ctime: '2019-07-11 17:04:00'
      },
      {
        id: 206,
        pid: 13,
        city_code: '101250700',
        city_name: '益阳',
        post_code: '413000',
        area_code: '0737',
        ctime: '2019-07-11 17:31:17'
      },
      {
        id: 207,
        pid: 13,
        city_code: '101251401',
        city_name: '永州',
        post_code: '425000',
        area_code: '0746',
        ctime: '2019-07-11 17:31:17'
      },
      {
        id: 208,
        pid: 13,
        city_code: '101251001',
        city_name: '岳阳市',
        post_code: '414000',
        area_code: '0730',
        ctime: '2019-07-11 21:24:02'
      },
      {
        id: 209,
        pid: 13,
        city_code: '101250301',
        city_name: '株洲',
        post_code: '412000',
        area_code: '0731',
        ctime: '2019-07-11 17:31:18'
      },
      {
        id: 210,
        pid: 14,
        city_code: '101060101',
        city_name: '长春',
        post_code: '130000',
        area_code: '0431',
        ctime: '2019-07-11 17:31:19'
      },
      {
        id: 211,
        pid: 14,
        city_code: '101060201',
        city_name: '吉林市',
        post_code: '132000',
        area_code: '0432',
        ctime: '2019-07-11 17:04:01'
      },
      {
        id: 212,
        pid: 14,
        city_code: '101060601',
        city_name: '白城',
        post_code: '137000',
        area_code: '0436',
        ctime: '2019-07-11 17:31:20'
      },
      {
        id: 213,
        pid: 14,
        city_code: '101060901',
        city_name: '白山',
        post_code: '134300',
        area_code: '0439',
        ctime: '2019-07-11 17:31:20'
      },
      {
        id: 214,
        pid: 14,
        city_code: '101060701',
        city_name: '辽源',
        post_code: '136200',
        area_code: '0437',
        ctime: '2019-07-11 17:31:21'
      },
      {
        id: 215,
        pid: 14,
        city_code: '101060401',
        city_name: '四平',
        post_code: '136000',
        area_code: '0434',
        ctime: '2019-07-11 17:31:21'
      },
      {
        id: 216,
        pid: 14,
        city_code: '101060801',
        city_name: '松原',
        post_code: '138000',
        area_code: '0438',
        ctime: '2019-07-11 17:31:21'
      },
      {
        id: 217,
        pid: 14,
        city_code: '101060501',
        city_name: '通化市',
        post_code: '134000',
        area_code: '0435',
        ctime: '2019-07-11 21:24:02'
      },
      {
        id: 218,
        pid: 14,
        city_code: '101060306',
        city_name: '延边',
        post_code: '133000',
        area_code: '0433',
        ctime: '2019-07-11 17:04:02'
      },
      {
        id: 219,
        pid: 15,
        city_code: '101190101',
        city_name: '南京',
        post_code: '210000',
        area_code: '025',
        ctime: '2019-07-11 17:31:22'
      },
      {
        id: 220,
        pid: 15,
        city_code: '101190401',
        city_name: '苏州',
        post_code: '215000',
        area_code: '0512',
        ctime: '2019-07-11 17:31:23'
      },
      {
        id: 221,
        pid: 15,
        city_code: '101190201',
        city_name: '无锡',
        post_code: '214000',
        area_code: '0510',
        ctime: '2019-07-11 17:31:24'
      },
      {
        id: 222,
        pid: 15,
        city_code: '101191101',
        city_name: '常州',
        post_code: '213000',
        area_code: '0519',
        ctime: '2019-07-11 17:31:25'
      },
      {
        id: 223,
        pid: 15,
        city_code: '101190901',
        city_name: '淮安市',
        post_code: '223001',
        area_code: '0517',
        ctime: '2019-07-11 21:24:02'
      },
      {
        id: 224,
        pid: 15,
        city_code: '101191001',
        city_name: '连云港',
        post_code: '222002',
        area_code: '国际:518；国内:0518',
        ctime: '2019-07-11 17:31:27'
      },
      {
        id: 225,
        pid: 15,
        city_code: '101190501',
        city_name: '南通',
        post_code: '226000',
        area_code: '0513',
        ctime: '2019-07-11 17:31:28'
      },
      {
        id: 226,
        pid: 15,
        city_code: '101191301',
        city_name: '宿迁',
        post_code: '223800',
        area_code: '0527',
        ctime: '2019-07-11 17:31:29'
      },
      {
        id: 227,
        pid: 15,
        city_code: '101191201',
        city_name: '泰州',
        post_code: '225300',
        area_code: '0523',
        ctime: '2019-07-11 17:31:30'
      },
      {
        id: 228,
        pid: 15,
        city_code: '101190801',
        city_name: '徐州',
        post_code: '221000',
        area_code: '0516',
        ctime: '2019-07-11 17:31:30'
      },
      {
        id: 229,
        pid: 15,
        city_code: '101190701',
        city_name: '盐城',
        post_code: '224000',
        area_code: '0515',
        ctime: '2019-07-11 17:31:31'
      },
      {
        id: 230,
        pid: 15,
        city_code: '101190601',
        city_name: '扬州',
        post_code: '225000',
        area_code: '0514',
        ctime: '2019-07-11 17:31:32'
      },
      {
        id: 231,
        pid: 15,
        city_code: '101190301',
        city_name: '镇江',
        post_code: '212000',
        area_code: '0511',
        ctime: '2019-07-11 17:31:32'
      },
      {
        id: 232,
        pid: 16,
        city_code: '101240101',
        city_name: '南昌市',
        post_code: '330000',
        area_code: '0791',
        ctime: '2019-07-11 21:24:02'
      },
      {
        id: 233,
        pid: 16,
        city_code: '101240401',
        city_name: '抚州',
        post_code: '344000',
        area_code: '0794',
        ctime: '2019-07-11 17:31:34'
      },
      {
        id: 234,
        pid: 16,
        city_code: '101240701',
        city_name: '赣州',
        post_code: '341000',
        area_code: '0797',
        ctime: '2019-07-11 17:31:34'
      },
      {
        id: 235,
        pid: 16,
        city_code: '101240601',
        city_name: '吉安市',
        post_code: '343000',
        area_code: '0796',
        ctime: '2019-07-11 21:24:03'
      },
      {
        id: 236,
        pid: 16,
        city_code: '101240801',
        city_name: '景德镇',
        post_code: '333000',
        area_code: '0798',
        ctime: '2019-07-11 17:31:34'
      },
      {
        id: 237,
        pid: 16,
        city_code: '101240201',
        city_name: '九江市',
        post_code: '332000',
        area_code: '0792',
        ctime: '2019-07-11 17:31:35'
      },
      {
        id: 238,
        pid: 16,
        city_code: '101240901',
        city_name: '萍乡',
        post_code: '337000',
        area_code: '0799',
        ctime: '2019-07-11 17:31:36'
      },
      {
        id: 239,
        pid: 16,
        city_code: '101240301',
        city_name: '上饶市',
        post_code: '334000',
        area_code: '0793',
        ctime: '2019-07-11 21:24:03'
      },
      {
        id: 240,
        pid: 16,
        city_code: '101241001',
        city_name: '新余',
        post_code: '338000',
        area_code: '0790',
        ctime: '2019-07-11 17:31:36'
      },
      {
        id: 241,
        pid: 16,
        city_code: '101240501',
        city_name: '宜春',
        post_code: '336000',
        area_code: '0795',
        ctime: '2019-07-11 17:31:37'
      },
      {
        id: 242,
        pid: 16,
        city_code: '101241101',
        city_name: '鹰潭',
        post_code: '335000',
        area_code: '0701',
        ctime: '2019-07-11 17:31:38'
      },
      {
        id: 243,
        pid: 17,
        city_code: '101070101',
        city_name: '沈阳',
        post_code: '110000',
        area_code: '024',
        ctime: '2019-07-11 17:31:39'
      },
      {
        id: 244,
        pid: 17,
        city_code: '101070201',
        city_name: '大连市',
        post_code: '116000',
        area_code: '0411，+86-411',
        ctime: '2019-07-11 16:24:00'
      },
      {
        id: 245,
        pid: 17,
        city_code: '101070301',
        city_name: '鞍山市',
        post_code: '114000',
        area_code: '0412',
        ctime: '2019-07-11 16:24:00'
      },
      {
        id: 246,
        pid: 17,
        city_code: '101070501',
        city_name: '本溪市',
        post_code: '117000',
        area_code: '024',
        ctime: '2019-07-11 16:24:00'
      },
      {
        id: 247,
        pid: 17,
        city_code: '101071201',
        city_name: '朝阳市',
        post_code: '122000',
        area_code: '0421',
        ctime: '2019-07-11 16:24:00'
      },
      {
        id: 248,
        pid: 17,
        city_code: '101070601',
        city_name: '丹东',
        post_code: '118000',
        area_code: '0415，+86-415',
        ctime: '2019-07-11 17:31:41'
      },
      {
        id: 249,
        pid: 17,
        city_code: '101070401',
        city_name: '抚顺市',
        post_code: '113006',
        area_code: '024，+86-24',
        ctime: '2019-07-11 17:31:42'
      },
      {
        id: 250,
        pid: 17,
        city_code: '101070901',
        city_name: '阜新',
        post_code: '123000',
        area_code: '0418，+86-418',
        ctime: '2019-07-11 17:31:44'
      },
      {
        id: 251,
        pid: 17,
        city_code: '101071401',
        city_name: '葫芦岛',
        post_code: '125000',
        area_code: '0429',
        ctime: '2019-07-11 17:31:44'
      },
      {
        id: 252,
        pid: 17,
        city_code: '101070701',
        city_name: '锦州',
        post_code: '121000',
        area_code: '（+86）0416',
        ctime: '2019-07-11 17:31:45'
      },
      {
        id: 253,
        pid: 17,
        city_code: '101071001',
        city_name: '辽阳市',
        post_code: '111000',
        area_code: '0419',
        ctime: '2019-07-11 16:24:00'
      },
      {
        id: 254,
        pid: 17,
        city_code: '101071301',
        city_name: '盘锦',
        post_code: '124000',
        area_code: '0427',
        ctime: '2019-07-11 17:31:46'
      },
      {
        id: 255,
        pid: 17,
        city_code: '101071101',
        city_name: '铁岭市',
        post_code: '112000',
        area_code: '024，+86-24',
        ctime: '2019-07-11 17:31:46'
      },
      {
        id: 256,
        pid: 17,
        city_code: '101070801',
        city_name: '营口',
        post_code: '115000',
        area_code: '-417',
        ctime: '2019-07-11 17:31:46'
      },
      {
        id: 257,
        pid: 18,
        city_code: '101080101',
        city_name: '呼和浩特',
        post_code: '010000',
        area_code: '0471',
        ctime: '2019-07-11 17:31:47'
      },
      {
        id: 258,
        pid: 18,
        city_code: '101081213',
        city_name: '阿拉善盟',
        post_code: '750306',
        area_code: '0483',
        ctime: '2019-07-11 17:04:03'
      },
      {
        id: 259,
        pid: 18,
        city_code: '101080811',
        city_name: '巴彦淖尔',
        post_code: '015000',
        area_code: '0478',
        ctime: '2019-07-11 17:31:48'
      },
      {
        id: 260,
        pid: 18,
        city_code: '101080201',
        city_name: '包头',
        post_code: '014000',
        area_code: '0472',
        ctime: '2019-07-11 17:31:48'
      },
      {
        id: 261,
        pid: 18,
        city_code: '101080601',
        city_name: '赤峰',
        post_code: '024000',
        area_code: '0476',
        ctime: '2019-07-11 17:31:48'
      },
      {
        id: 262,
        pid: 18,
        city_code: '101080701',
        city_name: '鄂尔多斯',
        post_code: '017000',
        area_code: '0477',
        ctime: '2019-07-11 17:31:50'
      },
      {
        id: 263,
        pid: 18,
        city_code: '101081001',
        city_name: '呼伦贝尔市',
        post_code: '021000',
        area_code: '0470',
        ctime: '2019-07-11 17:31:50'
      },
      {
        id: 264,
        pid: 18,
        city_code: '101080501',
        city_name: '通辽',
        post_code: '028000',
        area_code: '0475',
        ctime: '2019-07-11 17:31:51'
      },
      {
        id: 265,
        pid: 18,
        city_code: '101080301',
        city_name: '乌海',
        post_code: '016000',
        area_code: '0473',
        ctime: '2019-07-11 17:31:52'
      },
      {
        id: 266,
        pid: 18,
        city_code: '101080405',
        city_name: '乌兰察布',
        post_code: '012000',
        area_code: '0474',
        ctime: '2019-07-11 17:31:53'
      },
      {
        id: 267,
        pid: 18,
        city_code: '101080902',
        city_name: '锡林郭勒',
        post_code: '026000',
        area_code: '0479',
        ctime: '2019-07-11 17:31:53'
      },
      {
        id: 268,
        pid: 18,
        city_code: '101081108',
        city_name: '兴安盟',
        post_code: '137400',
        area_code: '0482',
        ctime: '2019-07-11 17:04:05'
      },
      {
        id: 269,
        pid: 19,
        city_code: '101170101',
        city_name: '银川',
        post_code: '750000',
        area_code: '0951',
        ctime: '2019-07-11 17:31:53'
      },
      {
        id: 270,
        pid: 19,
        city_code: '101170401',
        city_name: '固原',
        post_code: '756000',
        area_code: '0954',
        ctime: '2019-07-11 17:31:53'
      },
      {
        id: 271,
        pid: 19,
        city_code: '101170201',
        city_name: '石嘴山',
        post_code: '753000',
        area_code: '0952',
        ctime: '2019-07-11 17:31:54'
      },
      {
        id: 272,
        pid: 19,
        city_code: '101170301',
        city_name: '吴忠',
        post_code: '751100',
        area_code: '0953',
        ctime: '2019-07-11 17:31:54'
      },
      {
        id: 273,
        pid: 19,
        city_code: '101170501',
        city_name: '中卫',
        post_code: '755000',
        area_code: '0955',
        ctime: '2019-07-11 17:31:54'
      },
      {
        id: 274,
        pid: 20,
        city_code: '101150101',
        city_name: '西宁',
        post_code: '810000',
        area_code: '0971',
        ctime: '2019-07-11 17:31:54'
      },
      {
        id: 275,
        pid: 20,
        city_code: '101150507',
        city_name: '果洛',
        post_code: '814000',
        area_code: '0975',
        ctime: '2019-07-11 17:04:06'
      },
      {
        id: 276,
        pid: 20,
        city_code: '101150804',
        city_name: '海北',
        post_code: '812200',
        area_code: '0970',
        ctime: '2019-07-11 17:04:07'
      },
      {
        id: 277,
        pid: 20,
        city_code: '101150207',
        city_name: '海东',
        post_code: '810699',
        area_code: '0972',
        ctime: '2019-07-11 17:31:54'
      },
      {
        id: 278,
        pid: 20,
        city_code: '101150401',
        city_name: '共和县',
        post_code: '813000',
        area_code: '0974',
        ctime: '2019-07-11 16:24:00'
      },
      {
        id: 279,
        pid: 20,
        city_code: '101150701',
        city_name: '德令哈市',
        post_code: '817000',
        area_code: '0977',
        ctime: '2019-07-11 16:24:00'
      },
      {
        id: 280,
        pid: 20,
        city_code: '101150305',
        city_name: '黄南',
        post_code: '811300',
        area_code: '0973',
        ctime: '2019-07-11 17:04:08'
      },
      {
        id: 281,
        pid: 20,
        city_code: '101150601',
        city_name: '玉树',
        post_code: '815000',
        area_code: '0976',
        ctime: '2019-07-11 17:04:10'
      },
      {
        id: 282,
        pid: 21,
        city_code: '101120101',
        city_name: '济南',
        post_code: '250000',
        area_code: '0531',
        ctime: '2019-07-11 17:31:56'
      },
      {
        id: 283,
        pid: 21,
        city_code: '101120201',
        city_name: '青岛',
        post_code: '266000',
        area_code: '0532',
        ctime: '2019-07-11 17:31:56'
      },
      {
        id: 284,
        pid: 21,
        city_code: '101121101',
        city_name: '滨州',
        post_code: '256600',
        area_code: '0543',
        ctime: '2019-07-11 17:31:56'
      },
      {
        id: 285,
        pid: 21,
        city_code: '101120401',
        city_name: '德州',
        post_code: '253000',
        area_code: '0534',
        ctime: '2019-07-11 17:31:57'
      },
      {
        id: 286,
        pid: 21,
        city_code: '101121201',
        city_name: '东营区',
        post_code: '257100',
        area_code: '0546',
        ctime: '2019-07-11 17:31:57'
      },
      {
        id: 287,
        pid: 21,
        city_code: '101121001',
        city_name: '菏泽',
        post_code: '274000',
        area_code: '0530',
        ctime: '2019-07-11 17:31:57'
      },
      {
        id: 288,
        pid: 21,
        city_code: '101120701',
        city_name: '济宁',
        post_code: '272000',
        area_code: '0537',
        ctime: '2019-07-11 17:31:58'
      },
      {
        id: 289,
        pid: 21,
        city_code: '101121601',
        city_name: '莱芜',
        post_code: '271100',
        area_code: '0634',
        ctime: '2019-07-11 17:31:59'
      },
      {
        id: 290,
        pid: 21,
        city_code: '101121701',
        city_name: '聊城',
        post_code: '252000',
        area_code: '0635',
        ctime: '2019-07-11 17:32:00'
      },
      {
        id: 291,
        pid: 21,
        city_code: '101120901',
        city_name: '临沂',
        post_code: '276000',
        area_code: '0539',
        ctime: '2019-07-11 17:32:01'
      },
      {
        id: 292,
        pid: 21,
        city_code: '101121501',
        city_name: '日照',
        post_code: '276800',
        area_code: '0633',
        ctime: '2019-07-11 17:32:02'
      },
      {
        id: 293,
        pid: 21,
        city_code: '101120801',
        city_name: '泰安',
        post_code: '271000',
        area_code: '0538',
        ctime: '2019-07-11 17:32:03'
      },
      {
        id: 294,
        pid: 21,
        city_code: '101121301',
        city_name: '威海',
        post_code: '264200',
        area_code: '0631',
        ctime: '2019-07-11 17:32:03'
      },
      {
        id: 295,
        pid: 21,
        city_code: '101120601',
        city_name: '潍坊',
        post_code: '261000',
        area_code: '0536',
        ctime: '2019-07-11 17:32:03'
      },
      {
        id: 296,
        pid: 21,
        city_code: '101120501',
        city_name: '烟台',
        post_code: '264000',
        area_code: '0535',
        ctime: '2019-07-11 17:32:04'
      },
      {
        id: 297,
        pid: 21,
        city_code: '101121401',
        city_name: '枣庄',
        post_code: '277100',
        area_code: '0632',
        ctime: '2019-07-11 17:32:06'
      },
      {
        id: 298,
        pid: 21,
        city_code: '101120301',
        city_name: '淄博',
        post_code: '255000',
        area_code: '0533',
        ctime: '2019-07-11 17:32:06'
      },
      {
        id: 299,
        pid: 22,
        city_code: '101100101',
        city_name: '太原',
        post_code: '030000',
        area_code: '0351',
        ctime: '2019-07-11 17:32:06'
      },
      {
        id: 300,
        pid: 22,
        city_code: '101100501',
        city_name: '长治市',
        post_code: '046000',
        area_code: '0355',
        ctime: '2019-07-11 17:32:07'
      },
      {
        id: 301,
        pid: 22,
        city_code: '101100201',
        city_name: '大同市',
        post_code: '037000',
        area_code: '0352',
        ctime: '2019-07-11 16:24:00'
      },
      {
        id: 302,
        pid: 22,
        city_code: '101100601',
        city_name: '晋城',
        post_code: '048000',
        area_code: '0356',
        ctime: '2019-07-11 17:32:07'
      },
      {
        id: 303,
        pid: 22,
        city_code: '101100401',
        city_name: '晋中',
        post_code: '030600',
        area_code: '0354',
        ctime: '2019-07-11 17:32:07'
      },
      {
        id: 304,
        pid: 22,
        city_code: '101100701',
        city_name: '临汾',
        post_code: '041000',
        area_code: '0357',
        ctime: '2019-07-11 17:32:07'
      },
      {
        id: 305,
        pid: 22,
        city_code: '101101100',
        city_name: '吕梁',
        post_code: '033000',
        area_code: '0358',
        ctime: '2019-07-11 17:32:08'
      },
      {
        id: 306,
        pid: 22,
        city_code: '101100901',
        city_name: '朔州',
        post_code: '036000',
        area_code: '0349',
        ctime: '2019-07-11 17:32:08'
      },
      {
        id: 307,
        pid: 22,
        city_code: '101101001',
        city_name: '忻州',
        post_code: '034000',
        area_code: '0350',
        ctime: '2019-07-11 17:32:08'
      },
      {
        id: 308,
        pid: 22,
        city_code: '101100301',
        city_name: '阳泉',
        post_code: '045000',
        area_code: '0353',
        ctime: '2019-07-11 17:32:08'
      },
      {
        id: 309,
        pid: 22,
        city_code: '101100801',
        city_name: '运城',
        post_code: '044000',
        area_code: '国际:359；国内:0359',
        ctime: '2019-07-11 17:32:09'
      },
      {
        id: 310,
        pid: 23,
        city_code: '101110101',
        city_name: '西安市',
        post_code: '710000',
        area_code: '029',
        ctime: '2019-07-11 16:24:00'
      },
      {
        id: 311,
        pid: 23,
        city_code: '101110701',
        city_name: '安康市',
        post_code: '725000',
        area_code: '0915',
        ctime: '2019-07-11 17:32:09'
      },
      {
        id: 312,
        pid: 23,
        city_code: '101110901',
        city_name: '宝鸡',
        post_code: '721000',
        area_code: '0917',
        ctime: '2019-07-11 17:32:09'
      },
      {
        id: 313,
        pid: 23,
        city_code: '101110801',
        city_name: '汉中',
        post_code: '723000',
        area_code: '0916',
        ctime: '2019-07-11 17:32:10'
      },
      {
        id: 314,
        pid: 23,
        city_code: '101110601',
        city_name: '商洛',
        post_code: '726000',
        area_code: '0914',
        ctime: '2019-07-11 17:32:10'
      },
      {
        id: 315,
        pid: 23,
        city_code: '101111001',
        city_name: '铜川',
        post_code: '727000',
        area_code: '0919',
        ctime: '2019-07-11 17:32:10'
      },
      {
        id: 316,
        pid: 23,
        city_code: '101110501',
        city_name: '渭南',
        post_code: '714000',
        area_code: '0913',
        ctime: '2019-07-11 17:32:11'
      },
      {
        id: 317,
        pid: 23,
        city_code: '101110200',
        city_name: '咸阳',
        post_code: '712000',
        area_code: '029',
        ctime: '2019-07-11 17:32:12'
      },
      {
        id: 318,
        pid: 23,
        city_code: '101110300',
        city_name: '延安',
        post_code: '716000',
        area_code: '0911',
        ctime: '2019-07-11 17:32:13'
      },
      {
        id: 319,
        pid: 23,
        city_code: '101110401',
        city_name: '榆林',
        post_code: '719000',
        area_code: '0912',
        ctime: '2019-07-11 17:32:14'
      },
      {
        id: 321,
        pid: 25,
        city_code: '101270101',
        city_name: '成都',
        post_code: '610000',
        area_code: '028',
        ctime: '2019-07-11 17:32:14'
      },
      {
        id: 322,
        pid: 25,
        city_code: '101270401',
        city_name: '绵阳',
        post_code: '621000',
        area_code: '0816',
        ctime: '2019-07-11 17:32:14'
      },
      {
        id: 323,
        pid: 25,
        city_code: '101271901',
        city_name: '阿坝',
        post_code: '624000',
        area_code: '0837',
        ctime: '2019-07-11 17:04:11'
      },
      {
        id: 324,
        pid: 25,
        city_code: '101270901',
        city_name: '巴中',
        post_code: '636600',
        area_code: '0827',
        ctime: '2019-07-11 17:32:15'
      },
      {
        id: 325,
        pid: 25,
        city_code: '101270601',
        city_name: '达州',
        post_code: '635000',
        area_code: '0818',
        ctime: '2019-07-11 17:32:15'
      },
      {
        id: 326,
        pid: 25,
        city_code: '101272001',
        city_name: '德阳',
        post_code: '618000',
        area_code: '0838',
        ctime: '2019-07-11 17:32:16'
      },
      {
        id: 327,
        pid: 25,
        city_code: '101271801',
        city_name: '甘孜',
        post_code: '626700',
        area_code: '0836',
        ctime: '2019-07-11 17:04:12'
      },
      {
        id: 328,
        pid: 25,
        city_code: '101270801',
        city_name: '广安市',
        post_code: '638500',
        area_code: '+860826',
        ctime: '2019-07-11 17:32:16'
      },
      {
        id: 329,
        pid: 25,
        city_code: '101272101',
        city_name: '广元',
        post_code: '628000',
        area_code: '0839',
        ctime: '2019-07-11 17:32:17'
      },
      {
        id: 330,
        pid: 25,
        city_code: '101271401',
        city_name: '乐山',
        post_code: '614000',
        area_code: '0833',
        ctime: '2019-07-11 17:32:18'
      },
      {
        id: 331,
        pid: 25,
        city_code: '101271601',
        city_name: '凉山',
        post_code: '615000',
        area_code: '0834',
        ctime: '2019-07-11 17:04:13'
      },
      {
        id: 332,
        pid: 25,
        city_code: '101271501',
        city_name: '眉山市',
        post_code: '620010',
        area_code: '028',
        ctime: '2019-07-11 16:24:00'
      },
      {
        id: 333,
        pid: 25,
        city_code: '101270501',
        city_name: '南充',
        post_code: '637000',
        area_code: '0817',
        ctime: '2019-07-11 17:32:19'
      },
      {
        id: 334,
        pid: 25,
        city_code: '101271201',
        city_name: '内江',
        post_code: '641000',
        area_code: '0832',
        ctime: '2019-07-11 17:32:19'
      },
      {
        id: 335,
        pid: 25,
        city_code: '101270201',
        city_name: '攀枝花',
        post_code: '617000',
        area_code: '0812',
        ctime: '2019-07-11 17:32:20'
      },
      {
        id: 336,
        pid: 25,
        city_code: '101270701',
        city_name: '遂宁',
        post_code: '629000',
        area_code: '0825',
        ctime: '2019-07-11 17:32:20'
      },
      {
        id: 337,
        pid: 25,
        city_code: '101271701',
        city_name: '雅安',
        post_code: '625000',
        area_code: '0835',
        ctime: '2019-07-11 17:32:20'
      },
      {
        id: 338,
        pid: 25,
        city_code: '101271101',
        city_name: '宜宾',
        post_code: '644000',
        area_code: '0831',
        ctime: '2019-07-11 17:32:20'
      },
      {
        id: 339,
        pid: 25,
        city_code: '101271301',
        city_name: '资阳市',
        post_code: '641300',
        area_code: '028',
        ctime: '2019-07-11 16:24:00'
      },
      {
        id: 340,
        pid: 25,
        city_code: '101270301',
        city_name: '自贡',
        post_code: '643000',
        area_code: '0813',
        ctime: '2019-07-11 17:32:22'
      },
      {
        id: 341,
        pid: 25,
        city_code: '101271001',
        city_name: '泸州',
        post_code: '646000',
        area_code: '0830',
        ctime: '2019-07-11 17:32:22'
      },
      {
        id: 343,
        pid: 27,
        city_code: '101140101',
        city_name: '拉萨',
        post_code: '850000',
        area_code: '0891',
        ctime: '2019-07-11 17:32:22'
      },
      {
        id: 344,
        pid: 27,
        city_code: '101140701',
        city_name: '阿里',
        post_code: '859000',
        area_code: '0897',
        ctime: '2019-07-11 17:04:15'
      },
      {
        id: 345,
        pid: 27,
        city_code: '101140501',
        city_name: '昌都市',
        post_code: '854000',
        area_code: '0895',
        ctime: '2019-07-11 17:32:23'
      },
      {
        id: 346,
        pid: 27,
        city_code: '101140401',
        city_name: '林芝市',
        post_code: '860000',
        area_code: '0894',
        ctime: '2019-07-11 17:32:23'
      },
      {
        id: 347,
        pid: 27,
        city_code: '101140601',
        city_name: '那曲',
        post_code: '852000',
        area_code: '0896',
        ctime: '2019-07-11 17:04:16'
      },
      {
        id: 348,
        pid: 27,
        city_code: '101140201',
        city_name: '日喀则市',
        post_code: '857000',
        area_code: '0892',
        ctime: '2019-07-11 17:32:23'
      },
      {
        id: 349,
        pid: 27,
        city_code: '101140301',
        city_name: '山南',
        post_code: '856000',
        area_code: '0893',
        ctime: '2019-07-11 17:32:23'
      },
      {
        id: 350,
        pid: 28,
        city_code: '101130101',
        city_name: '乌鲁木齐市',
        post_code: '830001',
        area_code: '0991',
        ctime: '2019-07-11 16:24:00'
      },
      {
        id: 351,
        pid: 28,
        city_code: '101130801',
        city_name: '阿克苏市',
        post_code: '843000',
        area_code: '0997',
        ctime: '2019-07-11 17:04:17'
      },
      {
        id: 352,
        pid: 28,
        city_code: '101130701',
        city_name: '阿拉尔市',
        post_code: '843300',
        area_code: '0997',
        ctime: '2019-07-11 17:32:24'
      },
      {
        id: 353,
        pid: 28,
        city_code: '101130609',
        city_name: '巴音郭楞',
        post_code: '841000',
        area_code: '0996',
        ctime: '2019-07-11 17:04:19'
      },
      {
        id: 354,
        pid: 28,
        city_code: '101131604',
        city_name: '博尔塔拉',
        post_code: '833400',
        area_code: '0909',
        ctime: '2019-07-11 17:04:20'
      },
      {
        id: 355,
        pid: 28,
        city_code: '101130401',
        city_name: '昌吉市',
        post_code: '831100',
        area_code: '0994',
        ctime: '2019-07-11 17:04:21'
      },
      {
        id: 356,
        pid: 28,
        city_code: '101131201',
        city_name: '哈密市',
        post_code: '839000',
        area_code: '0902',
        ctime: '2019-07-11 17:32:24'
      },
      {
        id: 357,
        pid: 28,
        city_code: '101131301',
        city_name: '和田市',
        post_code: '848000',
        area_code: '0903',
        ctime: '2019-07-11 17:04:22'
      },
      {
        id: 358,
        pid: 28,
        city_code: '101130901',
        city_name: '喀什市',
        post_code: '844000',
        area_code: '0998',
        ctime: '2019-07-11 17:04:24'
      },
      {
        id: 359,
        pid: 28,
        city_code: '101130201',
        city_name: '克拉玛依市',
        post_code: '834000',
        area_code: '0990',
        ctime: '2019-07-11 17:32:24'
      },
      {
        id: 361,
        pid: 28,
        city_code: '101130301',
        city_name: '石河子市',
        post_code: '832000',
        area_code: '0993',
        ctime: '2019-07-11 17:32:25'
      },
      {
        id: 363,
        pid: 28,
        city_code: '101130501',
        city_name: '吐鲁番市',
        post_code: '838000',
        area_code: '0995',
        ctime: '2019-07-11 17:32:25'
      },
      {
        id: 365,
        pid: 28,
        city_code: '101131012',
        city_name: '伊犁',
        post_code: '835000',
        area_code: '0999、0901、0906',
        ctime: '2019-07-11 17:04:25'
      },
      {
        id: 366,
        pid: 29,
        city_code: '101290101',
        city_name: '昆明',
        post_code: '650000',
        area_code: '0871',
        ctime: '2019-07-11 17:32:25'
      },
      {
        id: 367,
        pid: 29,
        city_code: '101291201',
        city_name: '怒江',
        post_code: '673200',
        area_code: '0886',
        ctime: '2019-07-11 17:04:26'
      },
      {
        id: 368,
        pid: 29,
        city_code: '101290901',
        city_name: '普洱',
        post_code: '665000',
        area_code: '0879',
        ctime: '2019-07-11 17:32:26'
      },
      {
        id: 369,
        pid: 29,
        city_code: '101291401',
        city_name: '丽江',
        post_code: '674100',
        area_code: '0888',
        ctime: '2019-07-11 17:32:26'
      },
      {
        id: 370,
        pid: 29,
        city_code: '101290501',
        city_name: '保山',
        post_code: '678000',
        area_code: '0875',
        ctime: '2019-07-11 17:32:26'
      },
      {
        id: 371,
        pid: 29,
        city_code: '101290801',
        city_name: '楚雄市',
        post_code: '675000',
        area_code: '0878',
        ctime: '2019-07-11 17:32:26'
      },
      {
        id: 372,
        pid: 29,
        city_code: '101290201',
        city_name: '大理市',
        post_code: '671000',
        area_code: '0872',
        ctime: '2019-07-11 17:32:27'
      },
      {
        id: 373,
        pid: 29,
        city_code: '101291501',
        city_name: '德宏',
        post_code: '678400',
        area_code: '0692',
        ctime: '2019-07-11 17:04:27'
      },
      {
        id: 374,
        pid: 29,
        city_code: '101291305',
        city_name: '迪庆',
        post_code: '674400',
        area_code: '0887',
        ctime: '2019-07-11 17:04:29'
      },
      {
        id: 375,
        pid: 29,
        city_code: '101290301',
        city_name: '红河县',
        post_code: '654400',
        area_code: '0873',
        ctime: '2019-07-11 17:32:27'
      },
      {
        id: 376,
        pid: 29,
        city_code: '101291101',
        city_name: '临沧',
        post_code: '677000',
        area_code: '0883',
        ctime: '2019-07-11 17:32:27'
      },
      {
        id: 377,
        pid: 29,
        city_code: '101290401',
        city_name: '曲靖',
        post_code: '655000',
        area_code: '0874',
        ctime: '2019-07-11 17:32:27'
      },
      {
        id: 378,
        pid: 29,
        city_code: '101290601',
        city_name: '文山市',
        post_code: '663099',
        area_code: '0876',
        ctime: '2019-07-11 17:32:28'
      },
      {
        id: 379,
        pid: 29,
        city_code: '101291602',
        city_name: '西双版纳',
        post_code: '666100',
        area_code: '0691',
        ctime: '2019-07-11 17:04:30'
      },
      {
        id: 380,
        pid: 29,
        city_code: '101290701',
        city_name: '玉溪',
        post_code: '653100',
        area_code: '0877',
        ctime: '2019-07-11 17:32:28'
      },
      {
        id: 381,
        pid: 29,
        city_code: '101291001',
        city_name: '昭通',
        post_code: '657000',
        area_code: '0870',
        ctime: '2019-07-11 17:32:28'
      },
      {
        id: 382,
        pid: 30,
        city_code: '101210101',
        city_name: '杭州',
        post_code: '310000',
        area_code: '0571',
        ctime: '2019-07-11 17:32:28'
      },
      {
        id: 383,
        pid: 30,
        city_code: '101210201',
        city_name: '湖州',
        post_code: '313000',
        area_code: '0572',
        ctime: '2019-07-11 17:32:29'
      },
      {
        id: 384,
        pid: 30,
        city_code: '101210301',
        city_name: '嘉兴',
        post_code: '314000',
        area_code: '0573',
        ctime: '2019-07-11 17:32:29'
      },
      {
        id: 385,
        pid: 30,
        city_code: '101210901',
        city_name: '金华',
        post_code: '321000',
        area_code: '0579',
        ctime: '2019-07-11 17:32:29'
      },
      {
        id: 386,
        pid: 30,
        city_code: '101210801',
        city_name: '丽水',
        post_code: '323000',
        area_code: '0578',
        ctime: '2019-07-11 17:32:29'
      },
      {
        id: 387,
        pid: 30,
        city_code: '101210401',
        city_name: '宁波',
        post_code: '315000',
        area_code: '0574',
        ctime: '2019-07-11 17:32:30'
      },
      {
        id: 388,
        pid: 30,
        city_code: '101210507',
        city_name: '绍兴',
        post_code: '312000',
        area_code: '0575',
        ctime: '2019-07-11 17:32:30'
      },
      {
        id: 389,
        pid: 30,
        city_code: '101210601',
        city_name: '台州',
        post_code: '318000',
        area_code: '0576',
        ctime: '2019-07-11 17:32:30'
      },
      {
        id: 390,
        pid: 30,
        city_code: '101210701',
        city_name: '温州',
        post_code: '325000',
        area_code: '0577',
        ctime: '2019-07-11 17:32:30'
      },
      {
        id: 391,
        pid: 30,
        city_code: '101211101',
        city_name: '舟山',
        post_code: '316000',
        area_code: '0580',
        ctime: '2019-07-11 17:32:31'
      },
      {
        id: 392,
        pid: 30,
        city_code: '101211001',
        city_name: '衢州',
        post_code: '324000',
        area_code: '0570',
        ctime: '2019-07-11 17:32:31'
      },
      {
        id: 400,
        pid: 35,
        city_code: '101220609',
        city_name: '桐城市',
        post_code: '231400',
        area_code: '0556',
        ctime: '2019-07-11 17:04:31'
      },
      {
        id: 401,
        pid: 35,
        city_code: '101220605',
        city_name: '怀宁县',
        post_code: '246121',
        area_code: '0556',
        ctime: '2019-07-11 17:04:32'
      },
      {
        id: 402,
        pid: 47,
        city_code: '101221305',
        city_name: '枞阳县',
        post_code: '246700',
        area_code: '0556',
        ctime: '2019-07-11 17:04:34'
      },
      {
        id: 403,
        pid: 35,
        city_code: '101220604',
        city_name: '潜山县',
        post_code: '246300',
        area_code: '0556',
        ctime: '2019-07-11 17:04:35'
      },
      {
        id: 404,
        pid: 35,
        city_code: '101220603',
        city_name: '太湖县',
        post_code: '246400',
        area_code: '0556',
        ctime: '2019-07-11 17:04:36'
      },
      {
        id: 405,
        pid: 35,
        city_code: '101220606',
        city_name: '宿松县',
        post_code: '246500',
        area_code: '0556',
        ctime: '2019-07-11 17:04:37'
      },
      {
        id: 406,
        pid: 35,
        city_code: '101220607',
        city_name: '望江县',
        post_code: '246200',
        area_code: '0556',
        ctime: '2019-07-11 17:04:39'
      },
      {
        id: 407,
        pid: 35,
        city_code: '101220608',
        city_name: '岳西县',
        post_code: '246600',
        area_code: '0556',
        ctime: '2019-07-11 17:04:40'
      },
      {
        id: 412,
        pid: 36,
        city_code: '101220202',
        city_name: '怀远县',
        post_code: '233400',
        area_code: '0552',
        ctime: '2019-07-11 17:04:42'
      },
      {
        id: 413,
        pid: 36,
        city_code: '101220204',
        city_name: '五河县',
        post_code: '233300',
        area_code: '0552',
        ctime: '2019-07-11 17:20:47'
      },
      {
        id: 414,
        pid: 36,
        city_code: '101220203',
        city_name: '固镇县',
        post_code: '233700',
        area_code: '0552',
        ctime: '2019-07-11 17:04:43'
      },
      {
        id: 416,
        pid: 3400,
        city_code: '101220106',
        city_name: '庐江县',
        post_code: '231500',
        area_code: '0551',
        ctime: '2019-07-11 17:04:45'
      },
      {
        id: 417,
        pid: 48,
        city_code: '101220305',
        city_name: '无为县',
        post_code: '238300',
        area_code: '0553',
        ctime: '2019-07-11 17:04:46'
      },
      {
        id: 418,
        pid: 45,
        city_code: '101220503',
        city_name: '含山县',
        post_code: '238100',
        area_code: '0555',
        ctime: '2019-07-11 16:55:25'
      },
      {
        id: 419,
        pid: 45,
        city_code: '101220504',
        city_name: '和县',
        post_code: '238200',
        area_code: '0555',
        ctime: '2019-07-11 16:55:27'
      },
      {
        id: 421,
        pid: 38,
        city_code: '101221702',
        city_name: '东至县',
        post_code: '247200',
        area_code: '0566',
        ctime: '2019-07-11 17:04:59'
      },
      {
        id: 422,
        pid: 38,
        city_code: '101221705',
        city_name: '石台县',
        post_code: '245100',
        area_code: '0566',
        ctime: '2019-07-11 16:55:29'
      },
      {
        id: 423,
        pid: 38,
        city_code: '101221703',
        city_name: '青阳县',
        post_code: '242800',
        area_code: '0566',
        ctime: '2019-07-11 16:55:30'
      },
      {
        id: 426,
        pid: 39,
        city_code: '101221107',
        city_name: '天长市',
        post_code: '239300',
        area_code: '0550',
        ctime: '2019-07-11 16:55:32'
      },
      {
        id: 427,
        pid: 39,
        city_code: '101221103',
        city_name: '明光市',
        post_code: '239400',
        area_code: '0550',
        ctime: '2019-07-11 16:55:33'
      },
      {
        id: 428,
        pid: 39,
        city_code: '101221106',
        city_name: '来安县',
        post_code: '239200',
        area_code: '0550',
        ctime: '2019-07-11 16:55:34'
      },
      {
        id: 429,
        pid: 39,
        city_code: '101221105',
        city_name: '全椒县',
        post_code: '239500',
        area_code: '0550',
        ctime: '2019-07-11 16:55:35'
      },
      {
        id: 430,
        pid: 39,
        city_code: '101221104',
        city_name: '定远县',
        post_code: '233200',
        area_code: '0550',
        ctime: '2019-07-11 16:55:36'
      },
      {
        id: 431,
        pid: 39,
        city_code: '101221102',
        city_name: '凤阳县',
        post_code: '233100',
        area_code: '0550',
        ctime: '2019-07-11 16:55:38'
      },
      {
        id: 439,
        pid: 40,
        city_code: '101220805',
        city_name: '界首市',
        post_code: '236500',
        area_code: '0558',
        ctime: '2019-07-11 16:55:39'
      },
      {
        id: 440,
        pid: 40,
        city_code: '101220804',
        city_name: '临泉县',
        post_code: '236400',
        area_code: '0558',
        ctime: '2019-07-11 16:55:40'
      },
      {
        id: 441,
        pid: 40,
        city_code: '101220806',
        city_name: '太和县',
        post_code: '236600',
        area_code: '0558',
        ctime: '2019-07-11 16:55:41'
      },
      {
        id: 442,
        pid: 40,
        city_code: '101220802',
        city_name: '阜南县',
        post_code: '236300',
        area_code: '0558',
        ctime: '2019-07-11 16:55:43'
      },
      {
        id: 443,
        pid: 40,
        city_code: '101220803',
        city_name: '颍上县',
        post_code: '236200',
        area_code: '0558',
        ctime: '2019-07-11 16:55:44'
      },
      {
        id: 447,
        pid: 41,
        city_code: '101221202',
        city_name: '濉溪县',
        post_code: '235100',
        area_code: '0561',
        ctime: '2019-07-11 16:55:45'
      },
      {
        id: 452,
        pid: 42,
        city_code: '101220403',
        city_name: '潘集区',
        post_code: '232000',
        area_code: '0554',
        ctime: '2019-07-11 16:55:46'
      },
      {
        id: 453,
        pid: 42,
        city_code: '101220402',
        city_name: '凤台县',
        post_code: '232100',
        area_code: '0554',
        ctime: '2019-07-11 16:47:57'
      },
      {
        id: 454,
        pid: 43,
        city_code: '101221003',
        city_name: '屯溪区',
        post_code: '245000',
        area_code: '0559',
        ctime: '2019-07-11 16:47:57'
      },
      {
        id: 455,
        pid: 43,
        city_code: '101221002',
        city_name: '黄山区',
        post_code: '245700',
        area_code: '0559',
        ctime: '2019-07-11 16:56:00'
      },
      {
        id: 457,
        pid: 43,
        city_code: '101221006',
        city_name: '歙县',
        post_code: '245200',
        area_code: '0559',
        ctime: '2019-07-11 16:56:01'
      },
      {
        id: 458,
        pid: 43,
        city_code: '101221007',
        city_name: '休宁县',
        post_code: '245400',
        area_code: '0559',
        ctime: '2019-07-11 16:56:02'
      },
      {
        id: 459,
        pid: 43,
        city_code: '101221005',
        city_name: '黟县',
        post_code: '245500',
        area_code: '0559',
        ctime: '2019-07-11 16:56:03'
      },
      {
        id: 460,
        pid: 43,
        city_code: '101221004',
        city_name: '祁门县',
        post_code: '245600',
        area_code: '0559',
        ctime: '2019-07-11 16:56:05'
      },
      {
        id: 463,
        pid: 44,
        city_code: '101220408',
        city_name: '寿县',
        post_code: '232200',
        area_code: '0554',
        ctime: '2019-07-11 16:56:06'
      },
      {
        id: 464,
        pid: 44,
        city_code: '101221502',
        city_name: '霍邱县',
        post_code: '237400',
        area_code: '0564',
        ctime: '2019-07-11 16:56:07'
      },
      {
        id: 465,
        pid: 44,
        city_code: '101221507',
        city_name: '舒城县',
        post_code: '231300',
        area_code: '0564',
        ctime: '2019-07-11 16:56:08'
      },
      {
        id: 466,
        pid: 44,
        city_code: '101221505',
        city_name: '金寨县',
        post_code: '237300',
        area_code: '0564',
        ctime: '2019-07-11 16:56:10'
      },
      {
        id: 467,
        pid: 44,
        city_code: '101221506',
        city_name: '霍山县',
        post_code: '237200',
        area_code: '0564',
        ctime: '2019-07-11 16:56:11'
      },
      {
        id: 471,
        pid: 45,
        city_code: '101220502',
        city_name: '当涂县',
        post_code: '243100',
        area_code: '0555',
        ctime: '2019-07-11 16:56:12'
      },
      {
        id: 473,
        pid: 46,
        city_code: '101220702',
        city_name: '砀山县',
        post_code: '235300',
        area_code: '0557',
        ctime: '2019-07-11 16:56:13'
      },
      {
        id: 474,
        pid: 46,
        city_code: '101220705',
        city_name: '萧县',
        post_code: '235200',
        area_code: '0557',
        ctime: '2019-07-11 16:56:15'
      },
      {
        id: 475,
        pid: 46,
        city_code: '101220703',
        city_name: '灵璧县',
        post_code: '234200',
        area_code: '0557',
        ctime: '2019-07-11 16:56:16'
      },
      {
        id: 476,
        pid: 46,
        city_code: '101220704',
        city_name: '泗县',
        post_code: '234300',
        area_code: '0557',
        ctime: '2019-07-11 16:56:17'
      },
      {
        id: 480,
        pid: 47,
        city_code: '101221303',
        city_name: '义安区',
        post_code: '244100',
        area_code: '0562',
        ctime: '2019-07-11 16:56:18'
      },
      {
        id: 485,
        pid: 48,
        city_code: '101220303',
        city_name: '芜湖县',
        post_code: '241100',
        area_code: '0553',
        ctime: '2019-07-11 16:56:21'
      },
      {
        id: 486,
        pid: 48,
        city_code: '101220302',
        city_name: '繁昌县',
        post_code: '241200',
        area_code: '0553',
        ctime: '2019-07-11 16:56:22'
      },
      {
        id: 487,
        pid: 48,
        city_code: '101220304',
        city_name: '南陵县',
        post_code: '242400',
        area_code: '0553',
        ctime: '2019-07-11 16:56:23'
      },
      {
        id: 489,
        pid: 49,
        city_code: '101221404',
        city_name: '宁国市',
        post_code: '242300',
        area_code: '0563',
        ctime: '2019-07-11 16:56:24'
      },
      {
        id: 490,
        pid: 49,
        city_code: '101221407',
        city_name: '郎溪县',
        post_code: '242199',
        area_code: '0563',
        ctime: '2019-07-11 16:56:26'
      },
      {
        id: 491,
        pid: 49,
        city_code: '101221406',
        city_name: '广德县',
        post_code: '242200',
        area_code: '0563',
        ctime: '2019-07-11 16:56:27'
      },
      {
        id: 492,
        pid: 49,
        city_code: '101221402',
        city_name: '泾县',
        post_code: '242500',
        area_code: '0563',
        ctime: '2019-07-11 16:56:28'
      },
      {
        id: 493,
        pid: 49,
        city_code: '101221405',
        city_name: '绩溪县',
        post_code: '245300',
        area_code: '0563',
        ctime: '2019-07-11 16:56:29'
      },
      {
        id: 494,
        pid: 49,
        city_code: '101221403',
        city_name: '旌德县',
        post_code: '242600',
        area_code: '0563',
        ctime: '2019-07-11 16:56:31'
      },
      {
        id: 495,
        pid: 50,
        city_code: '101220902',
        city_name: '涡阳县',
        post_code: '233600',
        area_code: '0558',
        ctime: '2019-07-11 16:56:32'
      },
      {
        id: 496,
        pid: 50,
        city_code: '101220904',
        city_name: '蒙城县',
        post_code: '233500',
        area_code: '0558',
        ctime: '2019-07-11 16:56:33'
      },
      {
        id: 497,
        pid: 50,
        city_code: '101220903',
        city_name: '利辛县',
        post_code: '236700',
        area_code: '0558',
        ctime: '2019-07-11 16:56:34'
      },
      {
        id: 501,
        pid: 1,
        city_code: '101010200',
        city_name: '海淀区',
        post_code: '100089',
        area_code: '010',
        ctime: '2019-07-11 16:56:35'
      },
      {
        id: 502,
        pid: 1,
        city_code: '101010300',
        city_name: '朝阳区',
        post_code: '100020',
        area_code: '010',
        ctime: '2019-07-11 16:56:37'
      },
      {
        id: 505,
        pid: 1,
        city_code: '101010900',
        city_name: '丰台区',
        post_code: '100071',
        area_code: '010',
        ctime: '2019-07-11 16:56:38'
      },
      {
        id: 506,
        pid: 1,
        city_code: '101011000',
        city_name: '石景山区',
        post_code: '100043',
        area_code: '010',
        ctime: '2019-07-11 16:56:39'
      },
      {
        id: 507,
        pid: 1,
        city_code: '101011200',
        city_name: '房山区',
        post_code: '102488',
        area_code: '010',
        ctime: '2019-07-11 16:56:41'
      },
      {
        id: 508,
        pid: 1,
        city_code: '101011400',
        city_name: '门头沟区',
        post_code: '102300',
        area_code: '010',
        ctime: '2019-07-11 16:56:42'
      },
      {
        id: 509,
        pid: 1,
        city_code: '101010600',
        city_name: '通州区',
        post_code: '101149',
        area_code: '010',
        ctime: '2019-07-11 16:56:43'
      },
      {
        id: 510,
        pid: 1,
        city_code: '101010400',
        city_name: '顺义区',
        post_code: '101300',
        area_code: '010',
        ctime: '2019-07-11 16:56:44'
      },
      {
        id: 511,
        pid: 1,
        city_code: '101010700',
        city_name: '昌平区',
        post_code: '102200',
        area_code: '010',
        ctime: '2019-07-11 16:56:46'
      },
      {
        id: 512,
        pid: 1,
        city_code: '101010500',
        city_name: '怀柔区',
        post_code: '101400',
        area_code: '010',
        ctime: '2019-07-11 16:56:47'
      },
      {
        id: 513,
        pid: 1,
        city_code: '101011500',
        city_name: '平谷区',
        post_code: '101200',
        area_code: '010',
        ctime: '2019-07-11 16:56:48'
      },
      {
        id: 514,
        pid: 1,
        city_code: '101011100',
        city_name: '大兴区',
        post_code: '102600',
        area_code: '010',
        ctime: '2019-07-11 16:56:49'
      },
      {
        id: 515,
        pid: 1,
        city_code: '101011300',
        city_name: '密云区',
        post_code: '101500',
        area_code: '010',
        ctime: '2019-07-11 16:24:00'
      },
      {
        id: 516,
        pid: 1,
        city_code: '101010800',
        city_name: '延庆区',
        post_code: '102100-102019',
        area_code: '010',
        ctime: '2019-07-11 16:24:00'
      },
      {
        id: 522,
        pid: 52,
        city_code: '101230111',
        city_name: '福清市',
        post_code: '350300',
        area_code: '0591',
        ctime: '2019-07-11 16:56:51'
      },
      {
        id: 523,
        pid: 52,
        city_code: '101230110',
        city_name: '长乐市',
        post_code: '350200',
        area_code: '0591',
        ctime: '2019-07-11 16:48:18'
      },
      {
        id: 524,
        pid: 52,
        city_code: '101230103',
        city_name: '闽侯县',
        post_code: '350100',
        area_code: '0591',
        ctime: '2019-07-11 16:56:58'
      },
      {
        id: 525,
        pid: 52,
        city_code: '101230105',
        city_name: '连江县',
        post_code: '350500',
        area_code: '0591',
        ctime: '2019-07-11 16:56:59'
      },
      {
        id: 526,
        pid: 52,
        city_code: '101230104',
        city_name: '罗源县',
        post_code: '350600',
        area_code: '0591',
        ctime: '2019-07-11 16:48:19'
      },
      {
        id: 527,
        pid: 52,
        city_code: '101230102',
        city_name: '闽清县',
        post_code: '350800',
        area_code: '0591',
        ctime: '2019-07-11 16:48:20'
      },
      {
        id: 528,
        pid: 52,
        city_code: '101230107',
        city_name: '永泰县',
        post_code: '350700',
        area_code: '0591',
        ctime: '2019-07-11 16:48:20'
      },
      {
        id: 529,
        pid: 52,
        city_code: '101230108',
        city_name: '平潭县',
        post_code: '350400',
        area_code: '0591',
        ctime: '2019-07-11 16:57:18'
      },
      {
        id: 531,
        pid: 53,
        city_code: '101230707',
        city_name: '漳平市',
        post_code: '364400',
        area_code: '0597',
        ctime: '2019-07-11 16:57:19'
      },
      {
        id: 532,
        pid: 53,
        city_code: '101230702',
        city_name: '长汀县',
        post_code: '366300',
        area_code: '0597',
        ctime: '2019-07-11 16:57:21'
      },
      {
        id: 533,
        pid: 53,
        city_code: '101230706',
        city_name: '永定区',
        post_code: '364100',
        area_code: '0597',
        ctime: '2019-07-11 16:24:00'
      },
      {
        id: 534,
        pid: 53,
        city_code: '101230705',
        city_name: '上杭县',
        post_code: '364200',
        area_code: '0597',
        ctime: '2019-07-11 16:57:22'
      },
      {
        id: 535,
        pid: 53,
        city_code: '101230704',
        city_name: '武平县',
        post_code: '364300',
        area_code: '0597',
        ctime: '2019-07-11 16:57:23'
      },
      {
        id: 536,
        pid: 53,
        city_code: '101230703',
        city_name: '连城县',
        post_code: '366200',
        area_code: '0597',
        ctime: '2019-07-11 16:57:24'
      },
      {
        id: 538,
        pid: 54,
        city_code: '101230904',
        city_name: '邵武市',
        post_code: '354000',
        area_code: '0599',
        ctime: '2019-07-11 16:57:26'
      },
      {
        id: 539,
        pid: 54,
        city_code: '101230905',
        city_name: '武夷山市',
        post_code: '354300',
        area_code: '0599',
        ctime: '2019-07-11 16:48:22'
      },
      {
        id: 540,
        pid: 54,
        city_code: '101230910',
        city_name: '建瓯市',
        post_code: '353100',
        area_code: '0599',
        ctime: '2019-07-11 16:57:33'
      },
      {
        id: 541,
        pid: 54,
        city_code: '101230907',
        city_name: '建阳市',
        post_code: '354200',
        area_code: '0599',
        ctime: '2019-07-11 17:32:36'
      },
      {
        id: 542,
        pid: 54,
        city_code: '101230902',
        city_name: '顺昌县',
        post_code: '353200',
        area_code: '0599',
        ctime: '2019-07-11 16:48:23'
      },
      {
        id: 543,
        pid: 54,
        city_code: '101230906',
        city_name: '浦城县',
        post_code: '353400',
        area_code: '0599',
        ctime: '2019-07-11 16:48:23'
      },
      {
        id: 544,
        pid: 54,
        city_code: '101230903',
        city_name: '光泽县',
        post_code: '354100',
        area_code: '0599',
        ctime: '2019-07-11 16:57:50'
      },
      {
        id: 545,
        pid: 54,
        city_code: '101230908',
        city_name: '松溪县',
        post_code: '353500',
        area_code: '0599',
        ctime: '2019-07-11 16:48:23'
      },
      {
        id: 546,
        pid: 54,
        city_code: '101230909',
        city_name: '政和县',
        post_code: '353600',
        area_code: '0599',
        ctime: '2019-07-11 16:57:57'
      },
      {
        id: 548,
        pid: 55,
        city_code: '101230306',
        city_name: '福安市',
        post_code: '355000',
        area_code: '0593',
        ctime: '2019-07-11 16:58:00'
      },
      {
        id: 549,
        pid: 55,
        city_code: '101230308',
        city_name: '福鼎市',
        post_code: '355200',
        area_code: '0593',
        ctime: '2019-07-11 16:48:24'
      },
      {
        id: 550,
        pid: 55,
        city_code: '101230303',
        city_name: '霞浦县',
        post_code: '355100',
        area_code: '0593',
        ctime: '2019-07-11 16:58:07'
      },
      {
        id: 551,
        pid: 55,
        city_code: '101230302',
        city_name: '古田县',
        post_code: '352200',
        area_code: '0593',
        ctime: '2019-07-11 16:58:08'
      },
      {
        id: 552,
        pid: 55,
        city_code: '101230309',
        city_name: '屏南县',
        post_code: '352300',
        area_code: '0593',
        ctime: '2019-07-11 16:58:09'
      },
      {
        id: 553,
        pid: 55,
        city_code: '101230304',
        city_name: '寿宁县',
        post_code: '355500',
        area_code: '0593',
        ctime: '2019-07-11 16:58:11'
      },
      {
        id: 554,
        pid: 55,
        city_code: '101230305',
        city_name: '周宁县',
        post_code: '355400',
        area_code: '0593',
        ctime: '2019-07-11 16:48:26'
      },
      {
        id: 555,
        pid: 55,
        city_code: '101230307',
        city_name: '柘荣县',
        post_code: '355300',
        area_code: '0593',
        ctime: '2019-07-11 16:58:20'
      },
      {
        id: 556,
        pid: 56,
        city_code: '101230407',
        city_name: '城厢区',
        post_code: '351100',
        area_code: '0594',
        ctime: '2019-07-11 16:58:21'
      },
      {
        id: 557,
        pid: 56,
        city_code: '101230404',
        city_name: '涵江区',
        post_code: '351111',
        area_code: '0594',
        ctime: '2019-07-11 16:58:22'
      },
      {
        id: 558,
        pid: 56,
        city_code: '101230406',
        city_name: '荔城区',
        post_code: '351100',
        area_code: '0594',
        ctime: '2019-07-11 16:58:24'
      },
      {
        id: 559,
        pid: 56,
        city_code: '101230405',
        city_name: '秀屿区',
        post_code: '351100',
        area_code: '0594',
        ctime: '2019-07-11 16:58:25'
      },
      {
        id: 560,
        pid: 56,
        city_code: '101230402',
        city_name: '仙游县',
        post_code: '351200',
        area_code: '0594',
        ctime: '2019-07-11 16:58:26'
      },
      {
        id: 566,
        pid: 57,
        city_code: '101230510',
        city_name: '石狮市',
        post_code: '362700',
        area_code: '0595',
        ctime: '2019-07-11 16:58:27'
      },
      {
        id: 567,
        pid: 57,
        city_code: '101230509',
        city_name: '晋江市',
        post_code: '362200',
        area_code: '595',
        ctime: '2019-07-11 16:58:29'
      },
      {
        id: 568,
        pid: 57,
        city_code: '101230506',
        city_name: '南安市',
        post_code: '362300',
        area_code: '0595',
        ctime: '2019-07-11 16:58:30'
      },
      {
        id: 569,
        pid: 57,
        city_code: '101230508',
        city_name: '惠安县',
        post_code: '362100',
        area_code: '0595',
        ctime: '2019-07-11 16:48:28'
      },
      {
        id: 570,
        pid: 57,
        city_code: '101230502',
        city_name: '安溪县',
        post_code: '362400',
        area_code: '0595',
        ctime: '2019-07-11 16:58:37'
      },
      {
        id: 571,
        pid: 57,
        city_code: '101230504',
        city_name: '永春县',
        post_code: '362600',
        area_code: '0595',
        ctime: '2019-07-11 16:58:38'
      },
      {
        id: 572,
        pid: 57,
        city_code: '101230505',
        city_name: '德化县',
        post_code: '362500',
        area_code: '0595',
        ctime: '2019-07-11 16:58:40'
      },
      {
        id: 576,
        pid: 58,
        city_code: '101230810',
        city_name: '永安市',
        post_code: '366000',
        area_code: '0598',
        ctime: '2019-07-11 16:58:41'
      },
      {
        id: 577,
        pid: 58,
        city_code: '101230807',
        city_name: '明溪县',
        post_code: '365200',
        area_code: '0598',
        ctime: '2019-07-11 17:20:55'
      },
      {
        id: 578,
        pid: 58,
        city_code: '101230803',
        city_name: '清流县',
        post_code: '365300',
        area_code: '0598',
        ctime: '2019-07-11 17:20:56'
      },
      {
        id: 579,
        pid: 58,
        city_code: '101230802',
        city_name: '宁化县',
        post_code: '365400',
        area_code: '0598',
        ctime: '2019-07-11 17:20:58'
      },
      {
        id: 580,
        pid: 58,
        city_code: '101230811',
        city_name: '大田县',
        post_code: '366100',
        area_code: '0598',
        ctime: '2019-07-11 17:20:59'
      },
      {
        id: 581,
        pid: 58,
        city_code: '101230809',
        city_name: '尤溪县',
        post_code: '365100',
        area_code: '0598',
        ctime: '2019-07-11 16:58:42'
      },
      {
        id: 582,
        pid: 58,
        city_code: '101230808',
        city_name: '沙县',
        post_code: '365500',
        area_code: '0598',
        ctime: '2019-07-11 16:58:43'
      },
      {
        id: 583,
        pid: 58,
        city_code: '101230805',
        city_name: '将乐县',
        post_code: '353300',
        area_code: '0598',
        ctime: '2019-07-11 16:48:30'
      },
      {
        id: 584,
        pid: 58,
        city_code: '101230804',
        city_name: '泰宁县',
        post_code: '354400',
        area_code: '0598',
        ctime: '2019-07-11 16:48:31'
      },
      {
        id: 585,
        pid: 58,
        city_code: '101230806',
        city_name: '建宁县',
        post_code: '354500',
        area_code: '0598',
        ctime: '2019-07-11 17:21:00'
      },
      {
        id: 590,
        pid: 59,
        city_code: '101230202',
        city_name: '同安区',
        post_code: '361100',
        area_code: '592',
        ctime: '2019-07-11 16:58:57'
      },
      {
        id: 594,
        pid: 60,
        city_code: '101230605',
        city_name: '龙海市',
        post_code: '363100',
        area_code: '0596',
        ctime: '2019-07-11 16:58:58'
      },
      {
        id: 595,
        pid: 60,
        city_code: '101230609',
        city_name: '云霄县',
        post_code: '363300',
        area_code: '0596',
        ctime: '2019-07-11 16:58:59'
      },
      {
        id: 596,
        pid: 60,
        city_code: '101230606',
        city_name: '漳浦县',
        post_code: '363200',
        area_code: '0596',
        ctime: '2019-07-11 16:59:00'
      },
      {
        id: 597,
        pid: 60,
        city_code: '101230607',
        city_name: '诏安县',
        post_code: '363500',
        area_code: '0596',
        ctime: '2019-07-11 17:21:02'
      },
      {
        id: 598,
        pid: 60,
        city_code: '101230602',
        city_name: '长泰县',
        post_code: '363900',
        area_code: '0596',
        ctime: '2019-07-11 16:59:01'
      },
      {
        id: 599,
        pid: 60,
        city_code: '101230608',
        city_name: '东山县',
        post_code: '363400',
        area_code: '0596',
        ctime: '2019-07-11 16:59:03'
      },
      {
        id: 600,
        pid: 60,
        city_code: '101230603',
        city_name: '南靖县',
        post_code: '363600',
        area_code: '0596',
        ctime: '2019-07-11 16:59:04'
      },
      {
        id: 601,
        pid: 60,
        city_code: '101230604',
        city_name: '平和县',
        post_code: '363700',
        area_code: '0596',
        ctime: '2019-07-11 16:59:05'
      },
      {
        id: 602,
        pid: 60,
        city_code: '101230610',
        city_name: '华安县',
        post_code: '363800',
        area_code: '0596',
        ctime: '2019-07-11 16:59:06'
      },
      {
        id: 603,
        pid: 61,
        city_code: '101160102',
        city_name: '皋兰县',
        post_code: '730200',
        area_code: '0931',
        ctime: '2019-07-11 16:59:07'
      },
      {
        id: 609,
        pid: 61,
        city_code: '101160103',
        city_name: '永登县',
        post_code: '730300',
        area_code: '0931',
        ctime: '2019-07-11 16:59:09'
      },
      {
        id: 610,
        pid: 61,
        city_code: '101160104',
        city_name: '榆中县',
        post_code: '730100',
        area_code: '0931',
        ctime: '2019-07-11 16:59:10'
      },
      {
        id: 612,
        pid: 62,
        city_code: '101161304',
        city_name: '平川区',
        post_code: '730913',
        area_code: '0943',
        ctime: '2019-07-11 16:59:11'
      },
      {
        id: 613,
        pid: 62,
        city_code: '101161303',
        city_name: '会宁县',
        post_code: '730700',
        area_code: '0943',
        ctime: '2019-07-11 16:59:12'
      },
      {
        id: 614,
        pid: 62,
        city_code: '101161305',
        city_name: '景泰县',
        post_code: '730400',
        area_code: '0943',
        ctime: '2019-07-11 16:59:13'
      },
      {
        id: 615,
        pid: 62,
        city_code: '101161302',
        city_name: '靖远县',
        post_code: '730600',
        area_code: '0943',
        ctime: '2019-07-11 16:59:15'
      },
      {
        id: 616,
        pid: 63,
        city_code: '101160205',
        city_name: '临洮县',
        post_code: '730500',
        area_code: '0932',
        ctime: '2019-07-11 16:59:16'
      },
      {
        id: 617,
        pid: 63,
        city_code: '101160203',
        city_name: '陇西县',
        post_code: '748100',
        area_code: '0932',
        ctime: '2019-07-11 16:59:17'
      },
      {
        id: 618,
        pid: 63,
        city_code: '101160202',
        city_name: '通渭县',
        post_code: '743300',
        area_code: '0932',
        ctime: '2019-07-11 16:59:18'
      },
      {
        id: 619,
        pid: 63,
        city_code: '101160204',
        city_name: '渭源县',
        post_code: '748200',
        area_code: '0932',
        ctime: '2019-07-11 16:59:21'
      },
      {
        id: 620,
        pid: 63,
        city_code: '101160206',
        city_name: '漳县',
        post_code: '748300',
        area_code: '0932',
        ctime: '2019-07-11 16:59:22'
      },
      {
        id: 621,
        pid: 63,
        city_code: '101160207',
        city_name: '岷县',
        post_code: '748400',
        area_code: '0932',
        ctime: '2019-07-11 16:59:23'
      },
      {
        id: 624,
        pid: 64,
        city_code: '101161201',
        city_name: '合作市',
        post_code: '747000',
        area_code: '0941',
        ctime: '2019-07-11 16:59:24'
      },
      {
        id: 625,
        pid: 64,
        city_code: '101161202',
        city_name: '临潭县',
        post_code: '747500',
        area_code: '0941',
        ctime: '2019-07-11 16:59:26'
      },
      {
        id: 626,
        pid: 64,
        city_code: '101161203',
        city_name: '卓尼县',
        post_code: '747600',
        area_code: '0941',
        ctime: '2019-07-11 16:59:27'
      },
      {
        id: 627,
        pid: 64,
        city_code: '101161204',
        city_name: '舟曲县',
        post_code: '746300',
        area_code: '0941',
        ctime: '2019-07-11 16:59:28'
      },
      {
        id: 628,
        pid: 64,
        city_code: '101161205',
        city_name: '迭部县',
        post_code: '747400',
        area_code: '0941',
        ctime: '2019-07-11 16:59:29'
      },
      {
        id: 629,
        pid: 64,
        city_code: '101161206',
        city_name: '玛曲县',
        post_code: '747300',
        area_code: '0941',
        ctime: '2019-07-11 16:59:32'
      },
      {
        id: 630,
        pid: 64,
        city_code: '101161207',
        city_name: '碌曲县',
        post_code: '747200',
        area_code: '0941',
        ctime: '2019-07-11 16:59:34'
      },
      {
        id: 631,
        pid: 64,
        city_code: '101161208',
        city_name: '夏河县',
        post_code: '747100',
        area_code: '0941',
        ctime: '2019-07-11 16:59:35'
      },
      {
        id: 634,
        pid: 66,
        city_code: '101160602',
        city_name: '永昌县',
        post_code: '737200',
        area_code: '0935',
        ctime: '2019-07-11 16:59:36'
      },
      {
        id: 636,
        pid: 67,
        city_code: '101160807',
        city_name: '玉门市',
        post_code: '735211',
        area_code: '0937',
        ctime: '2019-07-11 16:59:37'
      },
      {
        id: 637,
        pid: 67,
        city_code: '101160808',
        city_name: '敦煌市',
        post_code: '736200',
        area_code: '0937',
        ctime: '2019-07-11 16:59:39'
      },
      {
        id: 638,
        pid: 67,
        city_code: '101160803',
        city_name: '金塔县',
        post_code: '735300',
        area_code: '0937',
        ctime: '2019-07-11 16:59:41'
      },
      {
        id: 639,
        pid: 67,
        city_code: '101160805',
        city_name: '瓜州县',
        post_code: '736100',
        area_code: '0937',
        ctime: '2019-07-11 16:59:42'
      },
      {
        id: 640,
        pid: 67,
        city_code: '101160806',
        city_name: '肃北县',
        post_code: '736300',
        area_code: '0937',
        ctime: '2019-07-11 16:59:44'
      },
      {
        id: 641,
        pid: 67,
        city_code: '101160804',
        city_name: '阿克塞',
        post_code: '736400',
        area_code: '0937',
        ctime: '2019-07-11 17:32:37'
      },
      {
        id: 644,
        pid: 68,
        city_code: '101161102',
        city_name: '康乐县',
        post_code: '731500',
        area_code: '0930',
        ctime: '2019-07-11 16:59:51'
      },
      {
        id: 645,
        pid: 68,
        city_code: '101161103',
        city_name: '永靖县',
        post_code: '731600',
        area_code: '0930',
        ctime: '2019-07-11 16:59:52'
      },
      {
        id: 646,
        pid: 68,
        city_code: '101161104',
        city_name: '广河县',
        post_code: '731300',
        area_code: '0930',
        ctime: '2019-07-11 16:59:53'
      },
      {
        id: 647,
        pid: 68,
        city_code: '101161105',
        city_name: '和政县',
        post_code: '731200',
        area_code: '0930',
        ctime: '2019-07-11 16:59:55'
      },
      {
        id: 648,
        pid: 68,
        city_code: '101161106',
        city_name: '东乡族自治县',
        post_code: '731400',
        area_code: '0930',
        ctime: '2019-07-11 16:59:56'
      },
      {
        id: 649,
        pid: 68,
        city_code: '101161107',
        city_name: '积石山',
        post_code: '731700',
        area_code: '0930',
        ctime: '2019-07-11 17:32:37'
      },
      {
        id: 650,
        pid: 69,
        city_code: '101161002',
        city_name: '成县',
        post_code: '742500',
        area_code: '0939',
        ctime: '2019-07-11 16:59:57'
      },
      {
        id: 651,
        pid: 69,
        city_code: '101161008',
        city_name: '徽县',
        post_code: '742300',
        area_code: '0939',
        ctime: '2019-07-11 16:59:58'
      },
      {
        id: 652,
        pid: 69,
        city_code: '101161005',
        city_name: '康县',
        post_code: '746500',
        area_code: '0939',
        ctime: '2019-07-11 17:00:00'
      },
      {
        id: 653,
        pid: 69,
        city_code: '101161007',
        city_name: '礼县',
        post_code: '742200',
        area_code: '0939',
        ctime: '2019-07-11 17:00:01'
      },
      {
        id: 654,
        pid: 69,
        city_code: '101161009',
        city_name: '两当县',
        post_code: '742400',
        area_code: '0939',
        ctime: '2019-07-11 17:00:02'
      },
      {
        id: 655,
        pid: 69,
        city_code: '101161003',
        city_name: '文县',
        post_code: '746400',
        area_code: '0939',
        ctime: '2019-07-11 17:00:03'
      },
      {
        id: 656,
        pid: 69,
        city_code: '101161006',
        city_name: '西和县',
        post_code: '742100',
        area_code: '0939',
        ctime: '2019-07-11 17:00:05'
      },
      {
        id: 657,
        pid: 69,
        city_code: '101161004',
        city_name: '宕昌县',
        post_code: '748500',
        area_code: '0939',
        ctime: '2019-07-11 17:00:06'
      },
      {
        id: 658,
        pid: 69,
        city_code: '101161001',
        city_name: '武都区',
        post_code: '746000',
        area_code: '国内：0939|国际：+86939',
        ctime: '2019-07-11 17:00:07'
      },
      {
        id: 659,
        pid: 70,
        city_code: '101160304',
        city_name: '崇信县',
        post_code: '744200',
        area_code: '0933',
        ctime: '2019-07-11 17:00:08'
      },
      {
        id: 660,
        pid: 70,
        city_code: '101160305',
        city_name: '华亭县',
        post_code: '744100',
        area_code: '0933',
        ctime: '2019-07-11 17:00:10'
      },
      {
        id: 661,
        pid: 70,
        city_code: '101160307',
        city_name: '静宁县',
        post_code: '743400',
        area_code: '0933',
        ctime: '2019-07-11 17:00:11'
      },
      {
        id: 662,
        pid: 70,
        city_code: '101160303',
        city_name: '灵台县',
        post_code: '744400',
        area_code: '0933',
        ctime: '2019-07-11 17:00:12'
      },
      {
        id: 663,
        pid: 70,
        city_code: '101160308',
        city_name: '崆峒区',
        post_code: '744000',
        area_code: '0933',
        ctime: '2019-07-11 17:00:13'
      },
      {
        id: 664,
        pid: 70,
        city_code: '101160306',
        city_name: '庄浪县',
        post_code: '744600',
        area_code: '0933',
        ctime: '2019-07-11 17:00:14'
      },
      {
        id: 665,
        pid: 70,
        city_code: '101160302',
        city_name: '泾川县',
        post_code: '744300',
        area_code: '0933',
        ctime: '2019-07-11 17:00:16'
      },
      {
        id: 666,
        pid: 71,
        city_code: '101160405',
        city_name: '合水县',
        post_code: '745400',
        area_code: '0934',
        ctime: '2019-07-11 17:00:17'
      },
      {
        id: 667,
        pid: 71,
        city_code: '101160404',
        city_name: '华池县',
        post_code: '745600',
        area_code: '0934',
        ctime: '2019-07-11 17:00:18'
      },
      {
        id: 668,
        pid: 71,
        city_code: '101160403',
        city_name: '环县',
        post_code: '745700',
        area_code: '0934',
        ctime: '2019-07-11 17:00:19'
      },
      {
        id: 669,
        pid: 71,
        city_code: '101160407',
        city_name: '宁县',
        post_code: '745200',
        area_code: '0934',
        ctime: '2019-07-11 17:00:21'
      },
      {
        id: 670,
        pid: 71,
        city_code: '101160409',
        city_name: '庆城县',
        post_code: '745100',
        area_code: '0934',
        ctime: '2019-07-11 17:00:22'
      },
      {
        id: 671,
        pid: 71,
        city_code: '101160402',
        city_name: '西峰区',
        post_code: '745000',
        area_code: '0934',
        ctime: '2019-07-11 17:00:23'
      },
      {
        id: 672,
        pid: 71,
        city_code: '101160408',
        city_name: '镇原县',
        post_code: '744500',
        area_code: '0934',
        ctime: '2019-07-11 17:00:24'
      },
      {
        id: 673,
        pid: 71,
        city_code: '101160406',
        city_name: '正宁县',
        post_code: '745300',
        area_code: '0934',
        ctime: '2019-07-11 17:00:26'
      },
      {
        id: 674,
        pid: 72,
        city_code: '101160905',
        city_name: '甘谷县',
        post_code: '741200',
        area_code: '0938',
        ctime: '2019-07-11 17:00:27'
      },
      {
        id: 675,
        pid: 72,
        city_code: '101160904',
        city_name: '秦安县',
        post_code: '741600',
        area_code: '0938',
        ctime: '2019-07-11 17:00:28'
      },
      {
        id: 676,
        pid: 72,
        city_code: '101160903',
        city_name: '清水县',
        post_code: '741400',
        area_code: '0938',
        ctime: '2019-07-11 17:00:29'
      },
      {
        id: 678,
        pid: 72,
        city_code: '101160908',
        city_name: '麦积区',
        post_code: '741020',
        area_code: '0938',
        ctime: '2019-07-11 17:00:31'
      },
      {
        id: 679,
        pid: 72,
        city_code: '101160906',
        city_name: '武山县',
        post_code: '741300',
        area_code: '0938',
        ctime: '2019-07-11 17:00:32'
      },
      {
        id: 680,
        pid: 72,
        city_code: '101160907',
        city_name: '张家川',
        post_code: '741500',
        area_code: '0938',
        ctime: '2019-07-11 17:32:38'
      },
      {
        id: 681,
        pid: 73,
        city_code: '101160503',
        city_name: '古浪县',
        post_code: '733100',
        area_code: '0935',
        ctime: '2019-07-11 17:00:33'
      },
      {
        id: 682,
        pid: 73,
        city_code: '101160502',
        city_name: '民勤县',
        post_code: '733300',
        area_code: '0935',
        ctime: '2019-07-11 17:00:34'
      },
      {
        id: 683,
        pid: 73,
        city_code: '101160505',
        city_name: '天祝县',
        post_code: '733200',
        area_code: '0935',
        ctime: '2019-07-11 17:00:35'
      },
      {
        id: 685,
        pid: 74,
        city_code: '101160705',
        city_name: '高台县',
        post_code: '734300',
        area_code: '0936',
        ctime: '2019-07-11 17:00:37'
      },
      {
        id: 686,
        pid: 74,
        city_code: '101160704',
        city_name: '临泽县',
        post_code: '734200',
        area_code: '0936',
        ctime: '2019-07-11 17:00:38'
      },
      {
        id: 687,
        pid: 74,
        city_code: '101160703',
        city_name: '民乐县',
        post_code: '734500',
        area_code: '0936',
        ctime: '2019-07-11 17:00:39'
      },
      {
        id: 688,
        pid: 74,
        city_code: '101160706',
        city_name: '山丹县',
        post_code: '734100',
        area_code: '0936',
        ctime: '2019-07-11 17:00:41'
      },
      {
        id: 689,
        pid: 74,
        city_code: '101160702',
        city_name: '肃南县',
        post_code: '734400',
        area_code: '0936',
        ctime: '2019-07-11 17:00:42'
      },
      {
        id: 691,
        pid: 75,
        city_code: '101280103',
        city_name: '从化区',
        post_code: '510900',
        area_code: '020',
        ctime: '2019-07-11 17:00:43'
      },
      {
        id: 692,
        pid: 75,
        city_code: '101280109',
        city_name: '天河区',
        post_code: '510000',
        area_code: '020',
        ctime: '2019-07-11 17:00:44'
      },
      {
        id: 699,
        pid: 75,
        city_code: '101280102',
        city_name: '番禺区',
        post_code: '511400',
        area_code: '020',
        ctime: '2019-07-11 17:00:46'
      },
      {
        id: 700,
        pid: 75,
        city_code: '101280105',
        city_name: '花都区',
        post_code: '510800',
        area_code: '020',
        ctime: '2019-07-11 17:00:47'
      },
      {
        id: 701,
        pid: 75,
        city_code: '101280104',
        city_name: '增城区',
        post_code: '511300',
        area_code: '020',
        ctime: '2019-07-11 17:00:48'
      },
      {
        id: 706,
        pid: 76,
        city_code: '101280604',
        city_name: '南山区',
        post_code: '518000',
        area_code: '0755',
        ctime: '2019-07-11 17:00:49'
      },
      {
        id: 711,
        pid: 77,
        city_code: '101281503',
        city_name: '潮安区',
        post_code: '515638',
        area_code: '0768',
        ctime: '2019-07-11 16:24:00'
      },
      {
        id: 712,
        pid: 77,
        city_code: '101281502',
        city_name: '饶平县',
        post_code: '515700',
        area_code: '0768',
        ctime: '2019-07-11 17:00:50'
      },
      {
        id: 746,
        pid: 79,
        city_code: '101280803',
        city_name: '南海区',
        post_code: '528200',
        area_code: '+86-757',
        ctime: '2019-07-11 17:00:52'
      },
      {
        id: 747,
        pid: 79,
        city_code: '101280801',
        city_name: '顺德区',
        post_code: '528300',
        area_code: '757',
        ctime: '2019-07-11 17:00:53'
      },
      {
        id: 748,
        pid: 79,
        city_code: '101280802',
        city_name: '三水区',
        post_code: '528100',
        area_code: '+86-757',
        ctime: '2019-07-11 17:00:54'
      },
      {
        id: 749,
        pid: 79,
        city_code: '101280804',
        city_name: '高明区',
        post_code: '528500',
        area_code: '+86-0757',
        ctime: '2019-07-11 17:00:55'
      },
      {
        id: 750,
        pid: 80,
        city_code: '101281206',
        city_name: '东源县',
        post_code: '517500',
        area_code: '0762',
        ctime: '2019-07-11 17:00:57'
      },
      {
        id: 751,
        pid: 80,
        city_code: '101281204',
        city_name: '和平县',
        post_code: '517200',
        area_code: '0762',
        ctime: '2019-07-11 17:00:58'
      },
      {
        id: 753,
        pid: 80,
        city_code: '101281203',
        city_name: '连平县',
        post_code: '517100',
        area_code: '0762',
        ctime: '2019-07-11 17:00:59'
      },
      {
        id: 754,
        pid: 80,
        city_code: '101281205',
        city_name: '龙川县',
        post_code: '517300',
        area_code: '0762',
        ctime: '2019-07-11 17:01:00'
      },
      {
        id: 755,
        pid: 80,
        city_code: '101281202',
        city_name: '紫金县',
        post_code: '517400',
        area_code: '0762',
        ctime: '2019-07-11 17:01:02'
      },
      {
        id: 756,
        pid: 81,
        city_code: '101280303',
        city_name: '惠阳区',
        post_code: '516200',
        area_code: '0752',
        ctime: '2019-07-11 17:01:03'
      },
      {
        id: 759,
        pid: 81,
        city_code: '101280302',
        city_name: '博罗县',
        post_code: '516100',
        area_code: '0752',
        ctime: '2019-07-11 17:01:04'
      },
      {
        id: 760,
        pid: 81,
        city_code: '101280304',
        city_name: '惠东县',
        post_code: '516300',
        area_code: '0752',
        ctime: '2019-07-11 17:01:05'
      },
      {
        id: 761,
        pid: 81,
        city_code: '101280305',
        city_name: '龙门县',
        post_code: '516800',
        area_code: '0752',
        ctime: '2019-07-11 17:01:06'
      },
      {
        id: 762,
        pid: 82,
        city_code: '101281109',
        city_name: '江海区',
        post_code: '529000',
        area_code: '0750',
        ctime: '2019-07-11 17:01:08'
      },
      {
        id: 763,
        pid: 82,
        city_code: '101281107',
        city_name: '蓬江区',
        post_code: '529000',
        area_code: '0750',
        ctime: '2019-07-11 17:01:09'
      },
      {
        id: 764,
        pid: 82,
        city_code: '101281104',
        city_name: '新会区',
        post_code: '529100',
        area_code: '0750',
        ctime: '2019-07-11 17:01:10'
      },
      {
        id: 765,
        pid: 82,
        city_code: '101281106',
        city_name: '台山市',
        post_code: '529200',
        area_code: '0750',
        ctime: '2019-07-11 17:01:11'
      },
      {
        id: 766,
        pid: 82,
        city_code: '101281103',
        city_name: '开平市',
        post_code: '529300',
        area_code: '0750',
        ctime: '2019-07-11 17:01:13'
      },
      {
        id: 767,
        pid: 82,
        city_code: '101281108',
        city_name: '鹤山市',
        post_code: '529700',
        area_code: '0750',
        ctime: '2019-07-11 17:01:14'
      },
      {
        id: 768,
        pid: 82,
        city_code: '101281105',
        city_name: '恩平市',
        post_code: '529400',
        area_code: '0750',
        ctime: '2019-07-11 17:01:15'
      },
      {
        id: 770,
        pid: 83,
        city_code: '101281903',
        city_name: '普宁市',
        post_code: '515300',
        area_code: '0663',
        ctime: '2019-07-11 17:01:16'
      },
      {
        id: 771,
        pid: 83,
        city_code: '101281905',
        city_name: '揭东区',
        post_code: '515500',
        area_code: '0663',
        ctime: '2019-07-11 21:24:03'
      },
      {
        id: 772,
        pid: 83,
        city_code: '101281902',
        city_name: '揭西县',
        post_code: '515400',
        area_code: '0663',
        ctime: '2019-07-11 17:01:18'
      },
      {
        id: 773,
        pid: 83,
        city_code: '101281904',
        city_name: '惠来县',
        post_code: '515200',
        area_code: '0663',
        ctime: '2019-07-11 17:01:19'
      },
      {
        id: 775,
        pid: 84,
        city_code: '101282006',
        city_name: '茂港',
        post_code: '525027',
        area_code: '0668',
        ctime: '2019-07-11 21:24:04'
      },
      {
        id: 776,
        pid: 84,
        city_code: '101282002',
        city_name: '高州市',
        post_code: '525200',
        area_code: '0668',
        ctime: '2019-07-11 17:01:20'
      },
      {
        id: 777,
        pid: 84,
        city_code: '101282003',
        city_name: '化州市',
        post_code: '525100',
        area_code: '0668',
        ctime: '2019-07-11 17:01:21'
      },
      {
        id: 778,
        pid: 84,
        city_code: '101282005',
        city_name: '信宜市',
        post_code: '525300',
        area_code: '0668',
        ctime: '2019-07-11 17:01:23'
      },
      {
        id: 779,
        pid: 84,
        city_code: '101282004',
        city_name: '电白区',
        post_code: '525400',
        area_code: '0668',
        ctime: '2019-07-11 21:24:04'
      },
      {
        id: 780,
        pid: 85,
        city_code: '101280409',
        city_name: '梅县区',
        post_code: '514700',
        area_code: '0753',
        ctime: '2019-07-11 21:24:04'
      },
      {
        id: 782,
        pid: 85,
        city_code: '101280402',
        city_name: '兴宁市',
        post_code: '514500',
        area_code: '0753',
        ctime: '2019-07-11 17:01:24'
      },
      {
        id: 783,
        pid: 85,
        city_code: '101280404',
        city_name: '大埔县',
        post_code: '514200',
        area_code: '0753',
        ctime: '2019-07-11 17:01:25'
      },
      {
        id: 784,
        pid: 85,
        city_code: '101280406',
        city_name: '丰顺县',
        post_code: '514300',
        area_code: '0753',
        ctime: '2019-07-11 17:01:26'
      },
      {
        id: 785,
        pid: 85,
        city_code: '101280408',
        city_name: '五华县',
        post_code: '514400',
        area_code: '0753',
        ctime: '2019-07-11 17:01:28'
      },
      {
        id: 786,
        pid: 85,
        city_code: '101280407',
        city_name: '平远县',
        post_code: '514600',
        area_code: '0753',
        ctime: '2019-07-11 17:01:29'
      },
      {
        id: 787,
        pid: 85,
        city_code: '101280403',
        city_name: '蕉岭县',
        post_code: '514100',
        area_code: '0753',
        ctime: '2019-07-11 17:01:30'
      },
      {
        id: 789,
        pid: 86,
        city_code: '101281307',
        city_name: '英德市',
        post_code: '513000',
        area_code: '0763',
        ctime: '2019-07-11 17:01:31'
      },
      {
        id: 790,
        pid: 86,
        city_code: '101281303',
        city_name: '连州市',
        post_code: '513400',
        area_code: '0763',
        ctime: '2019-07-11 17:01:32'
      },
      {
        id: 791,
        pid: 86,
        city_code: '101281306',
        city_name: '佛冈县',
        post_code: '511600',
        area_code: '0763',
        ctime: '2019-07-11 17:01:34'
      },
      {
        id: 792,
        pid: 86,
        city_code: '101281305',
        city_name: '阳山县',
        post_code: '513100',
        area_code: '0763',
        ctime: '2019-07-11 17:01:35'
      },
      {
        id: 793,
        pid: 86,
        city_code: '101281308',
        city_name: '清新区',
        post_code: '511800',
        area_code: '0763',
        ctime: '2019-07-11 21:24:05'
      },
      {
        id: 794,
        pid: 86,
        city_code: '101281304',
        city_name: '连山县',
        post_code: '513200',
        area_code: '0763',
        ctime: '2019-07-11 17:01:36'
      },
      {
        id: 795,
        pid: 86,
        city_code: '101281302',
        city_name: '连南县',
        post_code: '513300',
        area_code: '0763',
        ctime: '2019-07-11 17:01:37'
      },
      {
        id: 796,
        pid: 87,
        city_code: '101280504',
        city_name: '南澳县',
        post_code: '515900',
        area_code: '0754',
        ctime: '2019-07-11 17:01:39'
      },
      {
        id: 797,
        pid: 87,
        city_code: '101280502',
        city_name: '潮阳区',
        post_code: '515100',
        area_code: '0754',
        ctime: '2019-07-11 17:01:40'
      },
      {
        id: 798,
        pid: 87,
        city_code: '101280503',
        city_name: '澄海区',
        post_code: '515800',
        area_code: '0754',
        ctime: '2019-07-11 17:01:41'
      },
      {
        id: 804,
        pid: 88,
        city_code: '101282103',
        city_name: '陆丰市',
        post_code: '516500',
        area_code: '0660',
        ctime: '2019-07-11 17:01:42'
      },
      {
        id: 805,
        pid: 88,
        city_code: '101282102',
        city_name: '海丰县',
        post_code: '516400',
        area_code: '0660',
        ctime: '2019-07-11 17:01:44'
      },
      {
        id: 806,
        pid: 88,
        city_code: '101282104',
        city_name: '陆河县',
        post_code: '516700',
        area_code: '0660',
        ctime: '2019-07-11 17:01:45'
      },
      {
        id: 807,
        pid: 89,
        city_code: '101280209',
        city_name: '曲江区',
        post_code: '512100',
        area_code: '0751',
        ctime: '2019-07-11 17:01:46'
      },
      {
        id: 808,
        pid: 89,
        city_code: '101280210',
        city_name: '浈江区',
        post_code: '512023',
        area_code: '0751',
        ctime: '2019-07-11 17:01:47'
      },
      {
        id: 809,
        pid: 89,
        city_code: '101280211',
        city_name: '武江区',
        post_code: '512026',
        area_code: '0751',
        ctime: '2019-07-11 17:01:48'
      },
      {
        id: 811,
        pid: 89,
        city_code: '101280205',
        city_name: '乐昌市',
        post_code: '512200',
        area_code: '0751',
        ctime: '2019-07-11 17:01:51'
      },
      {
        id: 812,
        pid: 89,
        city_code: '101280207',
        city_name: '南雄市',
        post_code: '512400',
        area_code: '0751',
        ctime: '2019-07-11 17:01:52'
      },
      {
        id: 813,
        pid: 89,
        city_code: '101280203',
        city_name: '始兴县',
        post_code: '512500',
        area_code: '0751',
        ctime: '2019-07-11 17:01:53'
      },
      {
        id: 814,
        pid: 89,
        city_code: '101280206',
        city_name: '仁化县',
        post_code: '512300',
        area_code: '0751',
        ctime: '2019-07-11 17:01:54'
      },
      {
        id: 815,
        pid: 89,
        city_code: '101280204',
        city_name: '翁源县',
        post_code: '512600',
        area_code: '0751',
        ctime: '2019-07-11 17:01:56'
      },
      {
        id: 816,
        pid: 89,
        city_code: '101280208',
        city_name: '新丰县',
        post_code: '511100',
        area_code: '0751',
        ctime: '2019-07-11 17:01:57'
      },
      {
        id: 817,
        pid: 89,
        city_code: '101280202',
        city_name: '乳源县',
        post_code: '512700',
        area_code: '0751',
        ctime: '2019-07-11 17:01:58'
      },
      {
        id: 819,
        pid: 90,
        city_code: '101281802',
        city_name: '阳春市',
        post_code: '529600',
        area_code: '0662',
        ctime: '2019-07-11 17:01:59'
      },
      {
        id: 820,
        pid: 90,
        city_code: '101281804',
        city_name: '阳西县',
        post_code: '529800',
        area_code: '0662',
        ctime: '2019-07-11 17:02:01'
      },
      {
        id: 821,
        pid: 90,
        city_code: '101281803',
        city_name: '阳东区',
        post_code: '529900',
        area_code: '0662',
        ctime: '2019-07-11 21:24:05'
      },
      {
        id: 823,
        pid: 91,
        city_code: '101281402',
        city_name: '罗定市',
        post_code: '527200',
        area_code: '0766',
        ctime: '2019-07-11 17:02:02'
      },
      {
        id: 824,
        pid: 91,
        city_code: '101281403',
        city_name: '新兴县',
        post_code: '527400',
        area_code: '0766',
        ctime: '2019-07-11 17:02:03'
      },
      {
        id: 825,
        pid: 91,
        city_code: '101281404',
        city_name: '郁南县',
        post_code: '527100',
        area_code: '0766',
        ctime: '2019-07-11 17:02:04'
      },
      {
        id: 826,
        pid: 91,
        city_code: '101281406',
        city_name: '云安区',
        post_code: '527500',
        area_code: '0766',
        ctime: '2019-07-11 21:24:05'
      },
      {
        id: 827,
        pid: 92,
        city_code: '101281006',
        city_name: '赤坎区',
        post_code: '524033',
        area_code: '0759',
        ctime: '2019-07-11 17:02:05'
      },
      {
        id: 828,
        pid: 92,
        city_code: '101281009',
        city_name: '霞山区',
        post_code: '524002',
        area_code: '0759',
        ctime: '2019-07-11 17:02:07'
      },
      {
        id: 829,
        pid: 92,
        city_code: '101281008',
        city_name: '坡头区',
        post_code: '524057',
        area_code: '0759',
        ctime: '2019-07-11 17:02:08'
      },
      {
        id: 830,
        pid: 92,
        city_code: '101281010',
        city_name: '麻章区',
        post_code: '524003',
        area_code: '0759',
        ctime: '2019-07-11 17:02:09'
      },
      {
        id: 831,
        pid: 92,
        city_code: '101281005',
        city_name: '廉江市',
        post_code: '524400',
        area_code: '0759',
        ctime: '2019-07-11 17:02:10'
      },
      {
        id: 832,
        pid: 92,
        city_code: '101281003',
        city_name: '雷州市',
        post_code: '524200',
        area_code: '0759',
        ctime: '2019-07-11 17:02:12'
      },
      {
        id: 833,
        pid: 92,
        city_code: '101281002',
        city_name: '吴川市',
        post_code: '524500',
        area_code: '0759',
        ctime: '2019-07-11 17:02:13'
      },
      {
        id: 834,
        pid: 92,
        city_code: '101281007',
        city_name: '遂溪县',
        post_code: '524300',
        area_code: '0759',
        ctime: '2019-07-11 17:02:14'
      },
      {
        id: 835,
        pid: 92,
        city_code: '101281004',
        city_name: '徐闻县',
        post_code: '524100',
        area_code: '0759',
        ctime: '2019-07-11 17:02:15'
      },
      {
        id: 837,
        pid: 93,
        city_code: '101280908',
        city_name: '高要区',
        post_code: '526100',
        area_code: '0758',
        ctime: '2019-07-11 17:02:17'
      },
      {
        id: 838,
        pid: 93,
        city_code: '101280903',
        city_name: '四会市',
        post_code: '526200',
        area_code: '0758',
        ctime: '2019-07-11 17:02:18'
      },
      {
        id: 839,
        pid: 93,
        city_code: '101280902',
        city_name: '广宁县',
        post_code: '526300',
        area_code: '0758',
        ctime: '2019-07-11 17:02:19'
      },
      {
        id: 840,
        pid: 93,
        city_code: '101280906',
        city_name: '怀集县',
        post_code: '526400',
        area_code: '0758',
        ctime: '2019-07-11 17:02:20'
      },
      {
        id: 841,
        pid: 93,
        city_code: '101280907',
        city_name: '封开县',
        post_code: '526500',
        area_code: '0758',
        ctime: '2019-07-11 17:02:22'
      },
      {
        id: 842,
        pid: 93,
        city_code: '101280905',
        city_name: '德庆县',
        post_code: '526600',
        area_code: '0758',
        ctime: '2019-07-11 17:02:23'
      },
      {
        id: 850,
        pid: 95,
        city_code: '101280702',
        city_name: '斗门区',
        post_code: '519100',
        area_code: '0756',
        ctime: '2019-07-11 17:21:21'
      },
      {
        id: 851,
        pid: 95,
        city_code: '101280703',
        city_name: '金湾区',
        post_code: '519090',
        area_code: '0756',
        ctime: '2019-07-11 17:02:24'
      },
      {
        id: 852,
        pid: 96,
        city_code: '101300103',
        city_name: '邕宁区',
        post_code: '530200',
        area_code: '0771',
        ctime: '2019-07-11 17:02:25'
      },
      {
        id: 858,
        pid: 96,
        city_code: '101300108',
        city_name: '武鸣区',
        post_code: '530100',
        area_code: '0771',
        ctime: '2019-07-11 21:24:06'
      },
      {
        id: 859,
        pid: 96,
        city_code: '101300105',
        city_name: '隆安县',
        post_code: '532700',
        area_code: '0771',
        ctime: '2019-07-11 17:02:26'
      },
      {
        id: 860,
        pid: 96,
        city_code: '101300106',
        city_name: '马山县',
        post_code: '530600',
        area_code: '0771',
        ctime: '2019-07-11 17:02:28'
      },
      {
        id: 861,
        pid: 96,
        city_code: '101300107',
        city_name: '上林县',
        post_code: '530500',
        area_code: '0771',
        ctime: '2019-07-11 17:02:29'
      },
      {
        id: 862,
        pid: 96,
        city_code: '101300109',
        city_name: '宾阳县',
        post_code: '530400',
        area_code: '0771',
        ctime: '2019-07-11 17:02:30'
      },
      {
        id: 863,
        pid: 96,
        city_code: '101300104',
        city_name: '横县',
        post_code: '530300',
        area_code: '0771',
        ctime: '2019-07-11 17:02:31'
      },
      {
        id: 869,
        pid: 97,
        city_code: '101300510',
        city_name: '阳朔县',
        post_code: '541999',
        area_code: '0773',
        ctime: '2019-07-11 17:02:33'
      },
      {
        id: 870,
        pid: 97,
        city_code: '101300505',
        city_name: '临桂区',
        post_code: '541199',
        area_code: '0773',
        ctime: '2019-07-11 21:24:06'
      },
      {
        id: 871,
        pid: 97,
        city_code: '101300507',
        city_name: '灵川县',
        post_code: '541200',
        area_code: '0773',
        ctime: '2019-07-11 17:02:34'
      },
      {
        id: 872,
        pid: 97,
        city_code: '101300508',
        city_name: '全州县',
        post_code: '541500',
        area_code: '0773',
        ctime: '2019-07-11 17:02:35'
      },
      {
        id: 873,
        pid: 97,
        city_code: '101300512',
        city_name: '平乐县',
        post_code: '542400',
        area_code: '0773',
        ctime: '2019-07-11 17:02:36'
      },
      {
        id: 874,
        pid: 97,
        city_code: '101300506',
        city_name: '兴安县',
        post_code: '541300',
        area_code: '0773',
        ctime: '2019-07-11 17:02:37'
      },
      {
        id: 875,
        pid: 97,
        city_code: '101300509',
        city_name: '灌阳县',
        post_code: '541600',
        area_code: '0773',
        ctime: '2019-07-11 17:02:39'
      },
      {
        id: 876,
        pid: 97,
        city_code: '101300513',
        city_name: '荔浦县',
        post_code: '546600',
        area_code: '0773—7237026',
        ctime: '2019-07-11 17:02:40'
      },
      {
        id: 877,
        pid: 97,
        city_code: '101300514',
        city_name: '资源县',
        post_code: '541400',
        area_code: '0773',
        ctime: '2019-07-11 17:02:41'
      },
      {
        id: 878,
        pid: 97,
        city_code: '101300504',
        city_name: '永福县',
        post_code: '541899',
        area_code: '0773',
        ctime: '2019-07-11 17:02:42'
      },
      {
        id: 879,
        pid: 97,
        city_code: '101300503',
        city_name: '龙胜县',
        post_code: '541799',
        area_code: '0773',
        ctime: '2019-07-11 17:02:44'
      },
      {
        id: 880,
        pid: 97,
        city_code: '101300511',
        city_name: '恭城县',
        post_code: '542500',
        area_code: '0773',
        ctime: '2019-07-11 17:02:45'
      },
      {
        id: 882,
        pid: 98,
        city_code: '101301011',
        city_name: '凌云县',
        post_code: '533100',
        area_code: '0776',
        ctime: '2019-07-11 17:02:47'
      },
      {
        id: 883,
        pid: 98,
        city_code: '101301007',
        city_name: '平果县',
        post_code: '531400',
        area_code: '0776',
        ctime: '2019-07-11 17:02:48'
      },
      {
        id: 884,
        pid: 98,
        city_code: '101301009',
        city_name: '西林县',
        post_code: '533500',
        area_code: '0776',
        ctime: '2019-07-11 17:02:49'
      },
      {
        id: 885,
        pid: 98,
        city_code: '101301010',
        city_name: '乐业县',
        post_code: '533200',
        area_code: '0776',
        ctime: '2019-07-11 17:02:50'
      },
      {
        id: 886,
        pid: 98,
        city_code: '101301004',
        city_name: '德保县',
        post_code: '533700',
        area_code: '0776(百色)',
        ctime: '2019-07-11 17:02:51'
      },
      {
        id: 887,
        pid: 98,
        city_code: '101301012',
        city_name: '田林县',
        post_code: '533300',
        area_code: '0776',
        ctime: '2019-07-11 17:02:54'
      },
      {
        id: 888,
        pid: 98,
        city_code: '101301003',
        city_name: '田阳县',
        post_code: '533600',
        area_code: '0776',
        ctime: '2019-07-11 17:02:55'
      },
      {
        id: 889,
        pid: 98,
        city_code: '101301005',
        city_name: '靖西市',
        post_code: '533800',
        area_code: '0776',
        ctime: '2019-07-11 21:24:06'
      },
      {
        id: 890,
        pid: 98,
        city_code: '101301006',
        city_name: '田东县',
        post_code: '531500',
        area_code: '0776',
        ctime: '2019-07-11 17:02:56'
      },
      {
        id: 891,
        pid: 98,
        city_code: '101301002',
        city_name: '那坡县',
        post_code: '533900',
        area_code: '0776',
        ctime: '2019-07-11 17:02:57'
      },
      {
        id: 892,
        pid: 98,
        city_code: '101301008',
        city_name: '隆林县',
        post_code: '533500',
        area_code: '0776',
        ctime: '2019-07-11 16:49:55'
      },
      {
        id: 896,
        pid: 99,
        city_code: '101301302',
        city_name: '合浦县',
        post_code: '536100',
        area_code: '0779',
        ctime: '2019-07-11 16:49:56'
      },
      {
        id: 898,
        pid: 100,
        city_code: '101300204',
        city_name: '凭祥市',
        post_code: '532600',
        area_code: '0771',
        ctime: '2019-07-11 16:49:58'
      },
      {
        id: 899,
        pid: 100,
        city_code: '101300207',
        city_name: '宁明县',
        post_code: '532500',
        area_code: '0771',
        ctime: '2019-07-11 16:49:59'
      },
      {
        id: 900,
        pid: 100,
        city_code: '101300206',
        city_name: '扶绥县',
        post_code: '532100',
        area_code: '0771',
        ctime: '2019-07-11 16:50:00'
      },
      {
        id: 901,
        pid: 100,
        city_code: '101300203',
        city_name: '龙州县',
        post_code: '532400',
        area_code: '0771',
        ctime: '2019-07-11 16:50:01'
      },
      {
        id: 902,
        pid: 100,
        city_code: '101300205',
        city_name: '大新县',
        post_code: '532300',
        area_code: '0771',
        ctime: '2019-07-11 16:50:02'
      },
      {
        id: 903,
        pid: 100,
        city_code: '101300202',
        city_name: '天等县',
        post_code: '532800',
        area_code: '0771',
        ctime: '2019-07-11 16:50:03'
      },
      {
        id: 905,
        pid: 101,
        city_code: '101301405',
        city_name: '防城区',
        post_code: '538000',
        area_code: '0770',
        ctime: '2019-07-11 16:50:04'
      },
      {
        id: 906,
        pid: 101,
        city_code: '101301403',
        city_name: '东兴市',
        post_code: '538100',
        area_code: '0770',
        ctime: '2019-07-11 16:50:05'
      },
      {
        id: 907,
        pid: 101,
        city_code: '101301402',
        city_name: '上思县',
        post_code: '535500',
        area_code: '0770',
        ctime: '2019-07-11 17:21:28'
      },
      {
        id: 911,
        pid: 102,
        city_code: '101300802',
        city_name: '桂平市',
        post_code: '537200',
        area_code: '0775',
        ctime: '2019-07-11 16:50:05'
      },
      {
        id: 912,
        pid: 102,
        city_code: '101300803',
        city_name: '平南县',
        post_code: '537300',
        area_code: '0775',
        ctime: '2019-07-11 16:50:06'
      },
      {
        id: 914,
        pid: 103,
        city_code: '101301207',
        city_name: '宜州市',
        post_code: '546300',
        area_code: '0778',
        ctime: '2019-07-11 16:50:09'
      },
      {
        id: 915,
        pid: 103,
        city_code: '101301202',
        city_name: '天峨县',
        post_code: '547300',
        area_code: '0778',
        ctime: '2019-07-11 16:50:10'
      },
      {
        id: 916,
        pid: 103,
        city_code: '101301208',
        city_name: '凤山县',
        post_code: '547600',
        area_code: '0778',
        ctime: '2019-07-11 16:50:11'
      },
      {
        id: 917,
        pid: 103,
        city_code: '101301209',
        city_name: '南丹县',
        post_code: '547200',
        area_code: '0778',
        ctime: '2019-07-11 16:50:11'
      },
      {
        id: 918,
        pid: 103,
        city_code: '101301203',
        city_name: '东兰县',
        post_code: '547400',
        area_code: '0778',
        ctime: '2019-07-11 16:50:11'
      },
      {
        id: 919,
        pid: 103,
        city_code: '101301210',
        city_name: '都安县',
        post_code: '530700',
        area_code: '0778',
        ctime: '2019-07-11 16:50:12'
      },
      {
        id: 920,
        pid: 103,
        city_code: '101301206',
        city_name: '罗城县',
        post_code: '546499',
        area_code: '0778',
        ctime: '2019-07-11 16:50:13'
      },
      {
        id: 921,
        pid: 103,
        city_code: '101301204',
        city_name: '巴马县',
        post_code: '547500',
        area_code: '0778',
        ctime: '2019-07-11 16:50:14'
      },
      {
        id: 922,
        pid: 103,
        city_code: '101301205',
        city_name: '环江县',
        post_code: '547100',
        area_code: '0778',
        ctime: '2019-07-11 16:50:14'
      },
      {
        id: 923,
        pid: 103,
        city_code: '101301211',
        city_name: '大化县',
        post_code: '530800',
        area_code: '0778',
        ctime: '2019-07-11 16:50:15'
      },
      {
        id: 925,
        pid: 104,
        city_code: '101300704',
        city_name: '钟山县',
        post_code: '542600',
        area_code: '0774',
        ctime: '2019-07-11 16:50:15'
      },
      {
        id: 926,
        pid: 104,
        city_code: '101300702',
        city_name: '昭平县',
        post_code: '546800',
        area_code: '0774',
        ctime: '2019-07-11 16:50:15'
      },
      {
        id: 927,
        pid: 104,
        city_code: '101300703',
        city_name: '富川县',
        post_code: '542700',
        area_code: '0774',
        ctime: '2019-07-11 16:50:15'
      },
      {
        id: 929,
        pid: 105,
        city_code: '101300406',
        city_name: '合山市',
        post_code: '546500',
        area_code: '0772',
        ctime: '2019-07-11 16:50:17'
      },
      {
        id: 930,
        pid: 105,
        city_code: '101300404',
        city_name: '象州县',
        post_code: '545800',
        area_code: '0772',
        ctime: '2019-07-11 16:50:17'
      },
      {
        id: 931,
        pid: 105,
        city_code: '101300405',
        city_name: '武宣县',
        post_code: '545900',
        area_code: '0772',
        ctime: '2019-07-11 16:50:17'
      },
      {
        id: 932,
        pid: 105,
        city_code: '101300402',
        city_name: '忻城县',
        post_code: '546200',
        area_code: '0772',
        ctime: '2019-07-11 16:50:17'
      },
      {
        id: 933,
        pid: 105,
        city_code: '101300403',
        city_name: '金秀县',
        post_code: '545700',
        area_code: '0772',
        ctime: '2019-07-11 16:50:18'
      },
      {
        id: 938,
        pid: 106,
        city_code: '101300305',
        city_name: '柳江区',
        post_code: '545100',
        area_code: '0772',
        ctime: '2019-07-11 21:24:07'
      },
      {
        id: 939,
        pid: 106,
        city_code: '101300302',
        city_name: '柳城县',
        post_code: '545200',
        area_code: '0772',
        ctime: '2019-07-11 16:50:19'
      },
      {
        id: 940,
        pid: 106,
        city_code: '101300304',
        city_name: '鹿寨县',
        post_code: '545600',
        area_code: '0772',
        ctime: '2019-07-11 16:50:19'
      },
      {
        id: 941,
        pid: 106,
        city_code: '101300306',
        city_name: '融安县',
        post_code: '545400',
        area_code: '0772',
        ctime: '2019-07-11 16:50:19'
      },
      {
        id: 942,
        pid: 106,
        city_code: '101300307',
        city_name: '融水县',
        post_code: '545300',
        area_code: '0772',
        ctime: '2019-07-11 16:50:20'
      },
      {
        id: 943,
        pid: 106,
        city_code: '101300308',
        city_name: '三江县',
        post_code: '545500',
        area_code: '0772',
        ctime: '2019-07-11 16:50:21'
      },
      {
        id: 946,
        pid: 107,
        city_code: '101301103',
        city_name: '灵山县',
        post_code: '535400',
        area_code: '0777',
        ctime: '2019-07-11 16:50:21'
      },
      {
        id: 947,
        pid: 107,
        city_code: '101301102',
        city_name: '浦北县',
        post_code: '535300',
        area_code: '0777',
        ctime: '2019-07-11 16:50:22'
      },
      {
        id: 950,
        pid: 108,
        city_code: '101300607',
        city_name: '长洲区',
        post_code: '543003',
        area_code: '0774',
        ctime: '2019-07-11 16:50:23'
      },
      {
        id: 951,
        pid: 108,
        city_code: '101300606',
        city_name: '岑溪市',
        post_code: '543200',
        area_code: '0774',
        ctime: '2019-07-11 16:50:23'
      },
      {
        id: 952,
        pid: 108,
        city_code: '101300604',
        city_name: '苍梧县',
        post_code: '543100',
        area_code: '0774',
        ctime: '2019-07-11 16:50:23'
      },
      {
        id: 953,
        pid: 108,
        city_code: '101300602',
        city_name: '藤县',
        post_code: '543300',
        area_code: '0774',
        ctime: '2019-07-11 16:50:23'
      },
      {
        id: 954,
        pid: 108,
        city_code: '101300605',
        city_name: '蒙山县',
        post_code: '546700',
        area_code: '0774',
        ctime: '2019-07-11 16:50:25'
      },
      {
        id: 956,
        pid: 109,
        city_code: '101300903',
        city_name: '北流市',
        post_code: '537400',
        area_code: '0775',
        ctime: '2019-07-11 16:50:26'
      },
      {
        id: 957,
        pid: 109,
        city_code: '101300904',
        city_name: '容县',
        post_code: '537500',
        area_code: '0775',
        ctime: '2019-07-11 16:50:26'
      },
      {
        id: 958,
        pid: 109,
        city_code: '101300905',
        city_name: '陆川县',
        post_code: '537700',
        area_code: '0775',
        ctime: '2019-07-11 16:50:27'
      },
      {
        id: 959,
        pid: 109,
        city_code: '101300902',
        city_name: '博白县',
        post_code: '537600',
        area_code: '0775',
        ctime: '2019-07-11 16:50:28'
      },
      {
        id: 960,
        pid: 109,
        city_code: '101300906',
        city_name: '兴业县',
        post_code: '537800',
        area_code: '0775',
        ctime: '2019-07-11 16:50:29'
      },
      {
        id: 961,
        pid: 110,
        city_code: '101260111',
        city_name: '南明区',
        post_code: '550002',
        area_code: '0851',
        ctime: '2019-07-11 16:50:30'
      },
      {
        id: 962,
        pid: 110,
        city_code: '101260110',
        city_name: '云岩区',
        post_code: '550001',
        area_code: '0851',
        ctime: '2019-07-11 16:50:30'
      },
      {
        id: 963,
        pid: 110,
        city_code: '101260103',
        city_name: '花溪区',
        post_code: '550025',
        area_code: '0851',
        ctime: '2019-07-11 16:50:32'
      },
      {
        id: 964,
        pid: 110,
        city_code: '101260104',
        city_name: '乌当区',
        post_code: '550018',
        area_code: '0851',
        ctime: '2019-07-11 16:50:32'
      },
      {
        id: 965,
        pid: 110,
        city_code: '101280110',
        city_name: '白云区',
        post_code: '510080',
        area_code: '020',
        ctime: '2019-07-11 16:50:33'
      },
      {
        id: 966,
        pid: 110,
        city_code: '101260109',
        city_name: '小河',
        post_code: '553009',
        area_code: '0851',
        ctime: '2019-07-11 21:24:07'
      },
      {
        id: 969,
        pid: 110,
        city_code: '101260108',
        city_name: '清镇市',
        post_code: '551400',
        area_code: '0851',
        ctime: '2019-07-11 16:50:35'
      },
      {
        id: 970,
        pid: 110,
        city_code: '101260106',
        city_name: '开阳县',
        post_code: '550300',
        area_code: '0851',
        ctime: '2019-07-11 16:50:35'
      },
      {
        id: 971,
        pid: 110,
        city_code: '101260107',
        city_name: '修文县',
        post_code: '550200',
        area_code: '0851',
        ctime: '2019-07-11 16:50:36'
      },
      {
        id: 972,
        pid: 110,
        city_code: '101260105',
        city_name: '息烽县',
        post_code: '551100',
        area_code: '0851',
        ctime: '2019-07-11 16:50:37'
      },
      {
        id: 974,
        pid: 111,
        city_code: '101260306',
        city_name: '关岭县',
        post_code: '561300',
        area_code: '0853',
        ctime: '2019-07-11 16:50:38'
      },
      {
        id: 976,
        pid: 111,
        city_code: '101260305',
        city_name: '紫云县',
        post_code: '550800',
        area_code: '0853',
        ctime: '2019-07-11 16:50:39'
      },
      {
        id: 977,
        pid: 111,
        city_code: '101260304',
        city_name: '平坝区',
        post_code: '561100',
        area_code: '0851',
        ctime: '2019-07-11 21:24:07'
      },
      {
        id: 978,
        pid: 111,
        city_code: '101260302',
        city_name: '普定县',
        post_code: '562100',
        area_code: '0853',
        ctime: '2019-07-11 16:50:40'
      },
      {
        id: 980,
        pid: 112,
        city_code: '101260705',
        city_name: '大方县',
        post_code: '551600',
        area_code: '0857',
        ctime: '2019-07-11 16:50:40'
      },
      {
        id: 981,
        pid: 112,
        city_code: '101260708',
        city_name: '黔西县',
        post_code: '551500',
        area_code: '0857',
        ctime: '2019-07-11 16:50:41'
      },
      {
        id: 982,
        pid: 112,
        city_code: '101260703',
        city_name: '金沙县',
        post_code: '551800',
        area_code: '0857',
        ctime: '2019-07-11 16:50:41'
      },
      {
        id: 983,
        pid: 112,
        city_code: '101260707',
        city_name: '织金县',
        post_code: '552100',
        area_code: '0857',
        ctime: '2019-07-11 16:50:41'
      },
      {
        id: 984,
        pid: 112,
        city_code: '101260706',
        city_name: '纳雍县',
        post_code: '553300',
        area_code: '0857',
        ctime: '2019-07-11 16:50:41'
      },
      {
        id: 985,
        pid: 112,
        city_code: '101260702',
        city_name: '赫章县',
        post_code: '553200',
        area_code: '0857',
        ctime: '2019-07-11 16:50:42'
      },
      {
        id: 986,
        pid: 112,
        city_code: '101260704',
        city_name: '威宁县',
        post_code: '553100',
        area_code: '0857',
        ctime: '2019-07-11 16:50:42'
      },
      {
        id: 989,
        pid: 113,
        city_code: '101260801',
        city_name: '水城县',
        post_code: '553600',
        area_code: '0858',
        ctime: '2019-07-11 16:50:42'
      },
      {
        id: 990,
        pid: 113,
        city_code: '101260804',
        city_name: '盘县',
        post_code: '553537',
        area_code: '0858',
        ctime: '2019-07-11 16:50:42'
      },
      {
        id: 991,
        pid: 114,
        city_code: '101260501',
        city_name: '凯里市',
        post_code: '556000',
        area_code: '0855',
        ctime: '2019-07-11 16:50:43'
      },
      {
        id: 992,
        pid: 114,
        city_code: '101260505',
        city_name: '黄平县',
        post_code: '556100',
        area_code: '0855',
        ctime: '2019-07-11 16:50:43'
      },
      {
        id: 993,
        pid: 114,
        city_code: '101260503',
        city_name: '施秉县',
        post_code: '556200',
        area_code: '0855',
        ctime: '2019-07-11 16:50:43'
      },
      {
        id: 994,
        pid: 114,
        city_code: '101260509',
        city_name: '三穗县',
        post_code: '556500',
        area_code: '0855',
        ctime: '2019-07-11 16:50:44'
      },
      {
        id: 995,
        pid: 114,
        city_code: '101260504',
        city_name: '镇远县',
        post_code: '557700',
        area_code: '0855',
        ctime: '2019-07-11 16:50:45'
      },
      {
        id: 996,
        pid: 114,
        city_code: '101260502',
        city_name: '岑巩县',
        post_code: '557800',
        area_code: '0855',
        ctime: '2019-07-11 16:50:46'
      },
      {
        id: 997,
        pid: 114,
        city_code: '101260514',
        city_name: '天柱县',
        post_code: '556600',
        area_code: '0855',
        ctime: '2019-07-11 16:50:47'
      },
      {
        id: 998,
        pid: 114,
        city_code: '101260515',
        city_name: '锦屏县',
        post_code: '556700',
        area_code: '0855',
        ctime: '2019-07-11 16:50:48'
      },
      {
        id: 999,
        pid: 114,
        city_code: '101260511',
        city_name: '剑河县',
        post_code: '556400',
        area_code: '0855',
        ctime: '2019-07-11 16:50:52'
      },
      {
        id: 1000,
        pid: 114,
        city_code: '101260510',
        city_name: '台江县',
        post_code: '556300',
        area_code: '0855',
        ctime: '2019-07-11 16:50:52'
      },
      {
        id: 1001,
        pid: 114,
        city_code: '101260513',
        city_name: '黎平县',
        post_code: '557300',
        area_code: '0855',
        ctime: '2019-07-11 16:50:53'
      },
      {
        id: 1002,
        pid: 114,
        city_code: '101260516',
        city_name: '榕江县',
        post_code: '557200',
        area_code: '0855',
        ctime: '2019-07-11 16:50:54'
      },
      {
        id: 1003,
        pid: 114,
        city_code: '101260517',
        city_name: '从江县',
        post_code: '557400',
        area_code: '0855',
        ctime: '2019-07-11 16:50:56'
      },
      {
        id: 1004,
        pid: 114,
        city_code: '101260512',
        city_name: '雷山县',
        post_code: '557100',
        area_code: '0855',
        ctime: '2019-07-11 16:50:56'
      },
      {
        id: 1005,
        pid: 114,
        city_code: '101260507',
        city_name: '麻江县',
        post_code: '557600',
        area_code: '0855',
        ctime: '2019-07-11 16:50:57'
      },
      {
        id: 1006,
        pid: 114,
        city_code: '101260508',
        city_name: '丹寨县',
        post_code: '557500',
        area_code: '0855',
        ctime: '2019-07-11 16:50:58'
      },
      {
        id: 1007,
        pid: 115,
        city_code: '101260401',
        city_name: '都匀市',
        post_code: '558000',
        area_code: '0854',
        ctime: '2019-07-11 16:50:59'
      },
      {
        id: 1008,
        pid: 115,
        city_code: '101260405',
        city_name: '福泉市',
        post_code: '550500',
        area_code: '0854',
        ctime: '2019-07-11 16:51:01'
      },
      {
        id: 1009,
        pid: 115,
        city_code: '101260412',
        city_name: '荔波县',
        post_code: '558400',
        area_code: '0854',
        ctime: '2019-07-11 16:51:01'
      },
      {
        id: 1010,
        pid: 115,
        city_code: '101260402',
        city_name: '贵定县',
        post_code: '551300',
        area_code: '0854',
        ctime: '2019-07-11 16:51:02'
      },
      {
        id: 1011,
        pid: 115,
        city_code: '101260403',
        city_name: '瓮安县',
        post_code: '550400',
        area_code: '0854',
        ctime: '2019-07-11 16:51:02'
      },
      {
        id: 1012,
        pid: 115,
        city_code: '101260410',
        city_name: '独山县',
        post_code: '558200',
        area_code: '0854',
        ctime: '2019-07-11 16:51:04'
      },
      {
        id: 1013,
        pid: 115,
        city_code: '101260409',
        city_name: '平塘县',
        post_code: '558300',
        area_code: '0854',
        ctime: '2019-07-11 16:51:04'
      },
      {
        id: 1014,
        pid: 115,
        city_code: '101260408',
        city_name: '罗甸县',
        post_code: '550100',
        area_code: '0854',
        ctime: '2019-07-11 16:51:05'
      },
      {
        id: 1015,
        pid: 115,
        city_code: '101260404',
        city_name: '长顺县',
        post_code: '550700',
        area_code: '0854',
        ctime: '2019-07-11 16:51:06'
      },
      {
        id: 1016,
        pid: 115,
        city_code: '101260407',
        city_name: '龙里县',
        post_code: '551200',
        area_code: '0854',
        ctime: '2019-07-11 16:51:07'
      },
      {
        id: 1017,
        pid: 115,
        city_code: '101260406',
        city_name: '惠水县',
        post_code: '550600',
        area_code: '0854',
        ctime: '2019-07-11 16:51:07'
      },
      {
        id: 1018,
        pid: 115,
        city_code: '101260411',
        city_name: '三都县',
        post_code: '558100',
        area_code: '0854',
        ctime: '2019-07-11 16:51:07'
      },
      {
        id: 1019,
        pid: 116,
        city_code: '101260901',
        city_name: '兴义市',
        post_code: '562400',
        area_code: '0859',
        ctime: '2019-07-11 16:51:08'
      },
      {
        id: 1020,
        pid: 116,
        city_code: '101260903',
        city_name: '兴仁县',
        post_code: '562300',
        area_code: '0859',
        ctime: '2019-07-11 16:51:08'
      },
      {
        id: 1021,
        pid: 116,
        city_code: '101260909',
        city_name: '普安县',
        post_code: '561500',
        area_code: '0859',
        ctime: '2019-07-11 16:51:09'
      },
      {
        id: 1022,
        pid: 116,
        city_code: '101260902',
        city_name: '晴隆县',
        post_code: '561400',
        area_code: '0859',
        ctime: '2019-07-11 16:51:09'
      },
      {
        id: 1023,
        pid: 116,
        city_code: '101260904',
        city_name: '贞丰县',
        post_code: '562200',
        area_code: '0859',
        ctime: '2019-07-11 16:51:10'
      },
      {
        id: 1024,
        pid: 116,
        city_code: '101260905',
        city_name: '望谟县',
        post_code: '552300',
        area_code: '0859',
        ctime: '2019-07-11 16:51:11'
      },
      {
        id: 1025,
        pid: 116,
        city_code: '101260908',
        city_name: '册亨县',
        post_code: '552200',
        area_code: '0859',
        ctime: '2019-07-11 16:51:11'
      },
      {
        id: 1026,
        pid: 116,
        city_code: '101260907',
        city_name: '安龙县',
        post_code: '552400',
        area_code: '0859',
        ctime: '2019-07-11 16:51:12'
      },
      {
        id: 1028,
        pid: 117,
        city_code: '101260602',
        city_name: '江口县',
        post_code: '554400',
        area_code: '0856',
        ctime: '2019-07-11 16:51:14'
      },
      {
        id: 1029,
        pid: 117,
        city_code: '101260608',
        city_name: '石阡县',
        post_code: '555100',
        area_code: '0856',
        ctime: '2019-07-11 16:51:14'
      },
      {
        id: 1030,
        pid: 117,
        city_code: '101260605',
        city_name: '思南县',
        post_code: '565100',
        area_code: '0856',
        ctime: '2019-07-11 16:51:15'
      },
      {
        id: 1031,
        pid: 117,
        city_code: '101260610',
        city_name: '德江县',
        post_code: '565200',
        area_code: '0856',
        ctime: '2019-07-11 16:51:16'
      },
      {
        id: 1032,
        pid: 117,
        city_code: '101260603',
        city_name: '玉屏县',
        post_code: '554000',
        area_code: '0856',
        ctime: '2019-07-11 16:51:16'
      },
      {
        id: 1033,
        pid: 117,
        city_code: '101260607',
        city_name: '印江县',
        post_code: '555200',
        area_code: '0856',
        ctime: '2019-07-11 16:51:16'
      },
      {
        id: 1034,
        pid: 117,
        city_code: '101260609',
        city_name: '沿河县',
        post_code: '565300',
        area_code: '0856',
        ctime: '2019-07-11 16:51:16'
      },
      {
        id: 1035,
        pid: 117,
        city_code: '101260611',
        city_name: '松桃县',
        post_code: '554100',
        area_code: '0856',
        ctime: '2019-07-11 16:51:17'
      },
      {
        id: 1037,
        pid: 118,
        city_code: '101260215',
        city_name: '红花岗区',
        post_code: '563000',
        area_code: '0852',
        ctime: '2019-07-11 16:51:17'
      },
      {
        id: 1038,
        pid: 118,
        city_code: '101260212',
        city_name: '务川县',
        post_code: '564300',
        area_code: '0852',
        ctime: '2019-07-11 16:51:17'
      },
      {
        id: 1039,
        pid: 118,
        city_code: '101260210',
        city_name: '道真县',
        post_code: '563500',
        area_code: '0851(+2)',
        ctime: '2019-07-11 16:51:18'
      },
      {
        id: 1040,
        pid: 118,
        city_code: '101260214',
        city_name: '汇川区',
        post_code: '563000',
        area_code: '0852',
        ctime: '2019-07-11 16:51:18'
      },
      {
        id: 1041,
        pid: 118,
        city_code: '101260208',
        city_name: '赤水市',
        post_code: '564700',
        area_code: '0852',
        ctime: '2019-07-11 16:51:18'
      },
      {
        id: 1042,
        pid: 118,
        city_code: '101260203',
        city_name: '仁怀市',
        post_code: '564500',
        area_code: '0852',
        ctime: '2019-07-11 16:51:18'
      },
      {
        id: 1043,
        pid: 118,
        city_code: '101260202',
        city_name: '遵义县',
        post_code: '563100',
        area_code: '0851',
        ctime: '2019-07-11 21:24:08'
      },
      {
        id: 1044,
        pid: 118,
        city_code: '101260207',
        city_name: '桐梓县',
        post_code: '563200',
        area_code: '0852',
        ctime: '2019-07-11 16:51:19'
      },
      {
        id: 1045,
        pid: 118,
        city_code: '101260204',
        city_name: '绥阳县',
        post_code: '563300',
        area_code: '0852',
        ctime: '2019-07-11 16:51:19'
      },
      {
        id: 1046,
        pid: 118,
        city_code: '101260211',
        city_name: '正安县',
        post_code: '563400',
        area_code: '0852',
        ctime: '2019-07-11 16:51:19'
      },
      {
        id: 1047,
        pid: 118,
        city_code: '101260206',
        city_name: '凤冈县',
        post_code: '564200',
        area_code: '0852',
        ctime: '2019-07-11 16:51:19'
      },
      {
        id: 1048,
        pid: 118,
        city_code: '101260205',
        city_name: '湄潭县',
        post_code: '564100',
        area_code: '0852',
        ctime: '2019-07-11 16:51:20'
      },
      {
        id: 1049,
        pid: 118,
        city_code: '101260213',
        city_name: '余庆县',
        post_code: '564400',
        area_code: '0852',
        ctime: '2019-07-11 16:51:20'
      },
      {
        id: 1050,
        pid: 118,
        city_code: '101260209',
        city_name: '习水县',
        post_code: '564600',
        area_code: '0852',
        ctime: '2019-07-11 16:51:20'
      },
      {
        id: 1055,
        pid: 119,
        city_code: '101310104',
        city_name: '琼山区',
        post_code: '571199',
        area_code: '0898',
        ctime: '2019-07-11 16:51:20'
      },
      {
        id: 1082,
        pid: 137,
        city_code: '101090122',
        city_name: '井陉矿区',
        post_code: '050100',
        area_code: '0311',
        ctime: '2019-07-11 16:51:21'
      },
      {
        id: 1084,
        pid: 137,
        city_code: '101090114',
        city_name: '辛集市',
        post_code: '052360',
        area_code: '0311',
        ctime: '2019-07-11 16:51:21'
      },
      {
        id: 1085,
        pid: 137,
        city_code: '101090115',
        city_name: '藁城市',
        post_code: '052160、052161',
        area_code: '0311',
        ctime: '2019-07-11 17:32:40'
      },
      {
        id: 1086,
        pid: 137,
        city_code: '101090116',
        city_name: '晋州市',
        post_code: '660-760',
        area_code: '+82-055',
        ctime: '2019-07-11 16:51:21'
      },
      {
        id: 1087,
        pid: 137,
        city_code: '101090117',
        city_name: '新乐市',
        post_code: '050700',
        area_code: '0311',
        ctime: '2019-07-11 16:51:22'
      },
      {
        id: 1088,
        pid: 137,
        city_code: '101090118',
        city_name: '鹿泉区',
        post_code: '050200',
        area_code: '0311',
        ctime: '2019-07-11 16:51:22'
      },
      {
        id: 1089,
        pid: 137,
        city_code: '101090102',
        city_name: '井陉县',
        post_code: '050300',
        area_code: '0311',
        ctime: '2019-07-11 16:51:22'
      },
      {
        id: 1090,
        pid: 137,
        city_code: '101090103',
        city_name: '正定县',
        post_code: '050800',
        area_code: '0311',
        ctime: '2019-07-11 16:51:22'
      },
      {
        id: 1091,
        pid: 137,
        city_code: '101090104',
        city_name: '行唐县',
        post_code: '050600',
        area_code: '0311',
        ctime: '2019-07-11 21:24:08'
      },
      {
        id: 1093,
        pid: 137,
        city_code: '101090106',
        city_name: '灵寿县',
        post_code: '050500',
        area_code: '0311',
        ctime: '2019-07-11 16:51:23'
      },
      {
        id: 1094,
        pid: 137,
        city_code: '101090107',
        city_name: '高邑县',
        post_code: '051330',
        area_code: '0311',
        ctime: '2019-07-11 16:51:23'
      },
      {
        id: 1095,
        pid: 137,
        city_code: '101090108',
        city_name: '深泽县',
        post_code: '052560',
        area_code: '0311',
        ctime: '2019-07-11 16:51:23'
      },
      {
        id: 1096,
        pid: 137,
        city_code: '101090109',
        city_name: '赞皇县',
        post_code: '051230',
        area_code: '0311',
        ctime: '2019-07-11 16:51:24'
      },
      {
        id: 1097,
        pid: 137,
        city_code: '101090110',
        city_name: '无极县',
        post_code: '052460',
        area_code: '0311',
        ctime: '2019-07-11 16:51:24'
      },
      {
        id: 1098,
        pid: 137,
        city_code: '101090111',
        city_name: '平山县',
        post_code: '050400',
        area_code: '0311',
        ctime: '2019-07-11 16:51:24'
      },
      {
        id: 1099,
        pid: 137,
        city_code: '101090112',
        city_name: '元氏县',
        post_code: '051130',
        area_code: '0311',
        ctime: '2019-07-11 16:51:24'
      },
      {
        id: 1100,
        pid: 137,
        city_code: '101090113',
        city_name: '赵县',
        post_code: '051530',
        area_code: '0311',
        ctime: '2019-07-11 16:51:25'
      },
      {
        id: 1104,
        pid: 138,
        city_code: '101090218',
        city_name: '涿州市',
        post_code: '072750',
        area_code: '0312(部分010)',
        ctime: '2019-07-11 16:51:25'
      },
      {
        id: 1105,
        pid: 138,
        city_code: '101090219',
        city_name: '定州市',
        post_code: '073000',
        area_code: '0312',
        ctime: '2019-07-11 16:51:25'
      },
      {
        id: 1106,
        pid: 138,
        city_code: '101090220',
        city_name: '安国市',
        post_code: '071200',
        area_code: '0312',
        ctime: '2019-07-11 16:51:25'
      },
      {
        id: 1107,
        pid: 138,
        city_code: '101090221',
        city_name: '高碑店市',
        post_code: '074000',
        area_code: '0312',
        ctime: '2019-07-11 16:51:26'
      },
      {
        id: 1108,
        pid: 138,
        city_code: '101090202',
        city_name: '满城区',
        post_code: '072150',
        area_code: '0312',
        ctime: '2019-07-11 21:24:08'
      },
      {
        id: 1109,
        pid: 138,
        city_code: '101090224',
        city_name: '清苑区',
        post_code: '071100',
        area_code: '0312',
        ctime: '2019-07-11 21:24:08'
      },
      {
        id: 1110,
        pid: 138,
        city_code: '101090222',
        city_name: '涞水县',
        post_code: '074100',
        area_code: '0312',
        ctime: '2019-07-11 16:51:26'
      },
      {
        id: 1111,
        pid: 138,
        city_code: '101090203',
        city_name: '阜平县',
        post_code: '073200',
        area_code: '0312',
        ctime: '2019-07-11 16:51:26'
      },
      {
        id: 1112,
        pid: 138,
        city_code: '101090204',
        city_name: '徐水区',
        post_code: '072550',
        area_code: '0312',
        ctime: '2019-07-11 21:24:09'
      },
      {
        id: 1113,
        pid: 138,
        city_code: '101090223',
        city_name: '定兴县',
        post_code: '072650',
        area_code: '0312',
        ctime: '2019-07-11 16:51:26'
      },
      {
        id: 1114,
        pid: 138,
        city_code: '101090205',
        city_name: '唐县',
        post_code: '072350',
        area_code: '0312',
        ctime: '2019-07-11 16:51:27'
      },
      {
        id: 1115,
        pid: 138,
        city_code: '101090206',
        city_name: '高阳县',
        post_code: '071500',
        area_code: '0312',
        ctime: '2019-07-11 16:51:27'
      },
      {
        id: 1116,
        pid: 138,
        city_code: '101090207',
        city_name: '容城县',
        post_code: '071700',
        area_code: '0312',
        ctime: '2019-07-11 16:51:28'
      },
      {
        id: 1117,
        pid: 138,
        city_code: '101090209',
        city_name: '涞源县',
        post_code: '074300',
        area_code: '0312',
        ctime: '2019-07-11 16:51:28'
      },
      {
        id: 1118,
        pid: 138,
        city_code: '101090210',
        city_name: '望都县',
        post_code: '072450',
        area_code: '0312',
        ctime: '2019-07-11 16:51:28'
      },
      {
        id: 1119,
        pid: 138,
        city_code: '101090211',
        city_name: '安新县',
        post_code: '071600',
        area_code: '0312',
        ctime: '2019-07-11 16:51:28'
      },
      {
        id: 1120,
        pid: 138,
        city_code: '101090212',
        city_name: '易县',
        post_code: '074200',
        area_code: '0312',
        ctime: '2019-07-11 16:51:29'
      },
      {
        id: 1121,
        pid: 138,
        city_code: '101090214',
        city_name: '曲阳县',
        post_code: '073100',
        area_code: '0312',
        ctime: '2019-07-11 16:51:29'
      },
      {
        id: 1122,
        pid: 138,
        city_code: '101090215',
        city_name: '蠡县',
        post_code: '071400',
        area_code: '0312',
        ctime: '2019-07-11 16:51:29'
      },
      {
        id: 1123,
        pid: 138,
        city_code: '101090216',
        city_name: '顺平县',
        post_code: '072250',
        area_code: '0312',
        ctime: '2019-07-11 16:51:29'
      },
      {
        id: 1124,
        pid: 138,
        city_code: '101090225',
        city_name: '博野县',
        post_code: '071300',
        area_code: '0312',
        ctime: '2019-07-11 16:51:30'
      },
      {
        id: 1125,
        pid: 138,
        city_code: '101090217',
        city_name: '雄县',
        post_code: '071800',
        area_code: '0312',
        ctime: '2019-07-11 16:51:30'
      },
      {
        id: 1128,
        pid: 139,
        city_code: '101090711',
        city_name: '泊头市',
        post_code: '062150',
        area_code: '0317',
        ctime: '2019-07-11 16:51:30'
      },
      {
        id: 1129,
        pid: 139,
        city_code: '101090712',
        city_name: '任丘市',
        post_code: '062550',
        area_code: '0317',
        ctime: '2019-07-11 16:51:30'
      },
      {
        id: 1130,
        pid: 139,
        city_code: '101090713',
        city_name: '黄骅市',
        post_code: '061100',
        area_code: '0317',
        ctime: '2019-07-11 16:51:31'
      },
      {
        id: 1131,
        pid: 139,
        city_code: '101090714',
        city_name: '河间市',
        post_code: '062450',
        area_code: '0317',
        ctime: '2019-07-11 16:51:31'
      },
      {
        id: 1132,
        pid: 139,
        city_code: '101090716',
        city_name: '沧县',
        post_code: '061000',
        area_code: '0317',
        ctime: '2019-07-11 16:51:31'
      },
      {
        id: 1133,
        pid: 139,
        city_code: '101090702',
        city_name: '青县',
        post_code: '062650',
        area_code: '0317',
        ctime: '2019-07-11 16:51:31'
      },
      {
        id: 1134,
        pid: 139,
        city_code: '101090703',
        city_name: '东光县',
        post_code: '061600',
        area_code: '0317',
        ctime: '2019-07-11 16:51:32'
      },
      {
        id: 1135,
        pid: 139,
        city_code: '101090704',
        city_name: '海兴县',
        post_code: '061200',
        area_code: '0317',
        ctime: '2019-07-11 16:24:00'
      },
      {
        id: 1136,
        pid: 139,
        city_code: '101090705',
        city_name: '盐山县',
        post_code: '061300',
        area_code: '0317',
        ctime: '2019-07-11 16:24:00'
      },
      {
        id: 1137,
        pid: 139,
        city_code: '101090706',
        city_name: '肃宁县',
        post_code: '062350',
        area_code: '0317',
        ctime: '2019-07-11 16:24:02'
      },
      {
        id: 1138,
        pid: 139,
        city_code: '101090707',
        city_name: '南皮县',
        post_code: '061500',
        area_code: '0317',
        ctime: '2019-07-11 16:24:02'
      },
      {
        id: 1139,
        pid: 139,
        city_code: '101090708',
        city_name: '吴桥县',
        post_code: '061800',
        area_code: '0317',
        ctime: '2019-07-11 16:24:02'
      },
      {
        id: 1140,
        pid: 139,
        city_code: '101090709',
        city_name: '献县',
        post_code: '062250',
        area_code: '0317',
        ctime: '2019-07-11 16:24:02'
      },
      {
        id: 1141,
        pid: 139,
        city_code: '101090710',
        city_name: '孟村县',
        post_code: '061400',
        area_code: '0317',
        ctime: '2019-07-11 16:24:03'
      },
      {
        id: 1145,
        pid: 140,
        city_code: '101090403',
        city_name: '承德县',
        post_code: '067400',
        area_code: '0314',
        ctime: '2019-07-11 16:24:03'
      },
      {
        id: 1146,
        pid: 140,
        city_code: '101090404',
        city_name: '兴隆县',
        post_code: '067300',
        area_code: '0314',
        ctime: '2019-07-11 16:24:03'
      },
      {
        id: 1147,
        pid: 140,
        city_code: '101090405',
        city_name: '平泉市',
        post_code: '067500',
        area_code: '0314',
        ctime: '2019-07-11 21:24:09'
      },
      {
        id: 1148,
        pid: 140,
        city_code: '101090406',
        city_name: '滦平县',
        post_code: '068250',
        area_code: '0314',
        ctime: '2019-07-11 16:24:04'
      },
      {
        id: 1149,
        pid: 140,
        city_code: '101090407',
        city_name: '隆化县',
        post_code: '068150',
        area_code: '0314',
        ctime: '2019-07-11 16:24:05'
      },
      {
        id: 1150,
        pid: 140,
        city_code: '101090408',
        city_name: '丰宁县',
        post_code: '068350',
        area_code: '0314',
        ctime: '2019-07-11 16:24:05'
      },
      {
        id: 1151,
        pid: 140,
        city_code: '101090409',
        city_name: '宽城县',
        post_code: '067600',
        area_code: '0314',
        ctime: '2019-07-11 16:24:06'
      },
      {
        id: 1152,
        pid: 140,
        city_code: '101090410',
        city_name: '围场县',
        post_code: '068450',
        area_code: '0314',
        ctime: '2019-07-11 16:24:06'
      },
      {
        id: 1156,
        pid: 141,
        city_code: '101091002',
        city_name: '峰峰矿区',
        post_code: '056200',
        area_code: '0310',
        ctime: '2019-07-11 16:24:06'
      },
      {
        id: 1157,
        pid: 141,
        city_code: '101091016',
        city_name: '武安市',
        post_code: '056300',
        area_code: '0310',
        ctime: '2019-07-11 16:24:07'
      },
      {
        id: 1159,
        pid: 141,
        city_code: '101091003',
        city_name: '临漳县',
        post_code: '056600',
        area_code: '0310',
        ctime: '2019-07-11 16:24:08'
      },
      {
        id: 1160,
        pid: 141,
        city_code: '101091004',
        city_name: '成安县',
        post_code: '056700',
        area_code: '0310',
        ctime: '2019-07-11 16:24:09'
      },
      {
        id: 1161,
        pid: 141,
        city_code: '101091005',
        city_name: '大名县',
        post_code: '056900',
        area_code: '0310',
        ctime: '2019-07-11 16:24:10'
      },
      {
        id: 1162,
        pid: 141,
        city_code: '101091006',
        city_name: '涉县',
        post_code: '056400',
        area_code: '0310',
        ctime: '2019-07-11 16:24:10'
      },
      {
        id: 1163,
        pid: 141,
        city_code: '101091007',
        city_name: '磁县',
        post_code: '056500',
        area_code: '0310',
        ctime: '2019-07-11 16:24:10'
      },
      {
        id: 1164,
        pid: 141,
        city_code: '101091008',
        city_name: '肥乡县',
        post_code: '057550',
        area_code: '0310',
        ctime: '2019-07-11 16:24:10'
      },
      {
        id: 1165,
        pid: 141,
        city_code: '101091009',
        city_name: '永年县',
        post_code: '057150',
        area_code: '0310',
        ctime: '2019-07-11 16:24:11'
      },
      {
        id: 1166,
        pid: 141,
        city_code: '101091010',
        city_name: '邱县',
        post_code: '057450',
        area_code: '0310',
        ctime: '2019-07-11 16:24:11'
      },
      {
        id: 1167,
        pid: 141,
        city_code: '101091011',
        city_name: '鸡泽县',
        post_code: '057350',
        area_code: '0310',
        ctime: '2019-07-11 16:24:11'
      },
      {
        id: 1168,
        pid: 141,
        city_code: '101091012',
        city_name: '广平县',
        post_code: '057650',
        area_code: '0310',
        ctime: '2019-07-11 16:24:11'
      },
      {
        id: 1169,
        pid: 141,
        city_code: '101091013',
        city_name: '馆陶县',
        post_code: '057750',
        area_code: '0310',
        ctime: '2019-07-11 16:24:13'
      },
      {
        id: 1170,
        pid: 141,
        city_code: '101091014',
        city_name: '魏县',
        post_code: '056800',
        area_code: '0310',
        ctime: '2019-07-11 16:24:13'
      },
      {
        id: 1171,
        pid: 141,
        city_code: '101091015',
        city_name: '曲周县',
        post_code: '057250',
        area_code: '0310',
        ctime: '2019-07-11 16:24:14'
      },
      {
        id: 1173,
        pid: 142,
        city_code: '101090810',
        city_name: '冀州市',
        post_code: '053200',
        area_code: '0318',
        ctime: '2019-07-11 17:36:13'
      },
      {
        id: 1174,
        pid: 142,
        city_code: '101090811',
        city_name: '深州市',
        post_code: '053800',
        area_code: '0755',
        ctime: '2019-07-11 16:24:15'
      },
      {
        id: 1175,
        pid: 142,
        city_code: '101090802',
        city_name: '枣强县',
        post_code: '053100',
        area_code: '0318',
        ctime: '2019-07-11 16:24:15'
      },
      {
        id: 1176,
        pid: 142,
        city_code: '101090803',
        city_name: '武邑县',
        post_code: '053400',
        area_code: '0318',
        ctime: '2019-07-11 16:24:15'
      },
      {
        id: 1177,
        pid: 142,
        city_code: '101090804',
        city_name: '武强县',
        post_code: '053300',
        area_code: '0318',
        ctime: '2019-07-11 16:24:15'
      },
      {
        id: 1178,
        pid: 142,
        city_code: '101090805',
        city_name: '饶阳县',
        post_code: '053900',
        area_code: '0318',
        ctime: '2019-07-11 16:24:16'
      },
      {
        id: 1179,
        pid: 142,
        city_code: '101090806',
        city_name: '安平县',
        post_code: '053600',
        area_code: '0318',
        ctime: '2019-07-11 16:24:17'
      },
      {
        id: 1180,
        pid: 142,
        city_code: '101090807',
        city_name: '故城县',
        post_code: '253800',
        area_code: '0318',
        ctime: '2019-07-11 16:24:18'
      },
      {
        id: 1181,
        pid: 142,
        city_code: '101090808',
        city_name: '景县',
        post_code: '053500',
        area_code: '0318',
        ctime: '2019-07-11 16:24:18'
      },
      {
        id: 1182,
        pid: 142,
        city_code: '101090809',
        city_name: '阜城县',
        post_code: '053700',
        area_code: '0318',
        ctime: '2019-07-11 16:24:20'
      },
      {
        id: 1185,
        pid: 143,
        city_code: '101090608',
        city_name: '霸州市',
        post_code: '065700',
        area_code: '0316',
        ctime: '2019-07-11 16:24:20'
      },
      {
        id: 1186,
        pid: 143,
        city_code: '101090609',
        city_name: '三河市',
        post_code: '065200',
        area_code: '0316/010',
        ctime: '2019-07-11 16:24:21'
      },
      {
        id: 1187,
        pid: 143,
        city_code: '101090602',
        city_name: '固安县',
        post_code: '065500',
        area_code: '010，0316',
        ctime: '2019-07-11 16:24:21'
      },
      {
        id: 1188,
        pid: 143,
        city_code: '101090603',
        city_name: '永清县',
        post_code: '065600',
        area_code: '0316',
        ctime: '2019-07-11 16:24:22'
      },
      {
        id: 1189,
        pid: 143,
        city_code: '101090604',
        city_name: '香河县',
        post_code: '065400',
        area_code: '0316',
        ctime: '2019-07-11 16:24:22'
      },
      {
        id: 1190,
        pid: 143,
        city_code: '101090605',
        city_name: '大城县',
        post_code: '065900',
        area_code: '0316',
        ctime: '2019-07-11 16:24:22'
      },
      {
        id: 1191,
        pid: 143,
        city_code: '101090606',
        city_name: '文安县',
        post_code: '065800',
        area_code: '0316',
        ctime: '2019-07-11 16:24:23'
      },
      {
        id: 1192,
        pid: 143,
        city_code: '101090607',
        city_name: '大厂县',
        post_code: '065300',
        area_code: '0316',
        ctime: '2019-07-11 16:24:24'
      },
      {
        id: 1195,
        pid: 144,
        city_code: '101091106',
        city_name: '北戴河区',
        post_code: '066100',
        area_code: '0335',
        ctime: '2019-07-11 16:24:24'
      },
      {
        id: 1196,
        pid: 144,
        city_code: '101091103',
        city_name: '昌黎县',
        post_code: '066600',
        area_code: '0335',
        ctime: '2019-07-11 16:24:24'
      },
      {
        id: 1197,
        pid: 144,
        city_code: '101091104',
        city_name: '抚宁区',
        post_code: '066300',
        area_code: '（+86）0335',
        ctime: '2019-07-11 21:24:10'
      },
      {
        id: 1198,
        pid: 144,
        city_code: '101091105',
        city_name: '卢龙县',
        post_code: '066400',
        area_code: '0335',
        ctime: '2019-07-11 16:24:25'
      },
      {
        id: 1199,
        pid: 144,
        city_code: '101091102',
        city_name: '青龙县',
        post_code: '066500',
        area_code: '0335',
        ctime: '2019-07-11 16:24:25'
      },
      {
        id: 1204,
        pid: 145,
        city_code: '101090502',
        city_name: '丰南区',
        post_code: '063300',
        area_code: '0315',
        ctime: '2019-07-11 16:24:25'
      },
      {
        id: 1205,
        pid: 145,
        city_code: '101090503',
        city_name: '丰润区',
        post_code: '064000',
        area_code: '0315',
        ctime: '2019-07-11 16:24:25'
      },
      {
        id: 1206,
        pid: 145,
        city_code: '101090510',
        city_name: '遵化市',
        post_code: '064200',
        area_code: '0315',
        ctime: '2019-07-11 16:24:27'
      },
      {
        id: 1207,
        pid: 145,
        city_code: '101090511',
        city_name: '迁安市',
        post_code: '064400',
        area_code: '0315',
        ctime: '2019-07-11 16:24:27'
      },
      {
        id: 1208,
        pid: 145,
        city_code: '101090504',
        city_name: '滦县',
        post_code: '063700',
        area_code: '0315',
        ctime: '2019-07-11 16:24:27'
      },
      {
        id: 1209,
        pid: 145,
        city_code: '101090505',
        city_name: '滦南县',
        post_code: '063500',
        area_code: '0315',
        ctime: '2019-07-11 16:24:28'
      },
      {
        id: 1210,
        pid: 145,
        city_code: '101090506',
        city_name: '乐亭县',
        post_code: '063600',
        area_code: '0315',
        ctime: '2019-07-11 16:24:29'
      },
      {
        id: 1211,
        pid: 145,
        city_code: '101090507',
        city_name: '迁西县',
        post_code: '064300',
        area_code: '0315',
        ctime: '2019-07-11 16:24:29'
      },
      {
        id: 1212,
        pid: 145,
        city_code: '101090508',
        city_name: '玉田县',
        post_code: '064100',
        area_code: '0315',
        ctime: '2019-07-11 16:24:30'
      },
      {
        id: 1213,
        pid: 145,
        city_code: '101090509',
        city_name: '曹妃甸区',
        post_code: '063200',
        area_code: '0315',
        ctime: '2019-07-11 16:24:00'
      },
      {
        id: 1216,
        pid: 146,
        city_code: '101090916',
        city_name: '南宫市',
        post_code: '055750',
        area_code: '0319',
        ctime: '2019-07-11 16:24:32'
      },
      {
        id: 1217,
        pid: 146,
        city_code: '101090917',
        city_name: '沙河市',
        post_code: '054100',
        area_code: '0319',
        ctime: '2019-07-11 16:24:32'
      },
      {
        id: 1219,
        pid: 146,
        city_code: '101090902',
        city_name: '临城县',
        post_code: '054300',
        area_code: '0319',
        ctime: '2019-07-11 16:24:33'
      },
      {
        id: 1220,
        pid: 146,
        city_code: '101090904',
        city_name: '内丘县',
        post_code: '054200',
        area_code: '0319',
        ctime: '2019-07-11 16:24:34'
      },
      {
        id: 1221,
        pid: 146,
        city_code: '101090905',
        city_name: '柏乡县',
        post_code: '055450',
        area_code: '0319',
        ctime: '2019-07-11 16:24:35'
      },
      {
        id: 1222,
        pid: 146,
        city_code: '101090906',
        city_name: '隆尧县',
        post_code: '055350',
        area_code: '0319',
        ctime: '2019-07-11 16:24:35'
      },
      {
        id: 1223,
        pid: 146,
        city_code: '101090918',
        city_name: '任县',
        post_code: '055151',
        area_code: '0319',
        ctime: '2019-07-11 16:24:35'
      },
      {
        id: 1224,
        pid: 146,
        city_code: '101090907',
        city_name: '南和县',
        post_code: '054400',
        area_code: '0319',
        ctime: '2019-07-11 16:24:36'
      },
      {
        id: 1225,
        pid: 146,
        city_code: '101090908',
        city_name: '宁晋县',
        post_code: '055550',
        area_code: '0319',
        ctime: '2019-07-11 16:24:36'
      },
      {
        id: 1226,
        pid: 146,
        city_code: '101090909',
        city_name: '巨鹿县',
        post_code: '055250',
        area_code: '0319',
        ctime: '2019-07-11 16:24:36'
      },
      {
        id: 1227,
        pid: 146,
        city_code: '101090910',
        city_name: '新河县',
        post_code: '055650',
        area_code: '0319',
        ctime: '2019-07-11 16:24:37'
      },
      {
        id: 1228,
        pid: 146,
        city_code: '101090911',
        city_name: '广宗县',
        post_code: '054600',
        area_code: '0319',
        ctime: '2019-07-11 16:24:38'
      },
      {
        id: 1229,
        pid: 146,
        city_code: '101090912',
        city_name: '平乡县',
        post_code: '054500',
        area_code: '0319',
        ctime: '2019-07-11 16:24:38'
      },
      {
        id: 1230,
        pid: 146,
        city_code: '101090913',
        city_name: '威县',
        post_code: '054700',
        area_code: '0319',
        ctime: '2019-07-11 16:24:38'
      },
      {
        id: 1231,
        pid: 146,
        city_code: '101090914',
        city_name: '清河县',
        post_code: '054800',
        area_code: '0319',
        ctime: '2019-07-11 16:24:39'
      },
      {
        id: 1232,
        pid: 146,
        city_code: '101090915',
        city_name: '临西县',
        post_code: '054900',
        area_code: '0319',
        ctime: '2019-07-11 16:24:39'
      },
      {
        id: 1235,
        pid: 147,
        city_code: '101090302',
        city_name: '宣化区',
        post_code: '075100',
        area_code: '0313',
        ctime: '2019-07-11 16:24:39'
      },
      {
        id: 1238,
        pid: 147,
        city_code: '101090303',
        city_name: '张北县',
        post_code: '076450',
        area_code: '0313',
        ctime: '2019-07-11 16:24:40'
      },
      {
        id: 1239,
        pid: 147,
        city_code: '101090304',
        city_name: '康保县',
        post_code: '076650',
        area_code: '0313',
        ctime: '2019-07-11 16:24:40'
      },
      {
        id: 1240,
        pid: 147,
        city_code: '101090305',
        city_name: '沽源县',
        post_code: '076550',
        area_code: '0313',
        ctime: '2019-07-11 16:24:40'
      },
      {
        id: 1241,
        pid: 147,
        city_code: '101090306',
        city_name: '尚义县',
        post_code: '076750',
        area_code: '0313',
        ctime: '2019-07-11 16:24:41'
      },
      {
        id: 1242,
        pid: 147,
        city_code: '101090307',
        city_name: '蔚县',
        post_code: '075700',
        area_code: '0313',
        ctime: '2019-07-11 16:24:42'
      },
      {
        id: 1243,
        pid: 147,
        city_code: '101090308',
        city_name: '阳原县',
        post_code: '075800',
        area_code: '0313',
        ctime: '2019-07-11 16:24:42'
      },
      {
        id: 1244,
        pid: 147,
        city_code: '101090309',
        city_name: '怀安县',
        post_code: '076150',
        area_code: '0313',
        ctime: '2019-07-11 16:24:42'
      },
      {
        id: 1245,
        pid: 147,
        city_code: '101090310',
        city_name: '万全区',
        post_code: '076250',
        area_code: '0313',
        ctime: '2019-07-11 16:24:00'
      },
      {
        id: 1246,
        pid: 147,
        city_code: '101090311',
        city_name: '怀来县',
        post_code: '075400',
        area_code: '0313',
        ctime: '2019-07-11 16:24:44'
      },
      {
        id: 1247,
        pid: 147,
        city_code: '101090312',
        city_name: '涿鹿县',
        post_code: '075600',
        area_code: '0313',
        ctime: '2019-07-11 16:24:44'
      },
      {
        id: 1248,
        pid: 147,
        city_code: '101090313',
        city_name: '赤城县',
        post_code: '075500',
        area_code: '0313',
        ctime: '2019-07-11 16:24:45'
      },
      {
        id: 1249,
        pid: 147,
        city_code: '101090314',
        city_name: '崇礼区',
        post_code: '076350',
        area_code: '0313',
        ctime: '2019-07-11 16:24:00'
      },
      {
        id: 1255,
        pid: 148,
        city_code: '101180108',
        city_name: '上街区',
        post_code: '450041',
        area_code: '0371',
        ctime: '2019-07-11 16:24:46'
      },
      {
        id: 1261,
        pid: 148,
        city_code: '101180102',
        city_name: '巩义市',
        post_code: '451200',
        area_code: '0371',
        ctime: '2019-07-11 16:24:48'
      },
      {
        id: 1262,
        pid: 148,
        city_code: '101180103',
        city_name: '荥阳市',
        post_code: '450100',
        area_code: '0371',
        ctime: '2019-07-11 16:24:48'
      },
      {
        id: 1263,
        pid: 148,
        city_code: '101180105',
        city_name: '新密市',
        post_code: '452370',
        area_code: '0371',
        ctime: '2019-07-11 16:24:48'
      },
      {
        id: 1264,
        pid: 148,
        city_code: '101180106',
        city_name: '新郑市',
        post_code: '451150',
        area_code: '0371',
        ctime: '2019-07-11 16:24:49'
      },
      {
        id: 1265,
        pid: 148,
        city_code: '101180104',
        city_name: '登封市',
        post_code: '452470',
        area_code: '0371',
        ctime: '2019-07-11 16:24:49'
      },
      {
        id: 1266,
        pid: 148,
        city_code: '101180107',
        city_name: '中牟县',
        post_code: '451450',
        area_code: '0371',
        ctime: '2019-07-11 16:24:50'
      },
      {
        id: 1272,
        pid: 149,
        city_code: '101180911',
        city_name: '吉利区',
        post_code: '471012',
        area_code: '0379',
        ctime: '2019-07-11 16:24:50'
      },
      {
        id: 1273,
        pid: 149,
        city_code: '101180908',
        city_name: '偃师市',
        post_code: '471900',
        area_code: '0379',
        ctime: '2019-07-11 16:24:52'
      },
      {
        id: 1274,
        pid: 149,
        city_code: '101180903',
        city_name: '孟津县',
        post_code: '471100',
        area_code: '0379',
        ctime: '2019-07-11 16:24:52'
      },
      {
        id: 1275,
        pid: 149,
        city_code: '101180902',
        city_name: '新安县',
        post_code: '471800',
        area_code: '0379',
        ctime: '2019-07-11 16:24:53'
      },
      {
        id: 1276,
        pid: 149,
        city_code: '101180909',
        city_name: '栾川县',
        post_code: '471500',
        area_code: '0379',
        ctime: '2019-07-11 16:24:53'
      },
      {
        id: 1277,
        pid: 149,
        city_code: '101180907',
        city_name: '嵩县',
        post_code: '471400',
        area_code: '0379',
        ctime: '2019-07-11 16:24:55'
      },
      {
        id: 1278,
        pid: 149,
        city_code: '101180910',
        city_name: '汝阳县',
        post_code: '471200',
        area_code: '0379',
        ctime: '2019-07-11 16:24:56'
      },
      {
        id: 1279,
        pid: 149,
        city_code: '101180904',
        city_name: '宜阳县',
        post_code: '471600',
        area_code: '0379',
        ctime: '2019-07-11 16:24:56'
      },
      {
        id: 1280,
        pid: 149,
        city_code: '101180905',
        city_name: '洛宁县',
        post_code: '471700',
        area_code: '0379',
        ctime: '2019-07-11 16:24:57'
      },
      {
        id: 1281,
        pid: 149,
        city_code: '101180906',
        city_name: '伊川县',
        post_code: '471300',
        area_code: '0379',
        ctime: '2019-07-11 16:24:58'
      },
      {
        id: 1287,
        pid: 150,
        city_code: '101180802',
        city_name: '杞县',
        post_code: '475200',
        area_code: '0371',
        ctime: '2019-07-11 16:24:58'
      },
      {
        id: 1288,
        pid: 150,
        city_code: '101180804',
        city_name: '通许县',
        post_code: '475400',
        area_code: '03712',
        ctime: '2019-07-11 16:24:59'
      },
      {
        id: 1289,
        pid: 150,
        city_code: '101180803',
        city_name: '尉氏县',
        post_code: '475500',
        area_code: '0371',
        ctime: '2019-07-11 16:25:00'
      },
      {
        id: 1291,
        pid: 150,
        city_code: '101180805',
        city_name: '兰考县',
        post_code: '475300',
        area_code: '0371',
        ctime: '2019-07-11 16:25:00'
      },
      {
        id: 1296,
        pid: 151,
        city_code: '101180205',
        city_name: '林州市',
        post_code: '456550',
        area_code: '0372',
        ctime: '2019-07-11 16:25:00'
      },
      {
        id: 1298,
        pid: 151,
        city_code: '101180202',
        city_name: '汤阴县',
        post_code: '456150',
        area_code: '0372',
        ctime: '2019-07-11 16:25:02'
      },
      {
        id: 1299,
        pid: 151,
        city_code: '101180203',
        city_name: '滑县',
        post_code: '456400',
        area_code: '0372',
        ctime: '2019-07-11 16:25:02'
      },
      {
        id: 1300,
        pid: 151,
        city_code: '101180204',
        city_name: '内黄县',
        post_code: '456300',
        area_code: '0372',
        ctime: '2019-07-11 16:25:02'
      },
      {
        id: 1304,
        pid: 152,
        city_code: '101181202',
        city_name: '浚县',
        post_code: '456250',
        area_code: '0392',
        ctime: '2019-07-11 16:25:03'
      },
      {
        id: 1305,
        pid: 152,
        city_code: '101181203',
        city_name: '淇县',
        post_code: '456750',
        area_code: '0392',
        ctime: '2019-07-11 16:25:04'
      },
      {
        id: 1311,
        pid: 154,
        city_code: '101181104',
        city_name: '沁阳市',
        post_code: '454550',
        area_code: '0391',
        ctime: '2019-07-11 16:25:06'
      },
      {
        id: 1312,
        pid: 154,
        city_code: '101181108',
        city_name: '孟州市',
        post_code: '454750',
        area_code: '0391',
        ctime: '2019-07-11 16:25:07'
      },
      {
        id: 1313,
        pid: 154,
        city_code: '101181102',
        city_name: '修武县',
        post_code: '454350',
        area_code: '0391',
        ctime: '2019-07-11 16:25:07'
      },
      {
        id: 1314,
        pid: 154,
        city_code: '101181106',
        city_name: '博爱县',
        post_code: '454450',
        area_code: '0391',
        ctime: '2019-07-11 16:25:08'
      },
      {
        id: 1315,
        pid: 154,
        city_code: '101181103',
        city_name: '武陟县',
        post_code: '454950',
        area_code: '0391',
        ctime: '2019-07-11 17:21:58'
      },
      {
        id: 1316,
        pid: 154,
        city_code: '101181107',
        city_name: '温县',
        post_code: '454850',
        area_code: '0391',
        ctime: '2019-07-11 16:25:13'
      },
      {
        id: 1319,
        pid: 155,
        city_code: '101180711',
        city_name: '邓州市',
        post_code: '474150',
        area_code: '0377',
        ctime: '2019-07-11 16:25:14'
      },
      {
        id: 1320,
        pid: 155,
        city_code: '101180702',
        city_name: '南召县',
        post_code: '474650',
        area_code: '0377',
        ctime: '2019-07-11 16:25:15'
      },
      {
        id: 1321,
        pid: 155,
        city_code: '101180703',
        city_name: '方城县',
        post_code: '473200',
        area_code: '0377',
        ctime: '2019-07-11 16:25:15'
      },
      {
        id: 1322,
        pid: 155,
        city_code: '101180705',
        city_name: '西峡县',
        post_code: '474550',
        area_code: '0377',
        ctime: '2019-07-11 16:25:16'
      },
      {
        id: 1323,
        pid: 155,
        city_code: '101180707',
        city_name: '镇平县',
        post_code: '474250',
        area_code: '0377',
        ctime: '2019-07-11 16:25:17'
      },
      {
        id: 1324,
        pid: 155,
        city_code: '101180706',
        city_name: '内乡县',
        post_code: '474350',
        area_code: '0377',
        ctime: '2019-07-11 16:25:17'
      },
      {
        id: 1325,
        pid: 155,
        city_code: '101180708',
        city_name: '淅川县',
        post_code: '474450',
        area_code: '0377',
        ctime: '2019-07-11 16:25:18'
      },
      {
        id: 1326,
        pid: 155,
        city_code: '101180704',
        city_name: '社旗县',
        post_code: '473300',
        area_code: '0377',
        ctime: '2019-07-11 16:25:18'
      },
      {
        id: 1327,
        pid: 155,
        city_code: '101180710',
        city_name: '唐河县',
        post_code: '473400',
        area_code: '0377',
        ctime: '2019-07-11 16:25:19'
      },
      {
        id: 1328,
        pid: 155,
        city_code: '101180709',
        city_name: '新野县',
        post_code: '473500',
        area_code: '0377',
        ctime: '2019-07-11 16:25:20'
      },
      {
        id: 1329,
        pid: 155,
        city_code: '101180712',
        city_name: '桐柏县',
        post_code: '474750',
        area_code: '0377',
        ctime: '2019-07-11 16:25:21'
      },
      {
        id: 1333,
        pid: 156,
        city_code: '101180508',
        city_name: '石龙区',
        post_code: '467045',
        area_code: '0375',
        ctime: '2019-07-11 16:25:22'
      },
      {
        id: 1334,
        pid: 156,
        city_code: '101180506',
        city_name: '舞钢市',
        post_code: '462500',
        area_code: '0375',
        ctime: '2019-07-11 16:25:22'
      },
      {
        id: 1335,
        pid: 156,
        city_code: '101180504',
        city_name: '汝州市',
        post_code: '467599',
        area_code: '0375',
        ctime: '2019-07-11 16:25:23'
      },
      {
        id: 1336,
        pid: 156,
        city_code: '101180503',
        city_name: '宝丰县',
        post_code: '467400',
        area_code: '0375',
        ctime: '2019-07-11 16:25:23'
      },
      {
        id: 1337,
        pid: 156,
        city_code: '101180505',
        city_name: '叶县',
        post_code: '467200',
        area_code: '0375',
        ctime: '2019-07-11 16:25:25'
      },
      {
        id: 1338,
        pid: 156,
        city_code: '101180507',
        city_name: '鲁山县',
        post_code: '467300',
        area_code: '0375',
        ctime: '2019-07-11 16:25:25'
      },
      {
        id: 1339,
        pid: 156,
        city_code: '101180502',
        city_name: '郏县',
        post_code: '467100',
        area_code: '0375',
        ctime: '2019-07-11 16:25:26'
      },
      {
        id: 1341,
        pid: 157,
        city_code: '101181705',
        city_name: '义马市',
        post_code: '472300',
        area_code: '0398',
        ctime: '2019-07-11 16:25:26'
      },
      {
        id: 1342,
        pid: 157,
        city_code: '101181702',
        city_name: '灵宝市',
        post_code: '472500',
        area_code: '0398',
        ctime: '2019-07-11 16:25:27'
      },
      {
        id: 1343,
        pid: 157,
        city_code: '101181703',
        city_name: '渑池县',
        post_code: '472400',
        area_code: '0398',
        ctime: '2019-07-11 16:25:27'
      },
      {
        id: 1344,
        pid: 157,
        city_code: '101181708',
        city_name: '陕州区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 17:36:17'
      },
      {
        id: 1345,
        pid: 157,
        city_code: '101181704',
        city_name: '卢氏县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:25:27'
      },
      {
        id: 1347,
        pid: 158,
        city_code: '101181010',
        city_name: '睢阳区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:25:28'
      },
      {
        id: 1348,
        pid: 158,
        city_code: '101181009',
        city_name: '永城市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:25:28'
      },
      {
        id: 1349,
        pid: 158,
        city_code: '101181004',
        city_name: '民权县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:25:28'
      },
      {
        id: 1350,
        pid: 158,
        city_code: '101181003',
        city_name: '睢县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:25:28'
      },
      {
        id: 1351,
        pid: 158,
        city_code: '101181007',
        city_name: '宁陵县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:25:29'
      },
      {
        id: 1352,
        pid: 158,
        city_code: '101181005',
        city_name: '虞城县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:25:29'
      },
      {
        id: 1353,
        pid: 158,
        city_code: '101181006',
        city_name: '柘城县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:25:29'
      },
      {
        id: 1354,
        pid: 158,
        city_code: '101181008',
        city_name: '夏邑县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:25:29'
      },
      {
        id: 1359,
        pid: 159,
        city_code: '101180305',
        city_name: '卫辉市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:25:30'
      },
      {
        id: 1360,
        pid: 159,
        city_code: '101180304',
        city_name: '辉县市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:25:30'
      },
      {
        id: 1362,
        pid: 159,
        city_code: '101180302',
        city_name: '获嘉县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:25:30'
      },
      {
        id: 1363,
        pid: 159,
        city_code: '101180303',
        city_name: '原阳县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:25:31'
      },
      {
        id: 1364,
        pid: 159,
        city_code: '101180306',
        city_name: '延津县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:25:31'
      },
      {
        id: 1365,
        pid: 159,
        city_code: '101180307',
        city_name: '封丘县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:25:31'
      },
      {
        id: 1366,
        pid: 159,
        city_code: '101180308',
        city_name: '长垣县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:25:32'
      },
      {
        id: 1369,
        pid: 160,
        city_code: '101180603',
        city_name: '罗山县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:25:32'
      },
      {
        id: 1370,
        pid: 160,
        city_code: '101180604',
        city_name: '光山县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:25:32'
      },
      {
        id: 1371,
        pid: 160,
        city_code: '101180605',
        city_name: '新县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:25:32'
      },
      {
        id: 1372,
        pid: 160,
        city_code: '101180609',
        city_name: '商城县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:25:33'
      },
      {
        id: 1373,
        pid: 160,
        city_code: '101180608',
        city_name: '固始县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:25:33'
      },
      {
        id: 1374,
        pid: 160,
        city_code: '101180607',
        city_name: '潢川县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:25:33'
      },
      {
        id: 1375,
        pid: 160,
        city_code: '101180606',
        city_name: '淮滨县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:25:34'
      },
      {
        id: 1376,
        pid: 160,
        city_code: '101180602',
        city_name: '息县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:25:34'
      },
      {
        id: 1378,
        pid: 161,
        city_code: '101180405',
        city_name: '禹州市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:25:34'
      },
      {
        id: 1379,
        pid: 161,
        city_code: '101180404',
        city_name: '长葛市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:25:35'
      },
      {
        id: 1381,
        pid: 161,
        city_code: '101180402',
        city_name: '鄢陵县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:25:35'
      },
      {
        id: 1382,
        pid: 161,
        city_code: '101180403',
        city_name: '襄城县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:25:35'
      },
      {
        id: 1384,
        pid: 162,
        city_code: '101181407',
        city_name: '项城市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:25:36'
      },
      {
        id: 1385,
        pid: 162,
        city_code: '101181402',
        city_name: '扶沟县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:25:36'
      },
      {
        id: 1386,
        pid: 162,
        city_code: '101181405',
        city_name: '西华县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:25:36'
      },
      {
        id: 1387,
        pid: 162,
        city_code: '101181406',
        city_name: '商水县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:25:36'
      },
      {
        id: 1388,
        pid: 162,
        city_code: '101181410',
        city_name: '沈丘县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:25:37'
      },
      {
        id: 1389,
        pid: 162,
        city_code: '101181408',
        city_name: '郸城县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:25:37'
      },
      {
        id: 1390,
        pid: 162,
        city_code: '101181404',
        city_name: '淮阳县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:25:37'
      },
      {
        id: 1391,
        pid: 162,
        city_code: '101181403',
        city_name: '太康县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:25:37'
      },
      {
        id: 1392,
        pid: 162,
        city_code: '101181409',
        city_name: '鹿邑县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:25:38'
      },
      {
        id: 1394,
        pid: 163,
        city_code: '101181602',
        city_name: '西平县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:25:38'
      },
      {
        id: 1395,
        pid: 163,
        city_code: '101181604',
        city_name: '上蔡县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:25:38'
      },
      {
        id: 1396,
        pid: 163,
        city_code: '101181607',
        city_name: '平舆县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:25:38'
      },
      {
        id: 1397,
        pid: 163,
        city_code: '101181610',
        city_name: '正阳县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:25:39'
      },
      {
        id: 1398,
        pid: 163,
        city_code: '101181609',
        city_name: '确山县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:25:39'
      },
      {
        id: 1399,
        pid: 163,
        city_code: '101181606',
        city_name: '泌阳县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:25:39'
      },
      {
        id: 1400,
        pid: 163,
        city_code: '101181605',
        city_name: '汝南县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:25:39'
      },
      {
        id: 1401,
        pid: 163,
        city_code: '101181603',
        city_name: '遂平县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:25:40'
      },
      {
        id: 1402,
        pid: 163,
        city_code: '101181608',
        city_name: '新蔡县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:25:40'
      },
      {
        id: 1406,
        pid: 164,
        city_code: '101181503',
        city_name: '舞阳县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:25:40'
      },
      {
        id: 1407,
        pid: 164,
        city_code: '101181502',
        city_name: '临颍县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:25:40'
      },
      {
        id: 1409,
        pid: 165,
        city_code: '101181304',
        city_name: '清丰县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:25:41'
      },
      {
        id: 1410,
        pid: 165,
        city_code: '101181303',
        city_name: '南乐县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:25:41'
      },
      {
        id: 1411,
        pid: 165,
        city_code: '101181305',
        city_name: '范县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:25:41'
      },
      {
        id: 1412,
        pid: 165,
        city_code: '101181302',
        city_name: '台前县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:25:41'
      },
      {
        id: 1421,
        pid: 166,
        city_code: '101050104',
        city_name: '阿城区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:25:44'
      },
      {
        id: 1422,
        pid: 166,
        city_code: '101050103',
        city_name: '呼兰区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:25:44'
      },
      {
        id: 1424,
        pid: 166,
        city_code: '101050111',
        city_name: '尚志市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:25:45'
      },
      {
        id: 1425,
        pid: 166,
        city_code: '101050102',
        city_name: '双城市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 17:36:18'
      },
      {
        id: 1426,
        pid: 166,
        city_code: '101050112',
        city_name: '五常市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:25:46'
      },
      {
        id: 1427,
        pid: 166,
        city_code: '101050109',
        city_name: '方正县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:25:47'
      },
      {
        id: 1428,
        pid: 166,
        city_code: '101050105',
        city_name: '宾县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:25:48'
      },
      {
        id: 1429,
        pid: 166,
        city_code: '101050106',
        city_name: '依兰县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:25:48'
      },
      {
        id: 1430,
        pid: 166,
        city_code: '101050107',
        city_name: '巴彦县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:25:49'
      },
      {
        id: 1431,
        pid: 166,
        city_code: '101050108',
        city_name: '通河县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:25:51'
      },
      {
        id: 1432,
        pid: 166,
        city_code: '101050113',
        city_name: '木兰县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:25:52'
      },
      {
        id: 1433,
        pid: 166,
        city_code: '101050110',
        city_name: '延寿县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:25:53'
      },
      {
        id: 1439,
        pid: 167,
        city_code: '101050903',
        city_name: '肇州县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:25:54'
      },
      {
        id: 1440,
        pid: 167,
        city_code: '101050904',
        city_name: '肇源县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:25:54'
      },
      {
        id: 1441,
        pid: 167,
        city_code: '101050902',
        city_name: '林甸县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:25:54'
      },
      {
        id: 1442,
        pid: 167,
        city_code: '101050905',
        city_name: '杜尔伯特',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 17:36:19'
      },
      {
        id: 1443,
        pid: 168,
        city_code: '101050704',
        city_name: '呼玛县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:25:56'
      },
      {
        id: 1444,
        pid: 168,
        city_code: '101050703',
        city_name: '漠河县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:25:56'
      },
      {
        id: 1445,
        pid: 168,
        city_code: '101050702',
        city_name: '塔河县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:25:56'
      },
      {
        id: 1448,
        pid: 169,
        city_code: '101051206',
        city_name: '南山区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:25:56'
      },
      {
        id: 1452,
        pid: 169,
        city_code: '101051203',
        city_name: '萝北县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:25:58'
      },
      {
        id: 1453,
        pid: 169,
        city_code: '101051202',
        city_name: '绥滨县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:25:58'
      },
      {
        id: 1455,
        pid: 170,
        city_code: '101050605',
        city_name: '五大连池市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:25:58'
      },
      {
        id: 1456,
        pid: 170,
        city_code: '101050606',
        city_name: '北安市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:25:59'
      },
      {
        id: 1457,
        pid: 170,
        city_code: '101050602',
        city_name: '嫩江县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:25:59'
      },
      {
        id: 1458,
        pid: 170,
        city_code: '101050604',
        city_name: '逊克县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:25:59'
      },
      {
        id: 1459,
        pid: 170,
        city_code: '101050603',
        city_name: '孙吴县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:25:59'
      },
      {
        id: 1465,
        pid: 171,
        city_code: '101051102',
        city_name: '虎林市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:00'
      },
      {
        id: 1466,
        pid: 171,
        city_code: '101051103',
        city_name: '密山市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:00'
      },
      {
        id: 1467,
        pid: 171,
        city_code: '101051104',
        city_name: '鸡东县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:00'
      },
      {
        id: 1472,
        pid: 172,
        city_code: '101050406',
        city_name: '同江市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:00'
      },
      {
        id: 1473,
        pid: 172,
        city_code: '101050407',
        city_name: '富锦市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:01'
      },
      {
        id: 1474,
        pid: 172,
        city_code: '101050405',
        city_name: '桦南县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:01'
      },
      {
        id: 1475,
        pid: 172,
        city_code: '101050404',
        city_name: '桦川县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:01'
      },
      {
        id: 1476,
        pid: 172,
        city_code: '101050402',
        city_name: '汤原县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:01'
      },
      {
        id: 1477,
        pid: 172,
        city_code: '101050403',
        city_name: '抚远市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:24:00'
      },
      {
        id: 1482,
        pid: 173,
        city_code: '101050305',
        city_name: '绥芬河市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:02'
      },
      {
        id: 1483,
        pid: 173,
        city_code: '101050302',
        city_name: '海林市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:03'
      },
      {
        id: 1484,
        pid: 173,
        city_code: '101050306',
        city_name: '宁安市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:03'
      },
      {
        id: 1485,
        pid: 173,
        city_code: '101050303',
        city_name: '穆棱市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:04'
      },
      {
        id: 1486,
        pid: 173,
        city_code: '101050307',
        city_name: '东宁市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 21:24:10'
      },
      {
        id: 1487,
        pid: 173,
        city_code: '101050304',
        city_name: '林口县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:05'
      },
      {
        id: 1491,
        pid: 174,
        city_code: '101051003',
        city_name: '勃利县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:06'
      },
      {
        id: 1499,
        pid: 175,
        city_code: '101050202',
        city_name: '讷河市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:07'
      },
      {
        id: 1500,
        pid: 175,
        city_code: '101050203',
        city_name: '龙江县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:07'
      },
      {
        id: 1501,
        pid: 175,
        city_code: '101050206',
        city_name: '依安县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:08'
      },
      {
        id: 1502,
        pid: 175,
        city_code: '101050210',
        city_name: '泰来县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:08'
      },
      {
        id: 1503,
        pid: 175,
        city_code: '101050204',
        city_name: '甘南县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:10'
      },
      {
        id: 1504,
        pid: 175,
        city_code: '101050205',
        city_name: '富裕县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:11'
      },
      {
        id: 1505,
        pid: 175,
        city_code: '101050208',
        city_name: '克山县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:11'
      },
      {
        id: 1506,
        pid: 175,
        city_code: '101050209',
        city_name: '克东县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:11'
      },
      {
        id: 1507,
        pid: 175,
        city_code: '101050207',
        city_name: '拜泉县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:12'
      },
      {
        id: 1512,
        pid: 176,
        city_code: '101051302',
        city_name: '集贤县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:12'
      },
      {
        id: 1513,
        pid: 176,
        city_code: '101051305',
        city_name: '友谊县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:12'
      },
      {
        id: 1514,
        pid: 176,
        city_code: '101051303',
        city_name: '宝清县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:12'
      },
      {
        id: 1515,
        pid: 176,
        city_code: '101051304',
        city_name: '饶河县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:13'
      },
      {
        id: 1517,
        pid: 177,
        city_code: '101050503',
        city_name: '安达市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:13'
      },
      {
        id: 1518,
        pid: 177,
        city_code: '101050502',
        city_name: '肇东市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:14'
      },
      {
        id: 1519,
        pid: 177,
        city_code: '101050504',
        city_name: '海伦市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:15'
      },
      {
        id: 1520,
        pid: 177,
        city_code: '101050506',
        city_name: '望奎县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:16'
      },
      {
        id: 1521,
        pid: 177,
        city_code: '101050507',
        city_name: '兰西县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:16'
      },
      {
        id: 1522,
        pid: 177,
        city_code: '101050508',
        city_name: '青冈县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:16'
      },
      {
        id: 1523,
        pid: 177,
        city_code: '101050509',
        city_name: '庆安县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:17'
      },
      {
        id: 1524,
        pid: 177,
        city_code: '101050505',
        city_name: '明水县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:18'
      },
      {
        id: 1525,
        pid: 177,
        city_code: '101050510',
        city_name: '绥棱县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:18'
      },
      {
        id: 1536,
        pid: 178,
        city_code: '101050803',
        city_name: '五营区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:18'
      },
      {
        id: 1540,
        pid: 178,
        city_code: '101050802',
        city_name: '乌伊岭区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:18'
      },
      {
        id: 1541,
        pid: 178,
        city_code: '101050804',
        city_name: '铁力市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:19'
      },
      {
        id: 1542,
        pid: 178,
        city_code: '101050805',
        city_name: '嘉荫县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:19'
      },
      {
        id: 1550,
        pid: 179,
        city_code: '101200106',
        city_name: '东西湖区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:19'
      },
      {
        id: 1552,
        pid: 179,
        city_code: '101200102',
        city_name: '蔡甸区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:20'
      },
      {
        id: 1553,
        pid: 179,
        city_code: '101200105',
        city_name: '江夏区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:21'
      },
      {
        id: 1554,
        pid: 179,
        city_code: '101200103',
        city_name: '黄陂区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:21'
      },
      {
        id: 1555,
        pid: 179,
        city_code: '101200104',
        city_name: '新洲区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:26'
      },
      {
        id: 1560,
        pid: 181,
        city_code: '101200302',
        city_name: '梁子湖区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:26'
      },
      {
        id: 1562,
        pid: 182,
        city_code: '101200503',
        city_name: '麻城市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:26'
      },
      {
        id: 1563,
        pid: 182,
        city_code: '101200509',
        city_name: '武穴市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:27'
      },
      {
        id: 1564,
        pid: 182,
        city_code: '101200510',
        city_name: '团风县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:27'
      },
      {
        id: 1565,
        pid: 182,
        city_code: '101200502',
        city_name: '红安县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:27'
      },
      {
        id: 1566,
        pid: 182,
        city_code: '101200504',
        city_name: '罗田县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:27'
      },
      {
        id: 1567,
        pid: 182,
        city_code: '101200505',
        city_name: '英山县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:28'
      },
      {
        id: 1568,
        pid: 182,
        city_code: '101200506',
        city_name: '浠水县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:28'
      },
      {
        id: 1569,
        pid: 182,
        city_code: '101200507',
        city_name: '蕲春县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:28'
      },
      {
        id: 1570,
        pid: 182,
        city_code: '101200508',
        city_name: '黄梅县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:28'
      },
      {
        id: 1572,
        pid: 183,
        city_code: '101200606',
        city_name: '西塞山区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:29'
      },
      {
        id: 1573,
        pid: 183,
        city_code: '101200605',
        city_name: '下陆区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:29'
      },
      {
        id: 1574,
        pid: 183,
        city_code: '101200604',
        city_name: '铁山区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:29'
      },
      {
        id: 1575,
        pid: 183,
        city_code: '101200602',
        city_name: '大冶市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:29'
      },
      {
        id: 1576,
        pid: 183,
        city_code: '101200603',
        city_name: '阳新县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:30'
      },
      {
        id: 1578,
        pid: 184,
        city_code: '101201404',
        city_name: '掇刀区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:30'
      },
      {
        id: 1579,
        pid: 184,
        city_code: '101201402',
        city_name: '钟祥市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:30'
      },
      {
        id: 1580,
        pid: 184,
        city_code: '101201403',
        city_name: '京山县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:30'
      },
      {
        id: 1581,
        pid: 184,
        city_code: '101201405',
        city_name: '沙洋县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:32'
      },
      {
        id: 1584,
        pid: 185,
        city_code: '101200804',
        city_name: '石首市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:33'
      },
      {
        id: 1585,
        pid: 185,
        city_code: '101200806',
        city_name: '洪湖市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:33'
      },
      {
        id: 1586,
        pid: 185,
        city_code: '101200807',
        city_name: '松滋市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:33'
      },
      {
        id: 1587,
        pid: 185,
        city_code: '101200803',
        city_name: '公安县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:34'
      },
      {
        id: 1588,
        pid: 185,
        city_code: '101200805',
        city_name: '监利县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:34'
      },
      {
        id: 1589,
        pid: 185,
        city_code: '101200802',
        city_name: '江陵县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:35'
      },
      {
        id: 1592,
        pid: 188,
        city_code: '101201109',
        city_name: '张湾区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:36'
      },
      {
        id: 1593,
        pid: 188,
        city_code: '101201108',
        city_name: '茅箭区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:36'
      },
      {
        id: 1594,
        pid: 188,
        city_code: '101201107',
        city_name: '丹江口市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:36'
      },
      {
        id: 1595,
        pid: 188,
        city_code: '101201104',
        city_name: '郧阳区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:24:00'
      },
      {
        id: 1596,
        pid: 188,
        city_code: '101201103',
        city_name: '郧西县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:37'
      },
      {
        id: 1597,
        pid: 188,
        city_code: '101201105',
        city_name: '竹山县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:38'
      },
      {
        id: 1598,
        pid: 188,
        city_code: '101201102',
        city_name: '竹溪县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:38'
      },
      {
        id: 1599,
        pid: 188,
        city_code: '101201106',
        city_name: '房县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:38'
      },
      {
        id: 1601,
        pid: 189,
        city_code: '101201302',
        city_name: '广水市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:38'
      },
      {
        id: 1604,
        pid: 191,
        city_code: '101200702',
        city_name: '赤壁市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:39'
      },
      {
        id: 1605,
        pid: 191,
        city_code: '101200703',
        city_name: '嘉鱼县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:40'
      },
      {
        id: 1606,
        pid: 191,
        city_code: '101200705',
        city_name: '通城县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:41'
      },
      {
        id: 1607,
        pid: 191,
        city_code: '101200704',
        city_name: '崇阳县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:42'
      },
      {
        id: 1608,
        pid: 191,
        city_code: '101200706',
        city_name: '通山县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:42'
      },
      {
        id: 1611,
        pid: 192,
        city_code: '101200202',
        city_name: '襄州区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:42'
      },
      {
        id: 1612,
        pid: 192,
        city_code: '101200206',
        city_name: '老河口市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:42'
      },
      {
        id: 1613,
        pid: 192,
        city_code: '101200208',
        city_name: '枣阳市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:45'
      },
      {
        id: 1614,
        pid: 192,
        city_code: '101200205',
        city_name: '宜城市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:45'
      },
      {
        id: 1615,
        pid: 192,
        city_code: '101200204',
        city_name: '南漳县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:45'
      },
      {
        id: 1616,
        pid: 192,
        city_code: '101200207',
        city_name: '谷城县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:46'
      },
      {
        id: 1617,
        pid: 192,
        city_code: '101200203',
        city_name: '保康县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:47'
      },
      {
        id: 1619,
        pid: 193,
        city_code: '101200405',
        city_name: '应城市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:47'
      },
      {
        id: 1620,
        pid: 193,
        city_code: '101200402',
        city_name: '安陆市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:48'
      },
      {
        id: 1621,
        pid: 193,
        city_code: '101200406',
        city_name: '汉川市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:48'
      },
      {
        id: 1622,
        pid: 193,
        city_code: '101200407',
        city_name: '孝昌县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:49'
      },
      {
        id: 1623,
        pid: 193,
        city_code: '101200404',
        city_name: '大悟县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:49'
      },
      {
        id: 1624,
        pid: 193,
        city_code: '101200403',
        city_name: '云梦县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:52'
      },
      {
        id: 1625,
        pid: 194,
        city_code: '101200908',
        city_name: '长阳县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:52'
      },
      {
        id: 1626,
        pid: 194,
        city_code: '101200906',
        city_name: '五峰县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:52'
      },
      {
        id: 1631,
        pid: 194,
        city_code: '101200912',
        city_name: '夷陵区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:53'
      },
      {
        id: 1632,
        pid: 194,
        city_code: '101200909',
        city_name: '宜都市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:53'
      },
      {
        id: 1633,
        pid: 194,
        city_code: '101200907',
        city_name: '当阳市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:54'
      },
      {
        id: 1634,
        pid: 194,
        city_code: '101200910',
        city_name: '枝江市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:55'
      },
      {
        id: 1635,
        pid: 194,
        city_code: '101200902',
        city_name: '远安县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:55'
      },
      {
        id: 1636,
        pid: 194,
        city_code: '101200904',
        city_name: '兴山县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:55'
      },
      {
        id: 1637,
        pid: 194,
        city_code: '101200903',
        city_name: '秭归县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:56'
      },
      {
        id: 1639,
        pid: 195,
        city_code: '101201002',
        city_name: '利川市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:57'
      },
      {
        id: 1640,
        pid: 195,
        city_code: '101201003',
        city_name: '建始县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:57'
      },
      {
        id: 1641,
        pid: 195,
        city_code: '101201008',
        city_name: '巴东县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:57'
      },
      {
        id: 1642,
        pid: 195,
        city_code: '101201005',
        city_name: '宣恩县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:58'
      },
      {
        id: 1643,
        pid: 195,
        city_code: '101201004',
        city_name: '咸丰县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:58'
      },
      {
        id: 1644,
        pid: 195,
        city_code: '101201007',
        city_name: '来凤县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:59'
      },
      {
        id: 1645,
        pid: 195,
        city_code: '101201006',
        city_name: '鹤峰县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:26:59'
      },
      {
        id: 1652,
        pid: 196,
        city_code: '101250103',
        city_name: '浏阳市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:00'
      },
      {
        id: 1653,
        pid: 196,
        city_code: '101250106',
        city_name: '长沙县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:00'
      },
      {
        id: 1654,
        pid: 196,
        city_code: '101250105',
        city_name: '望城区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 21:24:10'
      },
      {
        id: 1655,
        pid: 196,
        city_code: '101250102',
        city_name: '宁乡县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:00'
      },
      {
        id: 1657,
        pid: 197,
        city_code: '101251104',
        city_name: '武陵源区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:00'
      },
      {
        id: 1658,
        pid: 197,
        city_code: '101251103',
        city_name: '慈利县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:02'
      },
      {
        id: 1659,
        pid: 197,
        city_code: '101251102',
        city_name: '桑植县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:02'
      },
      {
        id: 1662,
        pid: 198,
        city_code: '101250608',
        city_name: '津市市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:02'
      },
      {
        id: 1663,
        pid: 198,
        city_code: '101250602',
        city_name: '安乡县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:03'
      },
      {
        id: 1664,
        pid: 198,
        city_code: '101250604',
        city_name: '汉寿县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:04'
      },
      {
        id: 1665,
        pid: 198,
        city_code: '101250605',
        city_name: '澧县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:05'
      },
      {
        id: 1666,
        pid: 198,
        city_code: '101250606',
        city_name: '临澧县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:05'
      },
      {
        id: 1667,
        pid: 198,
        city_code: '101250603',
        city_name: '桃源县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:06'
      },
      {
        id: 1668,
        pid: 198,
        city_code: '101250607',
        city_name: '石门县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:07'
      },
      {
        id: 1670,
        pid: 199,
        city_code: '101250512',
        city_name: '苏仙区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:07'
      },
      {
        id: 1671,
        pid: 199,
        city_code: '101250507',
        city_name: '资兴市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:08'
      },
      {
        id: 1672,
        pid: 199,
        city_code: '101250502',
        city_name: '桂阳县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:08'
      },
      {
        id: 1673,
        pid: 199,
        city_code: '101250504',
        city_name: '宜章县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:09'
      },
      {
        id: 1674,
        pid: 199,
        city_code: '101250510',
        city_name: '永兴县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:09'
      },
      {
        id: 1675,
        pid: 199,
        city_code: '101250503',
        city_name: '嘉禾县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:09'
      },
      {
        id: 1676,
        pid: 199,
        city_code: '101250505',
        city_name: '临武县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:10'
      },
      {
        id: 1677,
        pid: 199,
        city_code: '101250508',
        city_name: '汝城县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:10'
      },
      {
        id: 1678,
        pid: 199,
        city_code: '101250511',
        city_name: '桂东县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:10'
      },
      {
        id: 1679,
        pid: 199,
        city_code: '101250509',
        city_name: '安仁县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:10'
      },
      {
        id: 1684,
        pid: 200,
        city_code: '101250409',
        city_name: '南岳区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:12'
      },
      {
        id: 1685,
        pid: 200,
        city_code: '101250408',
        city_name: '耒阳市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:12'
      },
      {
        id: 1686,
        pid: 200,
        city_code: '101250406',
        city_name: '常宁市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:13'
      },
      {
        id: 1687,
        pid: 200,
        city_code: '101250405',
        city_name: '衡阳县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:13'
      },
      {
        id: 1688,
        pid: 200,
        city_code: '101250407',
        city_name: '衡南县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:14'
      },
      {
        id: 1689,
        pid: 200,
        city_code: '101250402',
        city_name: '衡山县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:14'
      },
      {
        id: 1690,
        pid: 200,
        city_code: '101250403',
        city_name: '衡东县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:14'
      },
      {
        id: 1691,
        pid: 200,
        city_code: '101250404',
        city_name: '祁东县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:14'
      },
      {
        id: 1692,
        pid: 201,
        city_code: '101251202',
        city_name: '鹤城区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:14'
      },
      {
        id: 1693,
        pid: 201,
        city_code: '101251205',
        city_name: '靖州县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:15'
      },
      {
        id: 1694,
        pid: 201,
        city_code: '101251208',
        city_name: '麻阳县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:15'
      },
      {
        id: 1695,
        pid: 201,
        city_code: '101251207',
        city_name: '通道县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:16'
      },
      {
        id: 1696,
        pid: 201,
        city_code: '101251209',
        city_name: '新晃县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:16'
      },
      {
        id: 1697,
        pid: 201,
        city_code: '101251210',
        city_name: '芷江治县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 21:24:11'
      },
      {
        id: 1698,
        pid: 201,
        city_code: '101251203',
        city_name: '沅陵县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:18'
      },
      {
        id: 1699,
        pid: 201,
        city_code: '101251204',
        city_name: '辰溪县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:18'
      },
      {
        id: 1700,
        pid: 201,
        city_code: '101251211',
        city_name: '溆浦县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:18'
      },
      {
        id: 1701,
        pid: 201,
        city_code: '101251212',
        city_name: '中方县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:19'
      },
      {
        id: 1702,
        pid: 201,
        city_code: '101251206',
        city_name: '会同县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:19'
      },
      {
        id: 1703,
        pid: 201,
        city_code: '101251213',
        city_name: '洪江市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:19'
      },
      {
        id: 1705,
        pid: 202,
        city_code: '101250803',
        city_name: '冷水江市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:19'
      },
      {
        id: 1706,
        pid: 202,
        city_code: '101250806',
        city_name: '涟源市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:20'
      },
      {
        id: 1707,
        pid: 202,
        city_code: '101250802',
        city_name: '双峰县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:20'
      },
      {
        id: 1708,
        pid: 202,
        city_code: '101250805',
        city_name: '新化县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:21'
      },
      {
        id: 1709,
        pid: 203,
        city_code: '101250909',
        city_name: '城步县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:21'
      },
      {
        id: 1713,
        pid: 203,
        city_code: '101250908',
        city_name: '武冈市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:22'
      },
      {
        id: 1714,
        pid: 203,
        city_code: '101250905',
        city_name: '邵东县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:22'
      },
      {
        id: 1715,
        pid: 203,
        city_code: '101250904',
        city_name: '新邵县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:22'
      },
      {
        id: 1716,
        pid: 203,
        city_code: '101250910',
        city_name: '邵阳县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:23'
      },
      {
        id: 1717,
        pid: 203,
        city_code: '101250902',
        city_name: '隆回县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:24'
      },
      {
        id: 1718,
        pid: 203,
        city_code: '101250903',
        city_name: '洞口县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:25'
      },
      {
        id: 1719,
        pid: 203,
        city_code: '101250906',
        city_name: '绥宁县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:25'
      },
      {
        id: 1720,
        pid: 203,
        city_code: '101250907',
        city_name: '新宁县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:25'
      },
      {
        id: 1723,
        pid: 204,
        city_code: '101250203',
        city_name: '湘乡市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:26'
      },
      {
        id: 1724,
        pid: 204,
        city_code: '101250202',
        city_name: '韶山市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:26'
      },
      {
        id: 1726,
        pid: 205,
        city_code: '101251501',
        city_name: '吉首市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:27'
      },
      {
        id: 1727,
        pid: 205,
        city_code: '101251506',
        city_name: '泸溪县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:27'
      },
      {
        id: 1728,
        pid: 205,
        city_code: '101251505',
        city_name: '凤凰县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:28'
      },
      {
        id: 1729,
        pid: 205,
        city_code: '101251508',
        city_name: '花垣县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:28'
      },
      {
        id: 1730,
        pid: 205,
        city_code: '101251502',
        city_name: '保靖县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:28'
      },
      {
        id: 1731,
        pid: 205,
        city_code: '101251504',
        city_name: '古丈县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:28'
      },
      {
        id: 1732,
        pid: 205,
        city_code: '101251503',
        city_name: '永顺县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:30'
      },
      {
        id: 1733,
        pid: 205,
        city_code: '101251507',
        city_name: '龙山县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:30'
      },
      {
        id: 1734,
        pid: 206,
        city_code: '101250701',
        city_name: '赫山区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:31'
      },
      {
        id: 1736,
        pid: 206,
        city_code: '101250705',
        city_name: '沅江市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:31'
      },
      {
        id: 1737,
        pid: 206,
        city_code: '101250702',
        city_name: '南县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:32'
      },
      {
        id: 1738,
        pid: 206,
        city_code: '101250703',
        city_name: '桃江县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:32'
      },
      {
        id: 1739,
        pid: 206,
        city_code: '101250704',
        city_name: '安化县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:32'
      },
      {
        id: 1740,
        pid: 207,
        city_code: '101251410',
        city_name: '江华瑶族自治县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:24:00'
      },
      {
        id: 1743,
        pid: 207,
        city_code: '101251402',
        city_name: '祁阳县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:33'
      },
      {
        id: 1744,
        pid: 207,
        city_code: '101251403',
        city_name: '东安县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:34'
      },
      {
        id: 1745,
        pid: 207,
        city_code: '101251404',
        city_name: '双牌县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:34'
      },
      {
        id: 1746,
        pid: 207,
        city_code: '101251405',
        city_name: '道县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:35'
      },
      {
        id: 1747,
        pid: 207,
        city_code: '101251407',
        city_name: '江永县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:35'
      },
      {
        id: 1748,
        pid: 207,
        city_code: '101251406',
        city_name: '宁远县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:35'
      },
      {
        id: 1749,
        pid: 207,
        city_code: '101251408',
        city_name: '蓝山县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:35'
      },
      {
        id: 1750,
        pid: 207,
        city_code: '101251409',
        city_name: '新田县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:36'
      },
      {
        id: 1754,
        pid: 208,
        city_code: '101251004',
        city_name: '汨罗市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:36'
      },
      {
        id: 1755,
        pid: 208,
        city_code: '101251006',
        city_name: '临湘市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:36'
      },
      {
        id: 1757,
        pid: 208,
        city_code: '101251002',
        city_name: '华容县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:37'
      },
      {
        id: 1758,
        pid: 208,
        city_code: '101251003',
        city_name: '湘阴县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:37'
      },
      {
        id: 1759,
        pid: 208,
        city_code: '101251005',
        city_name: '平江县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:38'
      },
      {
        id: 1764,
        pid: 209,
        city_code: '101250303',
        city_name: '醴陵市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:38'
      },
      {
        id: 1765,
        pid: 209,
        city_code: '101250304',
        city_name: '荷塘区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:24:00'
      },
      {
        id: 1766,
        pid: 209,
        city_code: '101250302',
        city_name: '攸县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:39'
      },
      {
        id: 1767,
        pid: 209,
        city_code: '101250305',
        city_name: '茶陵县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:41'
      },
      {
        id: 1768,
        pid: 209,
        city_code: '101250306',
        city_name: '炎陵县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:41'
      },
      {
        id: 1774,
        pid: 210,
        city_code: '101060106',
        city_name: '双阳区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:41'
      },
      {
        id: 1779,
        pid: 210,
        city_code: '101060103',
        city_name: '德惠市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:42'
      },
      {
        id: 1780,
        pid: 210,
        city_code: '101060104',
        city_name: '九台市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 17:36:21'
      },
      {
        id: 1781,
        pid: 210,
        city_code: '101060105',
        city_name: '榆树市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:42'
      },
      {
        id: 1782,
        pid: 210,
        city_code: '101060102',
        city_name: '农安县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:42'
      },
      {
        id: 1787,
        pid: 211,
        city_code: '101060204',
        city_name: '蛟河市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:43'
      },
      {
        id: 1788,
        pid: 211,
        city_code: '101060206',
        city_name: '桦甸市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:43'
      },
      {
        id: 1789,
        pid: 211,
        city_code: '101060202',
        city_name: '舒兰市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:43'
      },
      {
        id: 1790,
        pid: 211,
        city_code: '101060205',
        city_name: '磐石市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:43'
      },
      {
        id: 1791,
        pid: 211,
        city_code: '101060203',
        city_name: '永吉县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:43'
      },
      {
        id: 1793,
        pid: 212,
        city_code: '101060602',
        city_name: '洮南市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:45'
      },
      {
        id: 1794,
        pid: 212,
        city_code: '101060603',
        city_name: '大安市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:45'
      },
      {
        id: 1795,
        pid: 212,
        city_code: '101060604',
        city_name: '镇赉县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:45'
      },
      {
        id: 1796,
        pid: 212,
        city_code: '101060605',
        city_name: '通榆县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:46'
      },
      {
        id: 1797,
        pid: 213,
        city_code: '101060907',
        city_name: '江源区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:46'
      },
      {
        id: 1799,
        pid: 213,
        city_code: '101060905',
        city_name: '长白县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:46'
      },
      {
        id: 1800,
        pid: 213,
        city_code: '101060903',
        city_name: '临江市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:46'
      },
      {
        id: 1801,
        pid: 213,
        city_code: '101060906',
        city_name: '抚松县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:47'
      },
      {
        id: 1802,
        pid: 213,
        city_code: '101060902',
        city_name: '靖宇县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:47'
      },
      {
        id: 1805,
        pid: 214,
        city_code: '101060702',
        city_name: '东丰县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:47'
      },
      {
        id: 1806,
        pid: 214,
        city_code: '101060703',
        city_name: '东辽县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:48'
      },
      {
        id: 1809,
        pid: 215,
        city_code: '101060405',
        city_name: '伊通满族自治县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:24:00'
      },
      {
        id: 1810,
        pid: 215,
        city_code: '101060404',
        city_name: '公主岭市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:48'
      },
      {
        id: 1811,
        pid: 215,
        city_code: '101060402',
        city_name: '双辽市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:48'
      },
      {
        id: 1812,
        pid: 215,
        city_code: '101060403',
        city_name: '梨树县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:50'
      },
      {
        id: 1813,
        pid: 216,
        city_code: '101060803',
        city_name: '前郭县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:24:00'
      },
      {
        id: 1815,
        pid: 216,
        city_code: '101060804',
        city_name: '长岭县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:51'
      },
      {
        id: 1816,
        pid: 216,
        city_code: '101060802',
        city_name: '乾安县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:51'
      },
      {
        id: 1817,
        pid: 216,
        city_code: '101060805',
        city_name: '扶余市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:51'
      },
      {
        id: 1820,
        pid: 217,
        city_code: '101060502',
        city_name: '梅河口市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:51'
      },
      {
        id: 1821,
        pid: 217,
        city_code: '101060505',
        city_name: '集安市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:53'
      },
      {
        id: 1822,
        pid: 217,
        city_code: '101060506',
        city_name: '通化县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:53'
      },
      {
        id: 1823,
        pid: 217,
        city_code: '101060504',
        city_name: '辉南县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:54'
      },
      {
        id: 1824,
        pid: 217,
        city_code: '101060503',
        city_name: '柳河县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:54'
      },
      {
        id: 1825,
        pid: 218,
        city_code: '101060301',
        city_name: '延吉市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:55'
      },
      {
        id: 1826,
        pid: 218,
        city_code: '101060309',
        city_name: '图们市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:55'
      },
      {
        id: 1827,
        pid: 218,
        city_code: '101060302',
        city_name: '敦化市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:56'
      },
      {
        id: 1828,
        pid: 218,
        city_code: '101060308',
        city_name: '珲春市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:56'
      },
      {
        id: 1829,
        pid: 218,
        city_code: '101060307',
        city_name: '龙井市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:58'
      },
      {
        id: 1830,
        pid: 218,
        city_code: '101060305',
        city_name: '和龙市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:58'
      },
      {
        id: 1831,
        pid: 218,
        city_code: '101060303',
        city_name: '安图县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:58'
      },
      {
        id: 1832,
        pid: 218,
        city_code: '101060304',
        city_name: '汪清县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:58'
      },
      {
        id: 1841,
        pid: 219,
        city_code: '101190107',
        city_name: '浦口区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:27:59'
      },
      {
        id: 1842,
        pid: 219,
        city_code: '101190104',
        city_name: '江宁区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:28:00'
      },
      {
        id: 1843,
        pid: 219,
        city_code: '101190105',
        city_name: '六合区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:28:00'
      },
      {
        id: 1844,
        pid: 219,
        city_code: '101190102',
        city_name: '溧水区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:28:00'
      },
      {
        id: 1845,
        pid: 219,
        city_code: '101190103',
        city_name: '高淳区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:24:00'
      },
      {
        id: 1850,
        pid: 220,
        city_code: '101190405',
        city_name: '吴中区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:28:02'
      },
      {
        id: 1853,
        pid: 220,
        city_code: '101190404',
        city_name: '昆山市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:28:02'
      },
      {
        id: 1854,
        pid: 220,
        city_code: '101190402',
        city_name: '常熟市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:28:02'
      },
      {
        id: 1855,
        pid: 220,
        city_code: '101190403',
        city_name: '张家港市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:28:02'
      },
      {
        id: 1856,
        pid: 365,
        city_code: '101131101',
        city_name: '塔城市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 17:36:23'
      },
      {
        id: 1867,
        pid: 220,
        city_code: '101190407',
        city_name: '吴江区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:28:03'
      },
      {
        id: 1868,
        pid: 220,
        city_code: '101190408',
        city_name: '太仓市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:28:03'
      },
      {
        id: 1872,
        pid: 221,
        city_code: '101190204',
        city_name: '锡山区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:28:03'
      },
      {
        id: 1876,
        pid: 221,
        city_code: '101190202',
        city_name: '江阴市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:28:04'
      },
      {
        id: 1877,
        pid: 221,
        city_code: '101190203',
        city_name: '宜兴市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:28:04'
      },
      {
        id: 1883,
        pid: 222,
        city_code: '101191104',
        city_name: '武进区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:28:04'
      },
      {
        id: 1884,
        pid: 222,
        city_code: '101191102',
        city_name: '溧阳市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:28:04'
      },
      {
        id: 1885,
        pid: 222,
        city_code: '101191103',
        city_name: '金坛区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:28:04'
      },
      {
        id: 1888,
        pid: 223,
        city_code: '101190908',
        city_name: '淮安区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:24:00'
      },
      {
        id: 1889,
        pid: 223,
        city_code: '101190906',
        city_name: '淮阴区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:28:06'
      },
      {
        id: 1890,
        pid: 223,
        city_code: '101190905',
        city_name: '涟水县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:28:06'
      },
      {
        id: 1891,
        pid: 223,
        city_code: '101190904',
        city_name: '洪泽区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:24:00'
      },
      {
        id: 1892,
        pid: 223,
        city_code: '101190903',
        city_name: '盱眙县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:28:06'
      },
      {
        id: 1893,
        pid: 223,
        city_code: '101190902',
        city_name: '金湖县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:28:07'
      },
      {
        id: 1897,
        pid: 224,
        city_code: '101191003',
        city_name: '赣榆区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:24:00'
      },
      {
        id: 1898,
        pid: 224,
        city_code: '101191002',
        city_name: '东海县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:28:08'
      },
      {
        id: 1899,
        pid: 224,
        city_code: '101191004',
        city_name: '灌云县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:28:08'
      },
      {
        id: 1900,
        pid: 224,
        city_code: '101191005',
        city_name: '灌南县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:28:09'
      },
      {
        id: 1904,
        pid: 225,
        city_code: '101190507',
        city_name: '启东市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:28:11'
      },
      {
        id: 1905,
        pid: 225,
        city_code: '101190503',
        city_name: '如皋市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 17:16:44'
      },
      {
        id: 1906,
        pid: 225,
        city_code: '101190509',
        city_name: '通州区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:28:17'
      },
      {
        id: 1907,
        pid: 225,
        city_code: '101190508',
        city_name: '海门市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:28:18'
      },
      {
        id: 1908,
        pid: 225,
        city_code: '101190502',
        city_name: '海安县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:28:18'
      },
      {
        id: 1909,
        pid: 225,
        city_code: '101190504',
        city_name: '如东县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:28:18'
      },
      {
        id: 1911,
        pid: 226,
        city_code: '101191305',
        city_name: '宿豫区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:28:19'
      },
      {
        id: 1913,
        pid: 226,
        city_code: '101191302',
        city_name: '沭阳县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:28:19'
      },
      {
        id: 1914,
        pid: 226,
        city_code: '101191303',
        city_name: '泗阳县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:28:19'
      },
      {
        id: 1915,
        pid: 226,
        city_code: '101191304',
        city_name: '泗洪县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:28:19'
      },
      {
        id: 1918,
        pid: 227,
        city_code: '101191202',
        city_name: '兴化市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:28:21'
      },
      {
        id: 1919,
        pid: 227,
        city_code: '101191205',
        city_name: '靖江市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 17:16:46'
      },
      {
        id: 1920,
        pid: 227,
        city_code: '101191203',
        city_name: '泰兴市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:28:26'
      },
      {
        id: 1921,
        pid: 227,
        city_code: '101191204',
        city_name: '姜堰区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:28:30'
      },
      {
        id: 1927,
        pid: 228,
        city_code: '101190807',
        city_name: '新沂市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:28:31'
      },
      {
        id: 1928,
        pid: 228,
        city_code: '101190805',
        city_name: '邳州市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:28:31'
      },
      {
        id: 1929,
        pid: 228,
        city_code: '101190803',
        city_name: '丰县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:28:31'
      },
      {
        id: 1930,
        pid: 228,
        city_code: '101190804',
        city_name: '沛县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 17:16:48'
      },
      {
        id: 1931,
        pid: 228,
        city_code: '101190802',
        city_name: '铜山区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:28:36'
      },
      {
        id: 1932,
        pid: 228,
        city_code: '101190806',
        city_name: '睢宁县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:28:40'
      },
      {
        id: 1935,
        pid: 229,
        city_code: '101190709',
        city_name: '盐都区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:28:40'
      },
      {
        id: 1937,
        pid: 229,
        city_code: '101190707',
        city_name: '东台市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:28:40'
      },
      {
        id: 1938,
        pid: 229,
        city_code: '101190708',
        city_name: '大丰区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 17:16:49'
      },
      {
        id: 1939,
        pid: 229,
        city_code: '101190702',
        city_name: '响水县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:28:45'
      },
      {
        id: 1940,
        pid: 229,
        city_code: '101190703',
        city_name: '滨海县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:28:46'
      },
      {
        id: 1941,
        pid: 229,
        city_code: '101190704',
        city_name: '阜宁县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:28:50'
      },
      {
        id: 1942,
        pid: 229,
        city_code: '101190705',
        city_name: '射阳县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:28:50'
      },
      {
        id: 1943,
        pid: 229,
        city_code: '101190706',
        city_name: '建湖县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:28:50'
      },
      {
        id: 1946,
        pid: 230,
        city_code: '101190606',
        city_name: '邗江区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 17:16:50'
      },
      {
        id: 1947,
        pid: 230,
        city_code: '101190603',
        city_name: '仪征市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:00'
      },
      {
        id: 1948,
        pid: 230,
        city_code: '101190604',
        city_name: '高邮市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:00'
      },
      {
        id: 1949,
        pid: 230,
        city_code: '101190605',
        city_name: '江都市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 17:36:24'
      },
      {
        id: 1950,
        pid: 230,
        city_code: '101190602',
        city_name: '宝应县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:05'
      },
      {
        id: 1953,
        pid: 231,
        city_code: '101190305',
        city_name: '丹徒区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:05'
      },
      {
        id: 1954,
        pid: 231,
        city_code: '101190302',
        city_name: '丹阳市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:10'
      },
      {
        id: 1955,
        pid: 231,
        city_code: '101190303',
        city_name: '扬中市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:10'
      },
      {
        id: 1956,
        pid: 231,
        city_code: '101190304',
        city_name: '句容市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 17:16:52'
      },
      {
        id: 1965,
        pid: 232,
        city_code: '101240103',
        city_name: '南昌县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:16'
      },
      {
        id: 1966,
        pid: 232,
        city_code: '101240102',
        city_name: '新建区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:24:00'
      },
      {
        id: 1967,
        pid: 232,
        city_code: '101240104',
        city_name: '安义县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:17'
      },
      {
        id: 1968,
        pid: 232,
        city_code: '101240105',
        city_name: '进贤县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:17'
      },
      {
        id: 1970,
        pid: 233,
        city_code: '101240408',
        city_name: '南城县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:17'
      },
      {
        id: 1971,
        pid: 233,
        city_code: '101240410',
        city_name: '黎川县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:17'
      },
      {
        id: 1972,
        pid: 233,
        city_code: '101240409',
        city_name: '南丰县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:18'
      },
      {
        id: 1973,
        pid: 233,
        city_code: '101240404',
        city_name: '崇仁县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:18'
      },
      {
        id: 1974,
        pid: 233,
        city_code: '101240403',
        city_name: '乐安县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:18'
      },
      {
        id: 1975,
        pid: 233,
        city_code: '101240407',
        city_name: '宜黄县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:18'
      },
      {
        id: 1976,
        pid: 233,
        city_code: '101240405',
        city_name: '金溪县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:19'
      },
      {
        id: 1977,
        pid: 233,
        city_code: '101240406',
        city_name: '资溪县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:19'
      },
      {
        id: 1978,
        pid: 233,
        city_code: '101240411',
        city_name: '东乡县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:19'
      },
      {
        id: 1979,
        pid: 233,
        city_code: '101240402',
        city_name: '广昌县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:19'
      },
      {
        id: 1981,
        pid: 234,
        city_code: '101240710',
        city_name: '于都县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:20'
      },
      {
        id: 1982,
        pid: 234,
        city_code: '101240709',
        city_name: '瑞金市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:20'
      },
      {
        id: 1983,
        pid: 234,
        city_code: '101240704',
        city_name: '南康市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 17:36:24'
      },
      {
        id: 1984,
        pid: 234,
        city_code: '101240718',
        city_name: '赣县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:20'
      },
      {
        id: 1985,
        pid: 234,
        city_code: '101240706',
        city_name: '信丰县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:21'
      },
      {
        id: 1986,
        pid: 234,
        city_code: '101240705',
        city_name: '大余县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:21'
      },
      {
        id: 1987,
        pid: 234,
        city_code: '101240703',
        city_name: '上犹县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:21'
      },
      {
        id: 1988,
        pid: 234,
        city_code: '101240702',
        city_name: '崇义县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:22'
      },
      {
        id: 1989,
        pid: 234,
        city_code: '101240712',
        city_name: '安远县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:23'
      },
      {
        id: 1990,
        pid: 234,
        city_code: '101240714',
        city_name: '龙南县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:23'
      },
      {
        id: 1991,
        pid: 234,
        city_code: '101240715',
        city_name: '定南县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:23'
      },
      {
        id: 1992,
        pid: 234,
        city_code: '101240713',
        city_name: '全南县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:23'
      },
      {
        id: 1993,
        pid: 234,
        city_code: '101240707',
        city_name: '宁都县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:24'
      },
      {
        id: 1994,
        pid: 234,
        city_code: '101240717',
        city_name: '兴国县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:24'
      },
      {
        id: 1995,
        pid: 234,
        city_code: '101240711',
        city_name: '会昌县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:24'
      },
      {
        id: 1996,
        pid: 234,
        city_code: '101240716',
        city_name: '寻乌县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:24'
      },
      {
        id: 1997,
        pid: 234,
        city_code: '101240708',
        city_name: '石城县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:25'
      },
      {
        id: 1998,
        pid: 235,
        city_code: '101240612',
        city_name: '安福县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:25'
      },
      {
        id: 2001,
        pid: 235,
        city_code: '101240608',
        city_name: '井冈山市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:25'
      },
      {
        id: 2002,
        pid: 235,
        city_code: '101240602',
        city_name: '吉安县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:25'
      },
      {
        id: 2003,
        pid: 235,
        city_code: '101240603',
        city_name: '吉水县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:26'
      },
      {
        id: 2004,
        pid: 235,
        city_code: '101240605',
        city_name: '峡江县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:26'
      },
      {
        id: 2005,
        pid: 235,
        city_code: '101240604',
        city_name: '新干县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:26'
      },
      {
        id: 2006,
        pid: 235,
        city_code: '101240606',
        city_name: '永丰县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:26'
      },
      {
        id: 2007,
        pid: 235,
        city_code: '101240611',
        city_name: '泰和县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:27'
      },
      {
        id: 2008,
        pid: 235,
        city_code: '101240610',
        city_name: '遂川县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:27'
      },
      {
        id: 2009,
        pid: 235,
        city_code: '101240609',
        city_name: '万安县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:27'
      },
      {
        id: 2010,
        pid: 235,
        city_code: '101240607',
        city_name: '永新县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:27'
      },
      {
        id: 2013,
        pid: 236,
        city_code: '101240802',
        city_name: '乐平市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:28'
      },
      {
        id: 2014,
        pid: 236,
        city_code: '101240803',
        city_name: '浮梁县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:28'
      },
      {
        id: 2016,
        pid: 237,
        city_code: '101240203',
        city_name: '庐山市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:24:00'
      },
      {
        id: 2017,
        pid: 237,
        city_code: '101240202',
        city_name: '瑞昌市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:28'
      },
      {
        id: 2019,
        pid: 237,
        city_code: '101240204',
        city_name: '武宁县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:29'
      },
      {
        id: 2020,
        pid: 237,
        city_code: '101240212',
        city_name: '修水县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:29'
      },
      {
        id: 2021,
        pid: 237,
        city_code: '101240206',
        city_name: '永修县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:29'
      },
      {
        id: 2022,
        pid: 237,
        city_code: '101240205',
        city_name: '德安县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:29'
      },
      {
        id: 2023,
        pid: 237,
        city_code: '101240209',
        city_name: '星子县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:24:00'
      },
      {
        id: 2024,
        pid: 237,
        city_code: '101240210',
        city_name: '都昌县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:30'
      },
      {
        id: 2025,
        pid: 237,
        city_code: '101240207',
        city_name: '湖口县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:30'
      },
      {
        id: 2026,
        pid: 237,
        city_code: '101240208',
        city_name: '彭泽县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:31'
      },
      {
        id: 2027,
        pid: 238,
        city_code: '101240904',
        city_name: '安源区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:32'
      },
      {
        id: 2028,
        pid: 238,
        city_code: '101240906',
        city_name: '湘东区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:33'
      },
      {
        id: 2029,
        pid: 238,
        city_code: '101240902',
        city_name: '莲花县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:33'
      },
      {
        id: 2030,
        pid: 238,
        city_code: '101240905',
        city_name: '芦溪县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:34'
      },
      {
        id: 2031,
        pid: 238,
        city_code: '101240903',
        city_name: '上栗县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:34'
      },
      {
        id: 2033,
        pid: 239,
        city_code: '101240307',
        city_name: '德兴市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:35'
      },
      {
        id: 2034,
        pid: 239,
        city_code: '101240308',
        city_name: '上饶县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:35'
      },
      {
        id: 2035,
        pid: 239,
        city_code: '101240313',
        city_name: '广丰区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:24:00'
      },
      {
        id: 2036,
        pid: 239,
        city_code: '101240312',
        city_name: '玉山县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:35'
      },
      {
        id: 2037,
        pid: 239,
        city_code: '101240311',
        city_name: '铅山县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:37'
      },
      {
        id: 2038,
        pid: 239,
        city_code: '101240310',
        city_name: '横峰县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:38'
      },
      {
        id: 2039,
        pid: 239,
        city_code: '101240309',
        city_name: '弋阳县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:38'
      },
      {
        id: 2040,
        pid: 239,
        city_code: '101240305',
        city_name: '余干县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:38'
      },
      {
        id: 2041,
        pid: 239,
        city_code: '101240302',
        city_name: '鄱阳县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 17:17:05'
      },
      {
        id: 2042,
        pid: 239,
        city_code: '101240306',
        city_name: '万年县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:45'
      },
      {
        id: 2043,
        pid: 239,
        city_code: '101240303',
        city_name: '婺源县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:45'
      },
      {
        id: 2045,
        pid: 240,
        city_code: '101241002',
        city_name: '分宜县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:45'
      },
      {
        id: 2047,
        pid: 241,
        city_code: '101240510',
        city_name: '丰城市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:45'
      },
      {
        id: 2048,
        pid: 241,
        city_code: '101240509',
        city_name: '樟树市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:46'
      },
      {
        id: 2049,
        pid: 241,
        city_code: '101240508',
        city_name: '高安市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:46'
      },
      {
        id: 2050,
        pid: 241,
        city_code: '101240507',
        city_name: '奉新县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:46'
      },
      {
        id: 2051,
        pid: 241,
        city_code: '101240504',
        city_name: '万载县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:47'
      },
      {
        id: 2052,
        pid: 241,
        city_code: '101240505',
        city_name: '上高县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:48'
      },
      {
        id: 2053,
        pid: 241,
        city_code: '101240503',
        city_name: '宜丰县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:48'
      },
      {
        id: 2054,
        pid: 241,
        city_code: '101240506',
        city_name: '靖安县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:48'
      },
      {
        id: 2055,
        pid: 241,
        city_code: '101240502',
        city_name: '铜鼓县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:49'
      },
      {
        id: 2057,
        pid: 242,
        city_code: '101241103',
        city_name: '贵溪市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:50'
      },
      {
        id: 2058,
        pid: 242,
        city_code: '101241102',
        city_name: '余江县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:51'
      },
      {
        id: 2064,
        pid: 243,
        city_code: '101070112',
        city_name: '苏家屯区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:51'
      },
      {
        id: 2067,
        pid: 243,
        city_code: '101070114',
        city_name: '于洪区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:52'
      },
      {
        id: 2069,
        pid: 243,
        city_code: '101070106',
        city_name: '新民市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:52'
      },
      {
        id: 2070,
        pid: 243,
        city_code: '101070103',
        city_name: '辽中区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 21:24:11'
      },
      {
        id: 2071,
        pid: 243,
        city_code: '101070104',
        city_name: '康平县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:52'
      },
      {
        id: 2072,
        pid: 243,
        city_code: '101070105',
        city_name: '法库县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:53'
      },
      {
        id: 2077,
        pid: 244,
        city_code: '101070205',
        city_name: '旅顺口区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:53'
      },
      {
        id: 2078,
        pid: 244,
        city_code: '101070203',
        city_name: '金州区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:54'
      },
      {
        id: 2080,
        pid: 244,
        city_code: '101070202',
        city_name: '瓦房店市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:54'
      },
      {
        id: 2081,
        pid: 244,
        city_code: '101070204',
        city_name: '普兰店市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 17:36:27'
      },
      {
        id: 2082,
        pid: 244,
        city_code: '101070207',
        city_name: '庄河市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:56'
      },
      {
        id: 2083,
        pid: 244,
        city_code: '101070206',
        city_name: '长海县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:56'
      },
      {
        id: 2088,
        pid: 245,
        city_code: '101070303',
        city_name: '岫岩县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:56'
      },
      {
        id: 2089,
        pid: 245,
        city_code: '101070304',
        city_name: '海城市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:57'
      },
      {
        id: 2090,
        pid: 245,
        city_code: '101070302',
        city_name: '台安县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:57'
      },
      {
        id: 2091,
        pid: 246,
        city_code: '101070502',
        city_name: '本溪县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:29:58'
      },
      {
        id: 2096,
        pid: 246,
        city_code: '101070504',
        city_name: '桓仁县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:00'
      },
      {
        id: 2099,
        pid: 247,
        city_code: '101071204',
        city_name: '喀喇沁左翼蒙古族自治县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:24:00'
      },
      {
        id: 2100,
        pid: 247,
        city_code: '101071205',
        city_name: '北票市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:01'
      },
      {
        id: 2101,
        pid: 247,
        city_code: '101071203',
        city_name: '凌源市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:01'
      },
      {
        id: 2103,
        pid: 247,
        city_code: '101071207',
        city_name: '建平县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:01'
      },
      {
        id: 2107,
        pid: 248,
        city_code: '101070603',
        city_name: '宽甸县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:02'
      },
      {
        id: 2108,
        pid: 248,
        city_code: '101070604',
        city_name: '东港市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:02'
      },
      {
        id: 2109,
        pid: 248,
        city_code: '101070602',
        city_name: '凤城市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:02'
      },
      {
        id: 2114,
        pid: 249,
        city_code: '101070403',
        city_name: '清原县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:02'
      },
      {
        id: 2115,
        pid: 249,
        city_code: '101070402',
        city_name: '新宾县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:03'
      },
      {
        id: 2123,
        pid: 250,
        city_code: '101070902',
        city_name: '彰武县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:03'
      },
      {
        id: 2127,
        pid: 251,
        city_code: '101071404',
        city_name: '兴城市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:03'
      },
      {
        id: 2128,
        pid: 251,
        city_code: '101071403',
        city_name: '绥中县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:05'
      },
      {
        id: 2129,
        pid: 251,
        city_code: '101071402',
        city_name: '建昌县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:06'
      },
      {
        id: 2133,
        pid: 252,
        city_code: '101070702',
        city_name: '凌海市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:06'
      },
      {
        id: 2134,
        pid: 252,
        city_code: '101070706',
        city_name: '北镇市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:07'
      },
      {
        id: 2135,
        pid: 252,
        city_code: '101070705',
        city_name: '黑山县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:08'
      },
      {
        id: 2136,
        pid: 252,
        city_code: '101070704',
        city_name: '义县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:08'
      },
      {
        id: 2141,
        pid: 253,
        city_code: '101071004',
        city_name: '弓长岭区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:08'
      },
      {
        id: 2142,
        pid: 253,
        city_code: '101071003',
        city_name: '灯塔市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 17:17:14'
      },
      {
        id: 2143,
        pid: 253,
        city_code: '101071002',
        city_name: '辽阳县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:13'
      },
      {
        id: 2146,
        pid: 254,
        city_code: '101071302',
        city_name: '大洼区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 21:24:12'
      },
      {
        id: 2147,
        pid: 254,
        city_code: '101071303',
        city_name: '盘山县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:15'
      },
      {
        id: 2150,
        pid: 255,
        city_code: '101071105',
        city_name: '调兵山市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:16'
      },
      {
        id: 2151,
        pid: 255,
        city_code: '101071102',
        city_name: '开原市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:17'
      },
      {
        id: 2153,
        pid: 255,
        city_code: '101071104',
        city_name: '西丰县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:19'
      },
      {
        id: 2154,
        pid: 255,
        city_code: '101071103',
        city_name: '昌图县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:19'
      },
      {
        id: 2159,
        pid: 256,
        city_code: '101070803',
        city_name: '盖州市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:19'
      },
      {
        id: 2160,
        pid: 256,
        city_code: '101070802',
        city_name: '大石桥市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:19'
      },
      {
        id: 2165,
        pid: 257,
        city_code: '101080105',
        city_name: '清水河县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:20'
      },
      {
        id: 2166,
        pid: 257,
        city_code: '101080102',
        city_name: '土默特左旗',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:20'
      },
      {
        id: 2167,
        pid: 257,
        city_code: '101080103',
        city_name: '托克托县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:20'
      },
      {
        id: 2168,
        pid: 257,
        city_code: '101080104',
        city_name: '和林格尔县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:20'
      },
      {
        id: 2169,
        pid: 257,
        city_code: '101080107',
        city_name: '武川县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:22'
      },
      {
        id: 2170,
        pid: 258,
        city_code: '101081201',
        city_name: '阿拉善左旗',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:22'
      },
      {
        id: 2171,
        pid: 258,
        city_code: '101081202',
        city_name: '阿拉善右旗',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:22'
      },
      {
        id: 2172,
        pid: 258,
        city_code: '101081203',
        city_name: '额济纳旗',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:23'
      },
      {
        id: 2173,
        pid: 259,
        city_code: '101080801',
        city_name: '临河区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:24'
      },
      {
        id: 2174,
        pid: 259,
        city_code: '101080802',
        city_name: '五原县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:24'
      },
      {
        id: 2175,
        pid: 259,
        city_code: '101080803',
        city_name: '磴口县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:25'
      },
      {
        id: 2176,
        pid: 259,
        city_code: '101080804',
        city_name: '乌拉特前旗',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:26'
      },
      {
        id: 2177,
        pid: 259,
        city_code: '101080806',
        city_name: '乌拉特中旗',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:26'
      },
      {
        id: 2178,
        pid: 259,
        city_code: '101080807',
        city_name: '乌拉特后旗',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:27'
      },
      {
        id: 2179,
        pid: 259,
        city_code: '101080810',
        city_name: '杭锦后旗',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:27'
      },
      {
        id: 2184,
        pid: 260,
        city_code: '101080211',
        city_name: '石拐区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:28'
      },
      {
        id: 2185,
        pid: 260,
        city_code: '101080202',
        city_name: '白云鄂博',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:28'
      },
      {
        id: 2186,
        pid: 260,
        city_code: '101080204',
        city_name: '土默特右旗',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:29'
      },
      {
        id: 2187,
        pid: 260,
        city_code: '101080205',
        city_name: '固阳县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:29'
      },
      {
        id: 2188,
        pid: 260,
        city_code: '101080206',
        city_name: '达茂旗',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 21:24:12'
      },
      {
        id: 2192,
        pid: 261,
        city_code: '101080603',
        city_name: '阿鲁科尔沁旗',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:30'
      },
      {
        id: 2193,
        pid: 261,
        city_code: '101080605',
        city_name: '巴林左旗',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:30'
      },
      {
        id: 2194,
        pid: 261,
        city_code: '101080606',
        city_name: '巴林右旗',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:32'
      },
      {
        id: 2195,
        pid: 261,
        city_code: '101080607',
        city_name: '林西县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:33'
      },
      {
        id: 2196,
        pid: 261,
        city_code: '101080608',
        city_name: '克什克腾旗',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:33'
      },
      {
        id: 2197,
        pid: 261,
        city_code: '101080609',
        city_name: '翁牛特旗',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:33'
      },
      {
        id: 2198,
        pid: 261,
        city_code: '101080611',
        city_name: '喀喇沁旗',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:34'
      },
      {
        id: 2199,
        pid: 261,
        city_code: '101080613',
        city_name: '宁城县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:34'
      },
      {
        id: 2200,
        pid: 261,
        city_code: '101080614',
        city_name: '敖汉旗',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:35'
      },
      {
        id: 2201,
        pid: 262,
        city_code: '101080713',
        city_name: '东胜区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:36'
      },
      {
        id: 2202,
        pid: 262,
        city_code: '101080703',
        city_name: '达拉特旗',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:36'
      },
      {
        id: 2203,
        pid: 262,
        city_code: '101080704',
        city_name: '准格尔旗',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:36'
      },
      {
        id: 2204,
        pid: 262,
        city_code: '101080705',
        city_name: '鄂托克前旗',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:40'
      },
      {
        id: 2205,
        pid: 262,
        city_code: '101080708',
        city_name: '鄂托克旗',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:41'
      },
      {
        id: 2206,
        pid: 262,
        city_code: '101080709',
        city_name: '杭锦旗',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:41'
      },
      {
        id: 2207,
        pid: 262,
        city_code: '101080710',
        city_name: '乌审旗',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:41'
      },
      {
        id: 2208,
        pid: 262,
        city_code: '101080711',
        city_name: '伊金霍洛旗',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:41'
      },
      {
        id: 2210,
        pid: 263,
        city_code: '101081004',
        city_name: '莫力达瓦',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 17:36:29'
      },
      {
        id: 2211,
        pid: 263,
        city_code: '101081010',
        city_name: '满洲里市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:42'
      },
      {
        id: 2212,
        pid: 263,
        city_code: '101081011',
        city_name: '牙克石市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:42'
      },
      {
        id: 2213,
        pid: 263,
        city_code: '101081012',
        city_name: '扎兰屯市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:42'
      },
      {
        id: 2214,
        pid: 263,
        city_code: '101081014',
        city_name: '额尔古纳市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:43'
      },
      {
        id: 2215,
        pid: 263,
        city_code: '101081015',
        city_name: '根河市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:43'
      },
      {
        id: 2216,
        pid: 263,
        city_code: '101081003',
        city_name: '阿荣旗',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:43'
      },
      {
        id: 2217,
        pid: 263,
        city_code: '101081005',
        city_name: '鄂伦春旗',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 21:24:13'
      },
      {
        id: 2218,
        pid: 263,
        city_code: '101081006',
        city_name: '鄂温克族旗',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 21:24:13'
      },
      {
        id: 2219,
        pid: 263,
        city_code: '101081007',
        city_name: '陈巴尔虎旗',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:44'
      },
      {
        id: 2220,
        pid: 263,
        city_code: '101081008',
        city_name: '新巴尔虎左旗',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:45'
      },
      {
        id: 2221,
        pid: 263,
        city_code: '101081009',
        city_name: '新巴尔虎右旗',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:47'
      },
      {
        id: 2223,
        pid: 264,
        city_code: '101080512',
        city_name: '霍林郭勒市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:47'
      },
      {
        id: 2224,
        pid: 264,
        city_code: '101080503',
        city_name: '科尔沁左翼中旗',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:47'
      },
      {
        id: 2225,
        pid: 264,
        city_code: '101080504',
        city_name: '科尔沁左翼后旗',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:47'
      },
      {
        id: 2226,
        pid: 264,
        city_code: '101080506',
        city_name: '开鲁县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:48'
      },
      {
        id: 2227,
        pid: 264,
        city_code: '101080507',
        city_name: '库伦旗',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:48'
      },
      {
        id: 2228,
        pid: 264,
        city_code: '101080508',
        city_name: '奈曼旗',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:48'
      },
      {
        id: 2229,
        pid: 264,
        city_code: '101080509',
        city_name: '扎鲁特旗',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:48'
      },
      {
        id: 2233,
        pid: 266,
        city_code: '101080403',
        city_name: '化德县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:49'
      },
      {
        id: 2234,
        pid: 266,
        city_code: '101080401',
        city_name: '集宁区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:50'
      },
      {
        id: 2235,
        pid: 266,
        city_code: '101080412',
        city_name: '丰镇市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:50'
      },
      {
        id: 2236,
        pid: 266,
        city_code: '101080402',
        city_name: '卓资县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:50'
      },
      {
        id: 2237,
        pid: 266,
        city_code: '101080404',
        city_name: '商都县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:52'
      },
      {
        id: 2238,
        pid: 266,
        city_code: '101080406',
        city_name: '兴和县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:52'
      },
      {
        id: 2239,
        pid: 266,
        city_code: '101080407',
        city_name: '凉城县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:52'
      },
      {
        id: 2240,
        pid: 266,
        city_code: '101080408',
        city_name: '察哈尔右翼前旗',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:52'
      },
      {
        id: 2241,
        pid: 266,
        city_code: '101080409',
        city_name: '察哈尔右翼中旗',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:55'
      },
      {
        id: 2242,
        pid: 266,
        city_code: '101080410',
        city_name: '察哈尔右翼后旗',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:55'
      },
      {
        id: 2243,
        pid: 266,
        city_code: '101080411',
        city_name: '四子王旗',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:55'
      },
      {
        id: 2244,
        pid: 267,
        city_code: '101080903',
        city_name: '二连浩特市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:56'
      },
      {
        id: 2245,
        pid: 267,
        city_code: '101080901',
        city_name: '锡林浩特市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:58'
      },
      {
        id: 2246,
        pid: 267,
        city_code: '101080904',
        city_name: '阿巴嘎旗',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:30:58'
      },
      {
        id: 2247,
        pid: 267,
        city_code: '101080906',
        city_name: '苏尼特左旗',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 17:17:23'
      },
      {
        id: 2248,
        pid: 267,
        city_code: '101080907',
        city_name: '苏尼特右旗',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:03'
      },
      {
        id: 2249,
        pid: 267,
        city_code: '101080909',
        city_name: '东乌珠穆沁旗',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:04'
      },
      {
        id: 2250,
        pid: 267,
        city_code: '101080910',
        city_name: '西乌珠穆沁旗',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:05'
      },
      {
        id: 2251,
        pid: 267,
        city_code: '101080911',
        city_name: '太仆寺旗',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:05'
      },
      {
        id: 2252,
        pid: 267,
        city_code: '101080912',
        city_name: '镶黄旗',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:05'
      },
      {
        id: 2253,
        pid: 267,
        city_code: '101080913',
        city_name: '正镶白旗',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:06'
      },
      {
        id: 2255,
        pid: 267,
        city_code: '101080915',
        city_name: '多伦县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:07'
      },
      {
        id: 2256,
        pid: 268,
        city_code: '101081101',
        city_name: '乌兰浩特市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:07'
      },
      {
        id: 2257,
        pid: 268,
        city_code: '101081102',
        city_name: '阿尔山市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:08'
      },
      {
        id: 2258,
        pid: 268,
        city_code: '101081109',
        city_name: '科尔沁右翼前旗',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:09'
      },
      {
        id: 2259,
        pid: 268,
        city_code: '101081103',
        city_name: '科尔沁右翼中旗',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:10'
      },
      {
        id: 2260,
        pid: 268,
        city_code: '101081105',
        city_name: '扎赉特旗',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:10'
      },
      {
        id: 2261,
        pid: 268,
        city_code: '101081107',
        city_name: '突泉县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:11'
      },
      {
        id: 2265,
        pid: 269,
        city_code: '101170103',
        city_name: '灵武市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:12'
      },
      {
        id: 2266,
        pid: 269,
        city_code: '101170102',
        city_name: '永宁县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:12'
      },
      {
        id: 2267,
        pid: 269,
        city_code: '101170104',
        city_name: '贺兰县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:13'
      },
      {
        id: 2270,
        pid: 270,
        city_code: '101170402',
        city_name: '西吉县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:14'
      },
      {
        id: 2271,
        pid: 270,
        city_code: '101170403',
        city_name: '隆德县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:14'
      },
      {
        id: 2272,
        pid: 270,
        city_code: '101170404',
        city_name: '泾源县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:15'
      },
      {
        id: 2273,
        pid: 270,
        city_code: '101170406',
        city_name: '彭阳县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:16'
      },
      {
        id: 2274,
        pid: 271,
        city_code: '101170202',
        city_name: '惠农区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:17'
      },
      {
        id: 2275,
        pid: 271,
        city_code: '101170205',
        city_name: '大武口区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:17'
      },
      {
        id: 2277,
        pid: 271,
        city_code: '101170204',
        city_name: '陶乐',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 21:24:13'
      },
      {
        id: 2278,
        pid: 271,
        city_code: '101170203',
        city_name: '平罗县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:18'
      },
      {
        id: 2281,
        pid: 272,
        city_code: '101170306',
        city_name: '青铜峡市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:19'
      },
      {
        id: 2283,
        pid: 272,
        city_code: '101170303',
        city_name: '盐池县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:19'
      },
      {
        id: 2284,
        pid: 272,
        city_code: '101170302',
        city_name: '同心县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:19'
      },
      {
        id: 2286,
        pid: 273,
        city_code: '101170504',
        city_name: '海原县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:20'
      },
      {
        id: 2287,
        pid: 273,
        city_code: '101170502',
        city_name: '中宁县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:21'
      },
      {
        id: 2292,
        pid: 274,
        city_code: '101150104',
        city_name: '湟中县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:21'
      },
      {
        id: 2293,
        pid: 274,
        city_code: '101150103',
        city_name: '湟源县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:21'
      },
      {
        id: 2294,
        pid: 274,
        city_code: '101150102',
        city_name: '大通县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:23'
      },
      {
        id: 2295,
        pid: 275,
        city_code: '101150501',
        city_name: '玛沁县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:24'
      },
      {
        id: 2296,
        pid: 275,
        city_code: '101150502',
        city_name: '班玛县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:24'
      },
      {
        id: 2297,
        pid: 275,
        city_code: '101150503',
        city_name: '甘德县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:24'
      },
      {
        id: 2298,
        pid: 275,
        city_code: '101150504',
        city_name: '达日县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:25'
      },
      {
        id: 2299,
        pid: 275,
        city_code: '101150505',
        city_name: '久治县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:25'
      },
      {
        id: 2300,
        pid: 275,
        city_code: '101150506',
        city_name: '玛多县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:26'
      },
      {
        id: 2301,
        pid: 276,
        city_code: '101150801',
        city_name: '海晏县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:26'
      },
      {
        id: 2302,
        pid: 276,
        city_code: '101150803',
        city_name: '祁连县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:30'
      },
      {
        id: 2303,
        pid: 276,
        city_code: '101150806',
        city_name: '刚察县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:30'
      },
      {
        id: 2304,
        pid: 276,
        city_code: '101150802',
        city_name: '门源县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:30'
      },
      {
        id: 2305,
        pid: 277,
        city_code: '101150208',
        city_name: '平安县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 21:24:13'
      },
      {
        id: 2306,
        pid: 277,
        city_code: '101150202',
        city_name: '乐都区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 21:24:14'
      },
      {
        id: 2307,
        pid: 277,
        city_code: '101150203',
        city_name: '民和县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:31'
      },
      {
        id: 2308,
        pid: 277,
        city_code: '101150204',
        city_name: '互助县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:31'
      },
      {
        id: 2309,
        pid: 277,
        city_code: '101150205',
        city_name: '化隆县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:31'
      },
      {
        id: 2310,
        pid: 277,
        city_code: '101150206',
        city_name: '循化县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:32'
      },
      {
        id: 2312,
        pid: 278,
        city_code: '101150408',
        city_name: '同德县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:32'
      },
      {
        id: 2313,
        pid: 278,
        city_code: '101150404',
        city_name: '贵德县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:32'
      },
      {
        id: 2314,
        pid: 278,
        city_code: '101150406',
        city_name: '兴海县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:32'
      },
      {
        id: 2315,
        pid: 278,
        city_code: '101150407',
        city_name: '贵南县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:33'
      },
      {
        id: 2317,
        pid: 279,
        city_code: '101150714',
        city_name: '格尔木市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:33'
      },
      {
        id: 2318,
        pid: 279,
        city_code: '101150709',
        city_name: '乌兰县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:34'
      },
      {
        id: 2319,
        pid: 279,
        city_code: '101150715',
        city_name: '都兰县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:34'
      },
      {
        id: 2320,
        pid: 279,
        city_code: '101150708',
        city_name: '天峻县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:34'
      },
      {
        id: 2321,
        pid: 280,
        city_code: '101150301',
        city_name: '同仁县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:34'
      },
      {
        id: 2322,
        pid: 280,
        city_code: '101150302',
        city_name: '尖扎县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:35'
      },
      {
        id: 2323,
        pid: 280,
        city_code: '101150303',
        city_name: '泽库县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:35'
      },
      {
        id: 2324,
        pid: 280,
        city_code: '101150304',
        city_name: '河南县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 21:24:14'
      },
      {
        id: 2326,
        pid: 281,
        city_code: '101150604',
        city_name: '杂多县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:36'
      },
      {
        id: 2327,
        pid: 281,
        city_code: '101150602',
        city_name: '称多县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:36'
      },
      {
        id: 2328,
        pid: 281,
        city_code: '101150603',
        city_name: '治多县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:36'
      },
      {
        id: 2329,
        pid: 281,
        city_code: '101150605',
        city_name: '囊谦县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:36'
      },
      {
        id: 2330,
        pid: 281,
        city_code: '101150606',
        city_name: '曲麻莱县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:37'
      },
      {
        id: 2336,
        pid: 282,
        city_code: '101120102',
        city_name: '长清区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:37'
      },
      {
        id: 2337,
        pid: 282,
        city_code: '101120104',
        city_name: '章丘市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 17:36:33'
      },
      {
        id: 2338,
        pid: 282,
        city_code: '101120105',
        city_name: '平阴县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:37'
      },
      {
        id: 2339,
        pid: 282,
        city_code: '101120106',
        city_name: '济阳县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:37'
      },
      {
        id: 2340,
        pid: 282,
        city_code: '101120103',
        city_name: '商河县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:38'
      },
      {
        id: 2347,
        pid: 283,
        city_code: '101120202',
        city_name: '崂山区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:38'
      },
      {
        id: 2348,
        pid: 283,
        city_code: '101120205',
        city_name: '胶州市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:38'
      },
      {
        id: 2349,
        pid: 283,
        city_code: '101120204',
        city_name: '即墨市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:39'
      },
      {
        id: 2350,
        pid: 283,
        city_code: '101120208',
        city_name: '平度市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:39'
      },
      {
        id: 2351,
        pid: 283,
        city_code: '101120206',
        city_name: '黄岛区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 21:24:15'
      },
      {
        id: 2352,
        pid: 283,
        city_code: '101120207',
        city_name: '莱西市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:39'
      },
      {
        id: 2354,
        pid: 284,
        city_code: '101121105',
        city_name: '惠民县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:39'
      },
      {
        id: 2355,
        pid: 284,
        city_code: '101121104',
        city_name: '阳信县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:40'
      },
      {
        id: 2356,
        pid: 284,
        city_code: '101121103',
        city_name: '无棣县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:40'
      },
      {
        id: 2357,
        pid: 284,
        city_code: '101121106',
        city_name: '沾化区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 21:24:15'
      },
      {
        id: 2358,
        pid: 284,
        city_code: '101121102',
        city_name: '博兴县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:40'
      },
      {
        id: 2359,
        pid: 284,
        city_code: '101121107',
        city_name: '邹平县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:41'
      },
      {
        id: 2361,
        pid: 285,
        city_code: '101120404',
        city_name: '兰陵县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 21:24:16'
      },
      {
        id: 2362,
        pid: 285,
        city_code: '101120406',
        city_name: '乐陵市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:41'
      },
      {
        id: 2363,
        pid: 285,
        city_code: '101120411',
        city_name: '禹城市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:41'
      },
      {
        id: 2364,
        pid: 285,
        city_code: '101120409',
        city_name: '宁津县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:41'
      },
      {
        id: 2365,
        pid: 285,
        city_code: '101120407',
        city_name: '庆云县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:42'
      },
      {
        id: 2366,
        pid: 285,
        city_code: '101120403',
        city_name: '临邑县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:42'
      },
      {
        id: 2367,
        pid: 285,
        city_code: '101120405',
        city_name: '齐河县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:42'
      },
      {
        id: 2368,
        pid: 285,
        city_code: '101120408',
        city_name: '平原县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:42'
      },
      {
        id: 2369,
        pid: 285,
        city_code: '101120410',
        city_name: '夏津县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:43'
      },
      {
        id: 2370,
        pid: 285,
        city_code: '101120402',
        city_name: '武城县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:43'
      },
      {
        id: 2372,
        pid: 286,
        city_code: '101121202',
        city_name: '河口区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:43'
      },
      {
        id: 2373,
        pid: 286,
        city_code: '101121203',
        city_name: '垦利区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 21:24:16'
      },
      {
        id: 2374,
        pid: 286,
        city_code: '101121204',
        city_name: '利津县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:44'
      },
      {
        id: 2375,
        pid: 286,
        city_code: '101121205',
        city_name: '广饶县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:44'
      },
      {
        id: 2377,
        pid: 287,
        city_code: '101121007',
        city_name: '曹县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:44'
      },
      {
        id: 2378,
        pid: 287,
        city_code: '101121009',
        city_name: '单县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:45'
      },
      {
        id: 2379,
        pid: 287,
        city_code: '101121008',
        city_name: '成武县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:45'
      },
      {
        id: 2380,
        pid: 287,
        city_code: '101121006',
        city_name: '巨野县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:45'
      },
      {
        id: 2381,
        pid: 287,
        city_code: '101121003',
        city_name: '郓城县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:45'
      },
      {
        id: 2382,
        pid: 287,
        city_code: '101121002',
        city_name: '鄄城县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:46'
      },
      {
        id: 2383,
        pid: 287,
        city_code: '101121005',
        city_name: '定陶区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 21:24:17'
      },
      {
        id: 2384,
        pid: 287,
        city_code: '101121004',
        city_name: '东明县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:46'
      },
      {
        id: 2387,
        pid: 288,
        city_code: '101120710',
        city_name: '曲阜市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:46'
      },
      {
        id: 2388,
        pid: 288,
        city_code: '101120705',
        city_name: '兖州市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 17:36:36'
      },
      {
        id: 2389,
        pid: 288,
        city_code: '101120711',
        city_name: '邹城市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:47'
      },
      {
        id: 2390,
        pid: 288,
        city_code: '101120703',
        city_name: '微山县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:47'
      },
      {
        id: 2391,
        pid: 288,
        city_code: '101120704',
        city_name: '鱼台县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:47'
      },
      {
        id: 2392,
        pid: 288,
        city_code: '101120706',
        city_name: '金乡县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:47'
      },
      {
        id: 2393,
        pid: 288,
        city_code: '101120702',
        city_name: '嘉祥县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:48'
      },
      {
        id: 2394,
        pid: 288,
        city_code: '101120707',
        city_name: '汶上县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:49'
      },
      {
        id: 2395,
        pid: 288,
        city_code: '101120708',
        city_name: '泗水县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:49'
      },
      {
        id: 2396,
        pid: 288,
        city_code: '101120709',
        city_name: '梁山县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:50'
      },
      {
        id: 2400,
        pid: 290,
        city_code: '101121707',
        city_name: '临清市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:51'
      },
      {
        id: 2401,
        pid: 290,
        city_code: '101121703',
        city_name: '阳谷县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:51'
      },
      {
        id: 2402,
        pid: 290,
        city_code: '101121709',
        city_name: '莘县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:52'
      },
      {
        id: 2403,
        pid: 290,
        city_code: '101121705',
        city_name: '茌平县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:53'
      },
      {
        id: 2404,
        pid: 290,
        city_code: '101121706',
        city_name: '东阿县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:54'
      },
      {
        id: 2405,
        pid: 290,
        city_code: '101121702',
        city_name: '冠县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:54'
      },
      {
        id: 2406,
        pid: 290,
        city_code: '101121704',
        city_name: '高唐县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:54'
      },
      {
        id: 2410,
        pid: 291,
        city_code: '101120903',
        city_name: '沂南县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:55'
      },
      {
        id: 2411,
        pid: 291,
        city_code: '101120906',
        city_name: '郯城县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:55'
      },
      {
        id: 2412,
        pid: 291,
        city_code: '101120910',
        city_name: '沂水县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:55'
      },
      {
        id: 2413,
        pid: 291,
        city_code: '101120904',
        city_name: '兰陵县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:57'
      },
      {
        id: 2414,
        pid: 291,
        city_code: '101120909',
        city_name: '费县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:57'
      },
      {
        id: 2415,
        pid: 291,
        city_code: '101120908',
        city_name: '平邑县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:57'
      },
      {
        id: 2416,
        pid: 291,
        city_code: '101120902',
        city_name: '莒南县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:57'
      },
      {
        id: 2417,
        pid: 291,
        city_code: '101120907',
        city_name: '蒙阴县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:58'
      },
      {
        id: 2418,
        pid: 291,
        city_code: '101120905',
        city_name: '临沭县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:58'
      },
      {
        id: 2421,
        pid: 292,
        city_code: '101121502',
        city_name: '五莲县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:31:58'
      },
      {
        id: 2422,
        pid: 292,
        city_code: '101121503',
        city_name: '莒县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:00'
      },
      {
        id: 2423,
        pid: 293,
        city_code: '101120803',
        city_name: '泰山区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:00'
      },
      {
        id: 2425,
        pid: 293,
        city_code: '101120802',
        city_name: '新泰市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:00'
      },
      {
        id: 2426,
        pid: 293,
        city_code: '101120804',
        city_name: '肥城市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:01'
      },
      {
        id: 2427,
        pid: 293,
        city_code: '101120806',
        city_name: '宁阳县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:02'
      },
      {
        id: 2428,
        pid: 293,
        city_code: '101120805',
        city_name: '东平县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:02'
      },
      {
        id: 2429,
        pid: 294,
        city_code: '101121303',
        city_name: '荣成市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:03'
      },
      {
        id: 2430,
        pid: 294,
        city_code: '101121304',
        city_name: '乳山市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:03'
      },
      {
        id: 2432,
        pid: 294,
        city_code: '101121302',
        city_name: '文登市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 17:36:36'
      },
      {
        id: 2437,
        pid: 295,
        city_code: '101120602',
        city_name: '青州市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:06'
      },
      {
        id: 2438,
        pid: 295,
        city_code: '101120609',
        city_name: '诸城市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:06'
      },
      {
        id: 2439,
        pid: 295,
        city_code: '101120603',
        city_name: '寿光市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:07'
      },
      {
        id: 2440,
        pid: 295,
        city_code: '101120607',
        city_name: '安丘市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:08'
      },
      {
        id: 2441,
        pid: 295,
        city_code: '101120608',
        city_name: '高密市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:08'
      },
      {
        id: 2442,
        pid: 295,
        city_code: '101120606',
        city_name: '昌邑市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:08'
      },
      {
        id: 2443,
        pid: 295,
        city_code: '101120604',
        city_name: '临朐县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:08'
      },
      {
        id: 2444,
        pid: 295,
        city_code: '101120605',
        city_name: '昌乐县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:09'
      },
      {
        id: 2446,
        pid: 296,
        city_code: '101120508',
        city_name: '福山区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:09'
      },
      {
        id: 2447,
        pid: 296,
        city_code: '101120509',
        city_name: '牟平区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:09'
      },
      {
        id: 2450,
        pid: 296,
        city_code: '101120505',
        city_name: '龙口市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:09'
      },
      {
        id: 2451,
        pid: 296,
        city_code: '101120510',
        city_name: '莱阳市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:10'
      },
      {
        id: 2452,
        pid: 296,
        city_code: '101120502',
        city_name: '莱州市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:10'
      },
      {
        id: 2453,
        pid: 296,
        city_code: '101120504',
        city_name: '蓬莱市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:10'
      },
      {
        id: 2454,
        pid: 296,
        city_code: '101120506',
        city_name: '招远市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:11'
      },
      {
        id: 2455,
        pid: 296,
        city_code: '101120507',
        city_name: '栖霞市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:12'
      },
      {
        id: 2456,
        pid: 296,
        city_code: '101120511',
        city_name: '海阳市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:13'
      },
      {
        id: 2457,
        pid: 296,
        city_code: '101120503',
        city_name: '长岛县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:14'
      },
      {
        id: 2460,
        pid: 297,
        city_code: '101121403',
        city_name: '峄城区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:14'
      },
      {
        id: 2461,
        pid: 297,
        city_code: '101121404',
        city_name: '台儿庄区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:16'
      },
      {
        id: 2462,
        pid: 297,
        city_code: '101121402',
        city_name: '薛城区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:16'
      },
      {
        id: 2463,
        pid: 297,
        city_code: '101121405',
        city_name: '滕州市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:16'
      },
      {
        id: 2465,
        pid: 298,
        city_code: '101120308',
        city_name: '临淄区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:17'
      },
      {
        id: 2466,
        pid: 298,
        city_code: '101120302',
        city_name: '淄川区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:18'
      },
      {
        id: 2467,
        pid: 298,
        city_code: '101120303',
        city_name: '博山区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:18'
      },
      {
        id: 2468,
        pid: 298,
        city_code: '101120305',
        city_name: '周村区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:18'
      },
      {
        id: 2469,
        pid: 298,
        city_code: '101120307',
        city_name: '桓台县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:18'
      },
      {
        id: 2470,
        pid: 298,
        city_code: '101120304',
        city_name: '高青县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:19'
      },
      {
        id: 2471,
        pid: 298,
        city_code: '101120306',
        city_name: '沂源县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:21'
      },
      {
        id: 2481,
        pid: 299,
        city_code: '101100102',
        city_name: '清徐县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:21'
      },
      {
        id: 2482,
        pid: 299,
        city_code: '101100103',
        city_name: '阳曲县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:21'
      },
      {
        id: 2483,
        pid: 299,
        city_code: '101100104',
        city_name: '娄烦县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:22'
      },
      {
        id: 2484,
        pid: 299,
        city_code: '101100105',
        city_name: '古交市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:22'
      },
      {
        id: 2487,
        pid: 300,
        city_code: '101100508',
        city_name: '沁县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:22'
      },
      {
        id: 2488,
        pid: 300,
        city_code: '101100504',
        city_name: '潞城市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:22'
      },
      {
        id: 2490,
        pid: 300,
        city_code: '101100505',
        city_name: '襄垣县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:23'
      },
      {
        id: 2491,
        pid: 300,
        city_code: '101100503',
        city_name: '屯留县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:24'
      },
      {
        id: 2492,
        pid: 300,
        city_code: '101100506',
        city_name: '平顺县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:24'
      },
      {
        id: 2493,
        pid: 300,
        city_code: '101100502',
        city_name: '黎城县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:26'
      },
      {
        id: 2494,
        pid: 300,
        city_code: '101100511',
        city_name: '壶关县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:26'
      },
      {
        id: 2495,
        pid: 300,
        city_code: '101100509',
        city_name: '长子县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:26'
      },
      {
        id: 2496,
        pid: 300,
        city_code: '101100507',
        city_name: '武乡县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:26'
      },
      {
        id: 2497,
        pid: 300,
        city_code: '101100510',
        city_name: '沁源县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:27'
      },
      {
        id: 2502,
        pid: 301,
        city_code: '101100202',
        city_name: '阳高县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:27'
      },
      {
        id: 2503,
        pid: 301,
        city_code: '101100204',
        city_name: '天镇县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:28'
      },
      {
        id: 2504,
        pid: 301,
        city_code: '101100205',
        city_name: '广灵县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:28'
      },
      {
        id: 2505,
        pid: 301,
        city_code: '101100206',
        city_name: '灵丘县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:30'
      },
      {
        id: 2506,
        pid: 301,
        city_code: '101100207',
        city_name: '浑源县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:30'
      },
      {
        id: 2507,
        pid: 301,
        city_code: '101100208',
        city_name: '左云县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:30'
      },
      {
        id: 2508,
        pid: 301,
        city_code: '101100203',
        city_name: '大同县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:30'
      },
      {
        id: 2510,
        pid: 302,
        city_code: '101100605',
        city_name: '高平市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:30'
      },
      {
        id: 2511,
        pid: 302,
        city_code: '101100602',
        city_name: '沁水县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:32'
      },
      {
        id: 2512,
        pid: 302,
        city_code: '101100603',
        city_name: '阳城县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:33'
      },
      {
        id: 2513,
        pid: 302,
        city_code: '101100604',
        city_name: '陵川县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:34'
      },
      {
        id: 2514,
        pid: 302,
        city_code: '101100606',
        city_name: '泽州县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:34'
      },
      {
        id: 2515,
        pid: 303,
        city_code: '101100402',
        city_name: '榆次区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:36'
      },
      {
        id: 2516,
        pid: 303,
        city_code: '101100412',
        city_name: '介休市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:37'
      },
      {
        id: 2517,
        pid: 303,
        city_code: '101100403',
        city_name: '榆社县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:38'
      },
      {
        id: 2518,
        pid: 303,
        city_code: '101100404',
        city_name: '左权县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:38'
      },
      {
        id: 2519,
        pid: 303,
        city_code: '101100405',
        city_name: '和顺县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:39'
      },
      {
        id: 2520,
        pid: 303,
        city_code: '101100406',
        city_name: '昔阳县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:39'
      },
      {
        id: 2521,
        pid: 303,
        city_code: '101100407',
        city_name: '寿阳县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:41'
      },
      {
        id: 2522,
        pid: 303,
        city_code: '101100408',
        city_name: '太谷县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:41'
      },
      {
        id: 2523,
        pid: 303,
        city_code: '101100409',
        city_name: '祁县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:42'
      },
      {
        id: 2524,
        pid: 303,
        city_code: '101100410',
        city_name: '平遥县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:42'
      },
      {
        id: 2525,
        pid: 303,
        city_code: '101100411',
        city_name: '灵石县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:42'
      },
      {
        id: 2527,
        pid: 304,
        city_code: '101100714',
        city_name: '侯马市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:42'
      },
      {
        id: 2528,
        pid: 304,
        city_code: '101100711',
        city_name: '霍州市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:43'
      },
      {
        id: 2529,
        pid: 304,
        city_code: '101100702',
        city_name: '曲沃县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:43'
      },
      {
        id: 2530,
        pid: 304,
        city_code: '101100713',
        city_name: '翼城县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:44'
      },
      {
        id: 2531,
        pid: 304,
        city_code: '101100707',
        city_name: '襄汾县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:44'
      },
      {
        id: 2532,
        pid: 304,
        city_code: '101100710',
        city_name: '洪洞县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:45'
      },
      {
        id: 2533,
        pid: 304,
        city_code: '101100706',
        city_name: '吉县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:45'
      },
      {
        id: 2534,
        pid: 304,
        city_code: '101100716',
        city_name: '安泽县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:46'
      },
      {
        id: 2535,
        pid: 304,
        city_code: '101100715',
        city_name: '浮山县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:47'
      },
      {
        id: 2536,
        pid: 304,
        city_code: '101100717',
        city_name: '古县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:48'
      },
      {
        id: 2537,
        pid: 304,
        city_code: '101100712',
        city_name: '乡宁县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:48'
      },
      {
        id: 2538,
        pid: 304,
        city_code: '101100705',
        city_name: '大宁县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:48'
      },
      {
        id: 2539,
        pid: 304,
        city_code: '101100704',
        city_name: '隰县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:48'
      },
      {
        id: 2540,
        pid: 304,
        city_code: '101100703',
        city_name: '永和县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:49'
      },
      {
        id: 2541,
        pid: 304,
        city_code: '101100708',
        city_name: '蒲县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:49'
      },
      {
        id: 2542,
        pid: 304,
        city_code: '101100709',
        city_name: '汾西县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:49'
      },
      {
        id: 2543,
        pid: 305,
        city_code: '101101101',
        city_name: '离石区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 17:36:37'
      },
      {
        id: 2545,
        pid: 305,
        city_code: '101101110',
        city_name: '孝义市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:51'
      },
      {
        id: 2546,
        pid: 305,
        city_code: '101101111',
        city_name: '汾阳市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:51'
      },
      {
        id: 2547,
        pid: 305,
        city_code: '101101112',
        city_name: '文水县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:51'
      },
      {
        id: 2548,
        pid: 305,
        city_code: '101101113',
        city_name: '交城县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:52'
      },
      {
        id: 2549,
        pid: 305,
        city_code: '101101103',
        city_name: '兴县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:54'
      },
      {
        id: 2550,
        pid: 305,
        city_code: '101101102',
        city_name: '临县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:54'
      },
      {
        id: 2551,
        pid: 305,
        city_code: '101101105',
        city_name: '柳林县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:54'
      },
      {
        id: 2552,
        pid: 305,
        city_code: '101101106',
        city_name: '石楼县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:54'
      },
      {
        id: 2553,
        pid: 305,
        city_code: '101101104',
        city_name: '岚县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:55'
      },
      {
        id: 2554,
        pid: 305,
        city_code: '101101107',
        city_name: '方山县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:55'
      },
      {
        id: 2555,
        pid: 305,
        city_code: '101101109',
        city_name: '中阳县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:55'
      },
      {
        id: 2556,
        pid: 305,
        city_code: '101101108',
        city_name: '交口县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:55'
      },
      {
        id: 2558,
        pid: 306,
        city_code: '101100902',
        city_name: '平鲁区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:57'
      },
      {
        id: 2559,
        pid: 306,
        city_code: '101100903',
        city_name: '山阴县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:57'
      },
      {
        id: 2560,
        pid: 306,
        city_code: '101100905',
        city_name: '应县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:58'
      },
      {
        id: 2561,
        pid: 306,
        city_code: '101100904',
        city_name: '右玉县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:58'
      },
      {
        id: 2562,
        pid: 306,
        city_code: '101100906',
        city_name: '怀仁县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:32:59'
      },
      {
        id: 2564,
        pid: 307,
        city_code: '101101015',
        city_name: '原平市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:00'
      },
      {
        id: 2565,
        pid: 307,
        city_code: '101101002',
        city_name: '定襄县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:00'
      },
      {
        id: 2566,
        pid: 307,
        city_code: '101101003',
        city_name: '五台县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:01'
      },
      {
        id: 2567,
        pid: 307,
        city_code: '101101008',
        city_name: '代县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:03'
      },
      {
        id: 2568,
        pid: 307,
        city_code: '101101009',
        city_name: '繁峙县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:03'
      },
      {
        id: 2569,
        pid: 307,
        city_code: '101101007',
        city_name: '宁武县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:03'
      },
      {
        id: 2570,
        pid: 307,
        city_code: '101101012',
        city_name: '静乐县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:04'
      },
      {
        id: 2571,
        pid: 307,
        city_code: '101101006',
        city_name: '神池县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:05'
      },
      {
        id: 2572,
        pid: 307,
        city_code: '101101014',
        city_name: '五寨县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:05'
      },
      {
        id: 2573,
        pid: 307,
        city_code: '101101013',
        city_name: '岢岚县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:05'
      },
      {
        id: 2574,
        pid: 307,
        city_code: '101101004',
        city_name: '河曲县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:05'
      },
      {
        id: 2575,
        pid: 307,
        city_code: '101101011',
        city_name: '保德县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:06'
      },
      {
        id: 2576,
        pid: 307,
        city_code: '101101005',
        city_name: '偏关县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:08'
      },
      {
        id: 2580,
        pid: 308,
        city_code: '101100303',
        city_name: '平定县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:09'
      },
      {
        id: 2581,
        pid: 308,
        city_code: '101100302',
        city_name: '盂县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:10'
      },
      {
        id: 2583,
        pid: 309,
        city_code: '101100810',
        city_name: '永济市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:11'
      },
      {
        id: 2584,
        pid: 309,
        city_code: '101100805',
        city_name: '河津市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:12'
      },
      {
        id: 2585,
        pid: 309,
        city_code: '101100802',
        city_name: '临猗县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:13'
      },
      {
        id: 2586,
        pid: 309,
        city_code: '101100804',
        city_name: '万荣县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:14'
      },
      {
        id: 2587,
        pid: 309,
        city_code: '101100808',
        city_name: '闻喜县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:14'
      },
      {
        id: 2588,
        pid: 309,
        city_code: '101100803',
        city_name: '稷山县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:14'
      },
      {
        id: 2589,
        pid: 309,
        city_code: '101100806',
        city_name: '新绛县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:14'
      },
      {
        id: 2590,
        pid: 309,
        city_code: '101100807',
        city_name: '绛县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:15'
      },
      {
        id: 2591,
        pid: 309,
        city_code: '101100809',
        city_name: '垣曲县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:15'
      },
      {
        id: 2592,
        pid: 309,
        city_code: '101100812',
        city_name: '夏县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:16'
      },
      {
        id: 2593,
        pid: 309,
        city_code: '101100813',
        city_name: '平陆县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:16'
      },
      {
        id: 2594,
        pid: 309,
        city_code: '101100811',
        city_name: '芮城县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:17'
      },
      {
        id: 2602,
        pid: 310,
        city_code: '101110103',
        city_name: '临潼区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:17'
      },
      {
        id: 2603,
        pid: 310,
        city_code: '101090119',
        city_name: '长安区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:17'
      },
      {
        id: 2604,
        pid: 310,
        city_code: '101110104',
        city_name: '蓝田县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:18'
      },
      {
        id: 2605,
        pid: 310,
        city_code: '101110105',
        city_name: '周至县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:18'
      },
      {
        id: 2606,
        pid: 310,
        city_code: '101110106',
        city_name: '户县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:18'
      },
      {
        id: 2607,
        pid: 310,
        city_code: '101110107',
        city_name: '高陵区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 21:24:18'
      },
      {
        id: 2609,
        pid: 311,
        city_code: '101110704',
        city_name: '汉阴县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:20'
      },
      {
        id: 2610,
        pid: 311,
        city_code: '101110703',
        city_name: '石泉县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:20'
      },
      {
        id: 2611,
        pid: 311,
        city_code: '101110710',
        city_name: '宁陕县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:21'
      },
      {
        id: 2612,
        pid: 311,
        city_code: '101110702',
        city_name: '紫阳县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:21'
      },
      {
        id: 2613,
        pid: 311,
        city_code: '101110706',
        city_name: '岚皋县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:23'
      },
      {
        id: 2614,
        pid: 311,
        city_code: '101110707',
        city_name: '平利县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:24'
      },
      {
        id: 2615,
        pid: 311,
        city_code: '101110709',
        city_name: '镇坪县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:24'
      },
      {
        id: 2616,
        pid: 311,
        city_code: '101110705',
        city_name: '旬阳县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:24'
      },
      {
        id: 2617,
        pid: 311,
        city_code: '101110708',
        city_name: '白河县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:25'
      },
      {
        id: 2618,
        pid: 312,
        city_code: '101110912',
        city_name: '陈仓区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:25'
      },
      {
        id: 2621,
        pid: 312,
        city_code: '101110906',
        city_name: '凤翔县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:25'
      },
      {
        id: 2622,
        pid: 312,
        city_code: '101110905',
        city_name: '岐山县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:26'
      },
      {
        id: 2623,
        pid: 312,
        city_code: '101110907',
        city_name: '扶风县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:27'
      },
      {
        id: 2624,
        pid: 312,
        city_code: '101110908',
        city_name: '眉县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:28'
      },
      {
        id: 2625,
        pid: 312,
        city_code: '101110911',
        city_name: '陇县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:29'
      },
      {
        id: 2626,
        pid: 312,
        city_code: '101110903',
        city_name: '千阳县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:29'
      },
      {
        id: 2627,
        pid: 312,
        city_code: '101110904',
        city_name: '麟游县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:29'
      },
      {
        id: 2628,
        pid: 312,
        city_code: '101110910',
        city_name: '凤县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:30'
      },
      {
        id: 2629,
        pid: 312,
        city_code: '101110909',
        city_name: '太白县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:30'
      },
      {
        id: 2631,
        pid: 313,
        city_code: '101110810',
        city_name: '南郑县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:31'
      },
      {
        id: 2632,
        pid: 313,
        city_code: '101110806',
        city_name: '城固县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:31'
      },
      {
        id: 2633,
        pid: 313,
        city_code: '101110805',
        city_name: '洋县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:32'
      },
      {
        id: 2634,
        pid: 313,
        city_code: '101110807',
        city_name: '西乡县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:32'
      },
      {
        id: 2635,
        pid: 313,
        city_code: '101110803',
        city_name: '勉县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:32'
      },
      {
        id: 2636,
        pid: 313,
        city_code: '101110809',
        city_name: '宁强县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:32'
      },
      {
        id: 2637,
        pid: 313,
        city_code: '101110802',
        city_name: '略阳县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:33'
      },
      {
        id: 2638,
        pid: 313,
        city_code: '101110811',
        city_name: '镇巴县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:33'
      },
      {
        id: 2639,
        pid: 313,
        city_code: '101110804',
        city_name: '留坝县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:33'
      },
      {
        id: 2640,
        pid: 313,
        city_code: '101110808',
        city_name: '佛坪县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:34'
      },
      {
        id: 2641,
        pid: 314,
        city_code: '101110604',
        city_name: '商州区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:34'
      },
      {
        id: 2642,
        pid: 314,
        city_code: '101110602',
        city_name: '洛南县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:34'
      },
      {
        id: 2643,
        pid: 314,
        city_code: '101110606',
        city_name: '丹凤县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:34'
      },
      {
        id: 2644,
        pid: 314,
        city_code: '101110607',
        city_name: '商南县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:35'
      },
      {
        id: 2645,
        pid: 314,
        city_code: '101110608',
        city_name: '山阳县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:35'
      },
      {
        id: 2646,
        pid: 314,
        city_code: '101110605',
        city_name: '镇安县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:35'
      },
      {
        id: 2647,
        pid: 314,
        city_code: '101110603',
        city_name: '柞水县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:35'
      },
      {
        id: 2648,
        pid: 315,
        city_code: '101111004',
        city_name: '耀州区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:36'
      },
      {
        id: 2651,
        pid: 315,
        city_code: '101111003',
        city_name: '宜君县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:36'
      },
      {
        id: 2653,
        pid: 316,
        city_code: '101110510',
        city_name: '韩城市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:36'
      },
      {
        id: 2654,
        pid: 316,
        city_code: '101110511',
        city_name: '华阴市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:36'
      },
      {
        id: 2655,
        pid: 316,
        city_code: '101110502',
        city_name: '华县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 21:24:18'
      },
      {
        id: 2656,
        pid: 316,
        city_code: '101110503',
        city_name: '潼关县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:37'
      },
      {
        id: 2657,
        pid: 316,
        city_code: '101110504',
        city_name: '大荔县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:37'
      },
      {
        id: 2658,
        pid: 316,
        city_code: '101110509',
        city_name: '合阳县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:37'
      },
      {
        id: 2659,
        pid: 316,
        city_code: '101110508',
        city_name: '澄城县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:38'
      },
      {
        id: 2660,
        pid: 316,
        city_code: '101110507',
        city_name: '蒲城县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:38'
      },
      {
        id: 2661,
        pid: 316,
        city_code: '101110505',
        city_name: '白水县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:38'
      },
      {
        id: 2662,
        pid: 316,
        city_code: '101110506',
        city_name: '富平县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:38'
      },
      {
        id: 2666,
        pid: 317,
        city_code: '101110211',
        city_name: '兴平市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:39'
      },
      {
        id: 2667,
        pid: 317,
        city_code: '101110201',
        city_name: '三原县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:39'
      },
      {
        id: 2668,
        pid: 317,
        city_code: '101110205',
        city_name: '泾阳县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:39'
      },
      {
        id: 2669,
        pid: 317,
        city_code: '101110207',
        city_name: '乾县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:40'
      },
      {
        id: 2670,
        pid: 317,
        city_code: '101110202',
        city_name: '礼泉县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:40'
      },
      {
        id: 2671,
        pid: 317,
        city_code: '101110203',
        city_name: '永寿县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:40'
      },
      {
        id: 2672,
        pid: 317,
        city_code: '101110208',
        city_name: '彬县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:40'
      },
      {
        id: 2673,
        pid: 317,
        city_code: '101110209',
        city_name: '长武县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:41'
      },
      {
        id: 2674,
        pid: 317,
        city_code: '101110210',
        city_name: '旬邑县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:41'
      },
      {
        id: 2675,
        pid: 317,
        city_code: '101110204',
        city_name: '淳化县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:41'
      },
      {
        id: 2676,
        pid: 317,
        city_code: '101110206',
        city_name: '武功县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:41'
      },
      {
        id: 2677,
        pid: 318,
        city_code: '101110312',
        city_name: '吴起县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:42'
      },
      {
        id: 2679,
        pid: 318,
        city_code: '101110301',
        city_name: '延长县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:42'
      },
      {
        id: 2680,
        pid: 318,
        city_code: '101110302',
        city_name: '延川县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:42'
      },
      {
        id: 2681,
        pid: 318,
        city_code: '101110303',
        city_name: '子长县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:42'
      },
      {
        id: 2682,
        pid: 318,
        city_code: '101110307',
        city_name: '安塞区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 21:24:19'
      },
      {
        id: 2683,
        pid: 318,
        city_code: '101110306',
        city_name: '志丹县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:43'
      },
      {
        id: 2684,
        pid: 318,
        city_code: '101110308',
        city_name: '甘泉县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:43'
      },
      {
        id: 2685,
        pid: 318,
        city_code: '101110305',
        city_name: '富县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:43'
      },
      {
        id: 2686,
        pid: 318,
        city_code: '101110309',
        city_name: '洛川县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:44'
      },
      {
        id: 2687,
        pid: 318,
        city_code: '101110304',
        city_name: '宜川县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:44'
      },
      {
        id: 2688,
        pid: 318,
        city_code: '101110311',
        city_name: '黄龙县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:44'
      },
      {
        id: 2689,
        pid: 318,
        city_code: '101110310',
        city_name: '黄陵县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:44'
      },
      {
        id: 2690,
        pid: 319,
        city_code: '101110413',
        city_name: '榆阳区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:45'
      },
      {
        id: 2691,
        pid: 319,
        city_code: '101110403',
        city_name: '神木县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:45'
      },
      {
        id: 2692,
        pid: 319,
        city_code: '101110402',
        city_name: '府谷县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:45'
      },
      {
        id: 2693,
        pid: 319,
        city_code: '101110407',
        city_name: '横山区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 21:24:19'
      },
      {
        id: 2694,
        pid: 319,
        city_code: '101110406',
        city_name: '靖边县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:46'
      },
      {
        id: 2695,
        pid: 319,
        city_code: '101110405',
        city_name: '定边县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:33:46'
      },
      {
        id: 2696,
        pid: 319,
        city_code: '101110410',
        city_name: '绥德县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 17:17:50'
      },
      {
        id: 2697,
        pid: 319,
        city_code: '101110408',
        city_name: '米脂县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 17:17:51'
      },
      {
        id: 2698,
        pid: 319,
        city_code: '101110404',
        city_name: '佳县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 17:17:52'
      },
      {
        id: 2699,
        pid: 319,
        city_code: '101110411',
        city_name: '吴堡县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 17:17:54'
      },
      {
        id: 2700,
        pid: 319,
        city_code: '101110412',
        city_name: '清涧县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 17:17:55'
      },
      {
        id: 2701,
        pid: 319,
        city_code: '101110409',
        city_name: '子洲县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 17:17:56'
      },
      {
        id: 2704,
        pid: 24,
        city_code: '101020200',
        city_name: '闵行区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:16'
      },
      {
        id: 2706,
        pid: 24,
        city_code: '101020600',
        city_name: '浦东新区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:16'
      },
      {
        id: 2714,
        pid: 24,
        city_code: '101020900',
        city_name: '松江区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:17'
      },
      {
        id: 2715,
        pid: 24,
        city_code: '101020500',
        city_name: '嘉定区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:17'
      },
      {
        id: 2716,
        pid: 24,
        city_code: '101020300',
        city_name: '宝山区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:17'
      },
      {
        id: 2717,
        pid: 24,
        city_code: '101020800',
        city_name: '青浦区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:18'
      },
      {
        id: 2718,
        pid: 24,
        city_code: '101020700',
        city_name: '金山区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:18'
      },
      {
        id: 2719,
        pid: 24,
        city_code: '101021000',
        city_name: '奉贤区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:18'
      },
      {
        id: 2720,
        pid: 24,
        city_code: '101021100',
        city_name: '崇明区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:18'
      },
      {
        id: 2726,
        pid: 321,
        city_code: '101270102',
        city_name: '龙泉驿区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:19'
      },
      {
        id: 2727,
        pid: 321,
        city_code: '101270115',
        city_name: '青白江区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:19'
      },
      {
        id: 2728,
        pid: 321,
        city_code: '101270103',
        city_name: '新都区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:19'
      },
      {
        id: 2729,
        pid: 321,
        city_code: '101270104',
        city_name: '温江区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:20'
      },
      {
        id: 2732,
        pid: 321,
        city_code: '101270111',
        city_name: '都江堰市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:20'
      },
      {
        id: 2733,
        pid: 321,
        city_code: '101270112',
        city_name: '彭州市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:20'
      },
      {
        id: 2734,
        pid: 321,
        city_code: '101270113',
        city_name: '邛崃市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:20'
      },
      {
        id: 2735,
        pid: 321,
        city_code: '101270114',
        city_name: '崇州市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:21'
      },
      {
        id: 2736,
        pid: 321,
        city_code: '101270105',
        city_name: '金堂县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:21'
      },
      {
        id: 2737,
        pid: 321,
        city_code: '101270106',
        city_name: '双流区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 21:24:22'
      },
      {
        id: 2738,
        pid: 321,
        city_code: '101270107',
        city_name: '郫县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:22'
      },
      {
        id: 2739,
        pid: 321,
        city_code: '101270108',
        city_name: '大邑县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:23'
      },
      {
        id: 2740,
        pid: 321,
        city_code: '101270109',
        city_name: '蒲江县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:23'
      },
      {
        id: 2741,
        pid: 321,
        city_code: '101270110',
        city_name: '新津县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:24'
      },
      {
        id: 2754,
        pid: 322,
        city_code: '101270408',
        city_name: '江油市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:24'
      },
      {
        id: 2755,
        pid: 322,
        city_code: '101270403',
        city_name: '盐亭县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:25'
      },
      {
        id: 2756,
        pid: 322,
        city_code: '101270402',
        city_name: '三台县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:27'
      },
      {
        id: 2757,
        pid: 322,
        city_code: '101270407',
        city_name: '平武县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:27'
      },
      {
        id: 2758,
        pid: 322,
        city_code: '101270404',
        city_name: '安县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 21:24:22'
      },
      {
        id: 2759,
        pid: 322,
        city_code: '101270405',
        city_name: '梓潼县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:27'
      },
      {
        id: 2760,
        pid: 322,
        city_code: '101270406',
        city_name: '北川县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:28'
      },
      {
        id: 2761,
        pid: 323,
        city_code: '101271910',
        city_name: '马尔康市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 21:24:22'
      },
      {
        id: 2762,
        pid: 323,
        city_code: '101271902',
        city_name: '汶川县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:28'
      },
      {
        id: 2763,
        pid: 323,
        city_code: '101271903',
        city_name: '理县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:28'
      },
      {
        id: 2764,
        pid: 323,
        city_code: '101271904',
        city_name: '茂县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:29'
      },
      {
        id: 2765,
        pid: 323,
        city_code: '101271905',
        city_name: '松潘县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:31'
      },
      {
        id: 2766,
        pid: 323,
        city_code: '101271906',
        city_name: '九寨沟县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:31'
      },
      {
        id: 2767,
        pid: 323,
        city_code: '101271907',
        city_name: '金川县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:31'
      },
      {
        id: 2768,
        pid: 323,
        city_code: '101271908',
        city_name: '小金县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:31'
      },
      {
        id: 2769,
        pid: 323,
        city_code: '101271909',
        city_name: '黑水县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:31'
      },
      {
        id: 2770,
        pid: 323,
        city_code: '101271911',
        city_name: '壤塘县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:32'
      },
      {
        id: 2772,
        pid: 323,
        city_code: '101271912',
        city_name: '若尔盖县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:32'
      },
      {
        id: 2773,
        pid: 323,
        city_code: '101271913',
        city_name: '红原县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:32'
      },
      {
        id: 2775,
        pid: 324,
        city_code: '101270902',
        city_name: '通江县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:33'
      },
      {
        id: 2776,
        pid: 324,
        city_code: '101270903',
        city_name: '南江县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:33'
      },
      {
        id: 2777,
        pid: 324,
        city_code: '101270904',
        city_name: '平昌县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:33'
      },
      {
        id: 2779,
        pid: 325,
        city_code: '101270606',
        city_name: '万源市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:34'
      },
      {
        id: 2780,
        pid: 325,
        city_code: '101270608',
        city_name: '达川区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:35'
      },
      {
        id: 2781,
        pid: 325,
        city_code: '101270602',
        city_name: '宣汉县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:35'
      },
      {
        id: 2782,
        pid: 325,
        city_code: '101270603',
        city_name: '开江县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:35'
      },
      {
        id: 2783,
        pid: 325,
        city_code: '101270604',
        city_name: '大竹县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:36'
      },
      {
        id: 2784,
        pid: 325,
        city_code: '101270605',
        city_name: '渠县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:36'
      },
      {
        id: 2786,
        pid: 326,
        city_code: '101272003',
        city_name: '广汉市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:37'
      },
      {
        id: 2787,
        pid: 326,
        city_code: '101272004',
        city_name: '什邡市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:37'
      },
      {
        id: 2788,
        pid: 326,
        city_code: '101272005',
        city_name: '绵竹市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:37'
      },
      {
        id: 2789,
        pid: 326,
        city_code: '101272006',
        city_name: '罗江区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 21:24:22'
      },
      {
        id: 2790,
        pid: 326,
        city_code: '101272002',
        city_name: '中江县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:38'
      },
      {
        id: 2791,
        pid: 327,
        city_code: '101271802',
        city_name: '康定市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 21:24:23'
      },
      {
        id: 2792,
        pid: 327,
        city_code: '101271804',
        city_name: '丹巴县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:38'
      },
      {
        id: 2793,
        pid: 327,
        city_code: '101271803',
        city_name: '泸定县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:39'
      },
      {
        id: 2794,
        pid: 327,
        city_code: '101271808',
        city_name: '炉霍县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:39'
      },
      {
        id: 2795,
        pid: 327,
        city_code: '101271805',
        city_name: '九龙县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:41'
      },
      {
        id: 2797,
        pid: 327,
        city_code: '101271806',
        city_name: '雅江县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:42'
      },
      {
        id: 2798,
        pid: 327,
        city_code: '101271809',
        city_name: '新龙县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:42'
      },
      {
        id: 2799,
        pid: 327,
        city_code: '101271807',
        city_name: '道孚县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:42'
      },
      {
        id: 2800,
        pid: 327,
        city_code: '101271811',
        city_name: '白玉县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:43'
      },
      {
        id: 2801,
        pid: 327,
        city_code: '101271814',
        city_name: '理塘县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:43'
      },
      {
        id: 2802,
        pid: 327,
        city_code: '101271810',
        city_name: '德格县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:43'
      },
      {
        id: 2803,
        pid: 327,
        city_code: '101271816',
        city_name: '乡城县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:44'
      },
      {
        id: 2804,
        pid: 327,
        city_code: '101271812',
        city_name: '石渠县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:45'
      },
      {
        id: 2805,
        pid: 327,
        city_code: '101271817',
        city_name: '稻城县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:46'
      },
      {
        id: 2806,
        pid: 327,
        city_code: '101271813',
        city_name: '色达县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:46'
      },
      {
        id: 2807,
        pid: 327,
        city_code: '101271815',
        city_name: '巴塘县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:47'
      },
      {
        id: 2808,
        pid: 327,
        city_code: '101271818',
        city_name: '得荣县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:48'
      },
      {
        id: 2810,
        pid: 328,
        city_code: '101270805',
        city_name: '华蓥市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:49'
      },
      {
        id: 2811,
        pid: 328,
        city_code: '101270802',
        city_name: '岳池县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:49'
      },
      {
        id: 2812,
        pid: 328,
        city_code: '101270803',
        city_name: '武胜县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:50'
      },
      {
        id: 2813,
        pid: 328,
        city_code: '101270804',
        city_name: '邻水县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:51'
      },
      {
        id: 2817,
        pid: 329,
        city_code: '101272102',
        city_name: '旺苍县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:51'
      },
      {
        id: 2818,
        pid: 329,
        city_code: '101272103',
        city_name: '青川县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:51'
      },
      {
        id: 2819,
        pid: 329,
        city_code: '101272104',
        city_name: '剑阁县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:51'
      },
      {
        id: 2820,
        pid: 329,
        city_code: '101272105',
        city_name: '苍溪县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:52'
      },
      {
        id: 2821,
        pid: 330,
        city_code: '101271408',
        city_name: '峨眉山市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:53'
      },
      {
        id: 2823,
        pid: 330,
        city_code: '101271402',
        city_name: '犍为县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:53'
      },
      {
        id: 2824,
        pid: 330,
        city_code: '101271403',
        city_name: '井研县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:53'
      },
      {
        id: 2825,
        pid: 330,
        city_code: '101271404',
        city_name: '夹江县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:55'
      },
      {
        id: 2826,
        pid: 330,
        city_code: '101271405',
        city_name: '沐川县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:55'
      },
      {
        id: 2827,
        pid: 330,
        city_code: '101271406',
        city_name: '峨边县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:55'
      },
      {
        id: 2828,
        pid: 330,
        city_code: '101271407',
        city_name: '马边县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:55'
      },
      {
        id: 2829,
        pid: 331,
        city_code: '101271610',
        city_name: '西昌市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:56'
      },
      {
        id: 2830,
        pid: 331,
        city_code: '101271604',
        city_name: '盐源县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:57'
      },
      {
        id: 2831,
        pid: 331,
        city_code: '101271605',
        city_name: '德昌县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:58'
      },
      {
        id: 2832,
        pid: 331,
        city_code: '101271606',
        city_name: '会理县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:58'
      },
      {
        id: 2833,
        pid: 331,
        city_code: '101271607',
        city_name: '会东县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:59'
      },
      {
        id: 2834,
        pid: 331,
        city_code: '101271608',
        city_name: '宁南县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:59'
      },
      {
        id: 2835,
        pid: 331,
        city_code: '101271609',
        city_name: '普格县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:59'
      },
      {
        id: 2836,
        pid: 331,
        city_code: '101271619',
        city_name: '布拖县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:34:59'
      },
      {
        id: 2837,
        pid: 331,
        city_code: '101271611',
        city_name: '金阳县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:00'
      },
      {
        id: 2838,
        pid: 331,
        city_code: '101271612',
        city_name: '昭觉县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:01'
      },
      {
        id: 2839,
        pid: 331,
        city_code: '101271613',
        city_name: '喜德县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:01'
      },
      {
        id: 2840,
        pid: 331,
        city_code: '101271614',
        city_name: '冕宁县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:01'
      },
      {
        id: 2841,
        pid: 331,
        city_code: '101271615',
        city_name: '越西县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:02'
      },
      {
        id: 2842,
        pid: 331,
        city_code: '101271616',
        city_name: '甘洛县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:02'
      },
      {
        id: 2843,
        pid: 331,
        city_code: '101271618',
        city_name: '美姑县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:02'
      },
      {
        id: 2844,
        pid: 331,
        city_code: '101271617',
        city_name: '雷波县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:02'
      },
      {
        id: 2845,
        pid: 331,
        city_code: '101271603',
        city_name: '木里县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:03'
      },
      {
        id: 2847,
        pid: 332,
        city_code: '101271502',
        city_name: '仁寿县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:03'
      },
      {
        id: 2848,
        pid: 332,
        city_code: '101271503',
        city_name: '彭山区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 21:24:24'
      },
      {
        id: 2849,
        pid: 332,
        city_code: '101271504',
        city_name: '洪雅县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:03'
      },
      {
        id: 2850,
        pid: 332,
        city_code: '101271505',
        city_name: '丹棱县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:03'
      },
      {
        id: 2851,
        pid: 332,
        city_code: '101271506',
        city_name: '青神县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:04'
      },
      {
        id: 2852,
        pid: 333,
        city_code: '101270507',
        city_name: '阆中市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:04'
      },
      {
        id: 2853,
        pid: 333,
        city_code: '101270502',
        city_name: '南部县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:04'
      },
      {
        id: 2854,
        pid: 333,
        city_code: '101270503',
        city_name: '营山县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:04'
      },
      {
        id: 2855,
        pid: 333,
        city_code: '101270504',
        city_name: '蓬安县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:05'
      },
      {
        id: 2856,
        pid: 333,
        city_code: '101270505',
        city_name: '仪陇县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:05'
      },
      {
        id: 2860,
        pid: 333,
        city_code: '101270506',
        city_name: '西充县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:05'
      },
      {
        id: 2862,
        pid: 334,
        city_code: '101271202',
        city_name: '东兴区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:05'
      },
      {
        id: 2863,
        pid: 334,
        city_code: '101271203',
        city_name: '威远县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:06'
      },
      {
        id: 2864,
        pid: 334,
        city_code: '101271204',
        city_name: '资中县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:06'
      },
      {
        id: 2865,
        pid: 334,
        city_code: '101271205',
        city_name: '隆昌县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:06'
      },
      {
        id: 2868,
        pid: 335,
        city_code: '101270202',
        city_name: '仁和区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:07'
      },
      {
        id: 2869,
        pid: 335,
        city_code: '101270203',
        city_name: '米易县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:07'
      },
      {
        id: 2870,
        pid: 335,
        city_code: '101270204',
        city_name: '盐边县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:07'
      },
      {
        id: 2873,
        pid: 336,
        city_code: '101270702',
        city_name: '蓬溪县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:07'
      },
      {
        id: 2874,
        pid: 336,
        city_code: '101270703',
        city_name: '射洪县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:08'
      },
      {
        id: 2877,
        pid: 337,
        city_code: '101271702',
        city_name: '名山区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 21:24:24'
      },
      {
        id: 2878,
        pid: 337,
        city_code: '101271703',
        city_name: '荥经县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:08'
      },
      {
        id: 2879,
        pid: 337,
        city_code: '101271704',
        city_name: '汉源县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:08'
      },
      {
        id: 2880,
        pid: 337,
        city_code: '101271705',
        city_name: '石棉县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:08'
      },
      {
        id: 2881,
        pid: 337,
        city_code: '101271706',
        city_name: '天全县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:09'
      },
      {
        id: 2882,
        pid: 337,
        city_code: '101271707',
        city_name: '芦山县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:09'
      },
      {
        id: 2883,
        pid: 337,
        city_code: '101271708',
        city_name: '宝兴县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:09'
      },
      {
        id: 2885,
        pid: 338,
        city_code: '101271103',
        city_name: '叙州区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 21:24:24'
      },
      {
        id: 2886,
        pid: 338,
        city_code: '101271104',
        city_name: '南溪区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 21:24:24'
      },
      {
        id: 2887,
        pid: 338,
        city_code: '101271105',
        city_name: '江安县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:10'
      },
      {
        id: 2888,
        pid: 338,
        city_code: '101271106',
        city_name: '长宁县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:10'
      },
      {
        id: 2889,
        pid: 338,
        city_code: '101271107',
        city_name: '高县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:10'
      },
      {
        id: 2890,
        pid: 338,
        city_code: '101271108',
        city_name: '珙县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:11'
      },
      {
        id: 2891,
        pid: 338,
        city_code: '101271109',
        city_name: '筠连县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:11'
      },
      {
        id: 2892,
        pid: 338,
        city_code: '101271110',
        city_name: '兴文县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:11'
      },
      {
        id: 2893,
        pid: 338,
        city_code: '101271111',
        city_name: '屏山县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:11'
      },
      {
        id: 2895,
        pid: 321,
        city_code: '101270121',
        city_name: '简阳市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:12'
      },
      {
        id: 2896,
        pid: 339,
        city_code: '101271302',
        city_name: '安岳县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:12'
      },
      {
        id: 2897,
        pid: 339,
        city_code: '101271303',
        city_name: '乐至县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:12'
      },
      {
        id: 2902,
        pid: 340,
        city_code: '101270303',
        city_name: '荣县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:12'
      },
      {
        id: 2903,
        pid: 340,
        city_code: '101270302',
        city_name: '富顺县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:12'
      },
      {
        id: 2905,
        pid: 341,
        city_code: '101271007',
        city_name: '纳溪区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:13'
      },
      {
        id: 2907,
        pid: 341,
        city_code: '101271003',
        city_name: '泸县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:13'
      },
      {
        id: 2908,
        pid: 341,
        city_code: '101271004',
        city_name: '合江县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:13'
      },
      {
        id: 2909,
        pid: 341,
        city_code: '101271005',
        city_name: '叙永县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:13'
      },
      {
        id: 2910,
        pid: 341,
        city_code: '101271006',
        city_name: '古蔺县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:14'
      },
      {
        id: 2917,
        pid: 26,
        city_code: '101030400',
        city_name: '东丽区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:14'
      },
      {
        id: 2918,
        pid: 26,
        city_code: '101031000',
        city_name: '津南区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:14'
      },
      {
        id: 2919,
        pid: 26,
        city_code: '101030500',
        city_name: '西青区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:14'
      },
      {
        id: 2920,
        pid: 26,
        city_code: '101030600',
        city_name: '北辰区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:15'
      },
      {
        id: 2921,
        pid: 26,
        city_code: '101031100',
        city_name: '滨海新区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 21:24:25'
      },
      {
        id: 2922,
        pid: 26,
        city_code: '101030800',
        city_name: '和平区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 21:24:25'
      },
      {
        id: 2923,
        pid: 26,
        city_code: '101031200',
        city_name: '河东区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 21:24:25'
      },
      {
        id: 2924,
        pid: 26,
        city_code: '101030200',
        city_name: '武清区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:16'
      },
      {
        id: 2925,
        pid: 26,
        city_code: '101030300',
        city_name: '宝坻区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:16'
      },
      {
        id: 2927,
        pid: 26,
        city_code: '101030700',
        city_name: '宁河区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:18'
      },
      {
        id: 2928,
        pid: 26,
        city_code: '101030900',
        city_name: '静海区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:18'
      },
      {
        id: 2929,
        pid: 26,
        city_code: '101031400',
        city_name: '蓟州区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:19'
      },
      {
        id: 2931,
        pid: 343,
        city_code: '101140104',
        city_name: '林周县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:21'
      },
      {
        id: 2932,
        pid: 343,
        city_code: '101140102',
        city_name: '当雄县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:21'
      },
      {
        id: 2933,
        pid: 343,
        city_code: '101140103',
        city_name: '尼木县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:22'
      },
      {
        id: 2934,
        pid: 343,
        city_code: '101140106',
        city_name: '曲水县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:22'
      },
      {
        id: 2935,
        pid: 343,
        city_code: '101140105',
        city_name: '堆龙德庆区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 21:24:25'
      },
      {
        id: 2936,
        pid: 343,
        city_code: '101140107',
        city_name: '达孜县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:24'
      },
      {
        id: 2937,
        pid: 343,
        city_code: '101140108',
        city_name: '墨竹工卡县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:24'
      },
      {
        id: 2938,
        pid: 344,
        city_code: '101140707',
        city_name: '噶尔县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:25'
      },
      {
        id: 2939,
        pid: 344,
        city_code: '101140705',
        city_name: '普兰县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:26'
      },
      {
        id: 2940,
        pid: 344,
        city_code: '101140706',
        city_name: '札达县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:26'
      },
      {
        id: 2941,
        pid: 344,
        city_code: '101140708',
        city_name: '日土县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:27'
      },
      {
        id: 2942,
        pid: 344,
        city_code: '101140709',
        city_name: '革吉县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:27'
      },
      {
        id: 2943,
        pid: 344,
        city_code: '101140702',
        city_name: '改则县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:29'
      },
      {
        id: 2944,
        pid: 344,
        city_code: '101140710',
        city_name: '措勤县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:29'
      },
      {
        id: 2946,
        pid: 345,
        city_code: '101140509',
        city_name: '江达县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:30'
      },
      {
        id: 2947,
        pid: 345,
        city_code: '101140511',
        city_name: '贡觉县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:30'
      },
      {
        id: 2948,
        pid: 345,
        city_code: '101140507',
        city_name: '类乌齐县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:32'
      },
      {
        id: 2949,
        pid: 345,
        city_code: '101140502',
        city_name: '丁青县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:33'
      },
      {
        id: 2950,
        pid: 345,
        city_code: '101140510',
        city_name: '察雅县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:34'
      },
      {
        id: 2951,
        pid: 345,
        city_code: '101140508',
        city_name: '八宿县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:35'
      },
      {
        id: 2952,
        pid: 345,
        city_code: '101140505',
        city_name: '左贡县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:36'
      },
      {
        id: 2953,
        pid: 345,
        city_code: '101140506',
        city_name: '芒康县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:36'
      },
      {
        id: 2954,
        pid: 345,
        city_code: '101140504',
        city_name: '洛隆县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:36'
      },
      {
        id: 2955,
        pid: 345,
        city_code: '101140503',
        city_name: '边坝县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:37'
      },
      {
        id: 2957,
        pid: 346,
        city_code: '101140405',
        city_name: '工布江达县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:39'
      },
      {
        id: 2958,
        pid: 346,
        city_code: '101140403',
        city_name: '米林县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:41'
      },
      {
        id: 2959,
        pid: 346,
        city_code: '101140407',
        city_name: '墨脱县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:41'
      },
      {
        id: 2960,
        pid: 346,
        city_code: '101140402',
        city_name: '波密县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:42'
      },
      {
        id: 2961,
        pid: 346,
        city_code: '101140404',
        city_name: '察隅县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:43'
      },
      {
        id: 2962,
        pid: 346,
        city_code: '101140406',
        city_name: '朗县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:44'
      },
      {
        id: 2964,
        pid: 347,
        city_code: '101140603',
        city_name: '嘉黎县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:44'
      },
      {
        id: 2965,
        pid: 347,
        city_code: '101140609',
        city_name: '比如县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:45'
      },
      {
        id: 2966,
        pid: 347,
        city_code: '101140607',
        city_name: '聂荣县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:45'
      },
      {
        id: 2967,
        pid: 347,
        city_code: '101140605',
        city_name: '安多县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:46'
      },
      {
        id: 2968,
        pid: 347,
        city_code: '101140611',
        city_name: '申扎县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:46'
      },
      {
        id: 2969,
        pid: 347,
        city_code: '101140606',
        city_name: '索县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:47'
      },
      {
        id: 2970,
        pid: 347,
        city_code: '101140604',
        city_name: '班戈县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:48'
      },
      {
        id: 2971,
        pid: 347,
        city_code: '101140608',
        city_name: '巴青县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:48'
      },
      {
        id: 2972,
        pid: 347,
        city_code: '101140602',
        city_name: '尼玛县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:48'
      },
      {
        id: 2974,
        pid: 348,
        city_code: '101140203',
        city_name: '南木林县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:49'
      },
      {
        id: 2975,
        pid: 348,
        city_code: '101140206',
        city_name: '江孜县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:51'
      },
      {
        id: 2976,
        pid: 348,
        city_code: '101140205',
        city_name: '定日县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:51'
      },
      {
        id: 2977,
        pid: 348,
        city_code: '101140213',
        city_name: '萨迦县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:53'
      },
      {
        id: 2978,
        pid: 348,
        city_code: '101140202',
        city_name: '拉孜县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:53'
      },
      {
        id: 2979,
        pid: 348,
        city_code: '101140211',
        city_name: '昂仁县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:54'
      },
      {
        id: 2980,
        pid: 348,
        city_code: '101140214',
        city_name: '谢通门县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:55'
      },
      {
        id: 2981,
        pid: 348,
        city_code: '101140217',
        city_name: '白朗县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:57'
      },
      {
        id: 2982,
        pid: 348,
        city_code: '101140220',
        city_name: '仁布县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:58'
      },
      {
        id: 2983,
        pid: 348,
        city_code: '101140219',
        city_name: '康马县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:58'
      },
      {
        id: 2984,
        pid: 348,
        city_code: '101140212',
        city_name: '定结县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:35:59'
      },
      {
        id: 2985,
        pid: 348,
        city_code: '101140208',
        city_name: '仲巴县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:00'
      },
      {
        id: 2986,
        pid: 348,
        city_code: '101140218',
        city_name: '亚东县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:00'
      },
      {
        id: 2987,
        pid: 348,
        city_code: '101140210',
        city_name: '吉隆县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:01'
      },
      {
        id: 2988,
        pid: 348,
        city_code: '101140204',
        city_name: '聂拉木县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:01'
      },
      {
        id: 2989,
        pid: 348,
        city_code: '101140209',
        city_name: '萨嘎县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:01'
      },
      {
        id: 2990,
        pid: 348,
        city_code: '101140216',
        city_name: '岗巴县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:03'
      },
      {
        id: 2991,
        pid: 349,
        city_code: '101140309',
        city_name: '乃东区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 21:24:26'
      },
      {
        id: 2992,
        pid: 349,
        city_code: '101140303',
        city_name: '扎囊县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:03'
      },
      {
        id: 2993,
        pid: 349,
        city_code: '101140302',
        city_name: '贡嘎县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:04'
      },
      {
        id: 2994,
        pid: 349,
        city_code: '101140310',
        city_name: '桑日县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:05'
      },
      {
        id: 2995,
        pid: 349,
        city_code: '101140313',
        city_name: '琼结县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:05'
      },
      {
        id: 2996,
        pid: 349,
        city_code: '101140314',
        city_name: '曲松县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:05'
      },
      {
        id: 2997,
        pid: 349,
        city_code: '101140312',
        city_name: '措美县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:05'
      },
      {
        id: 2998,
        pid: 349,
        city_code: '101140311',
        city_name: '洛扎县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:05'
      },
      {
        id: 2999,
        pid: 349,
        city_code: '101140304',
        city_name: '加查县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:07'
      },
      {
        id: 3000,
        pid: 349,
        city_code: '101140307',
        city_name: '隆子县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:07'
      },
      {
        id: 3001,
        pid: 349,
        city_code: '101140306',
        city_name: '错那县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:08'
      },
      {
        id: 3002,
        pid: 349,
        city_code: '101140305',
        city_name: '浪卡子县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:08'
      },
      {
        id: 3008,
        pid: 350,
        city_code: '101130105',
        city_name: '达坂城区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:10'
      },
      {
        id: 3010,
        pid: 350,
        city_code: '101130113',
        city_name: '乌鲁木齐县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:10'
      },
      {
        id: 3012,
        pid: 351,
        city_code: '101130803',
        city_name: '温宿县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:10'
      },
      {
        id: 3013,
        pid: 351,
        city_code: '101130807',
        city_name: '库车县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:10'
      },
      {
        id: 3014,
        pid: 351,
        city_code: '101130806',
        city_name: '沙雅县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:11'
      },
      {
        id: 3015,
        pid: 351,
        city_code: '101130805',
        city_name: '新和县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:12'
      },
      {
        id: 3016,
        pid: 351,
        city_code: '101130804',
        city_name: '拜城县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:12'
      },
      {
        id: 3017,
        pid: 351,
        city_code: '101130802',
        city_name: '乌什县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:12'
      },
      {
        id: 3018,
        pid: 351,
        city_code: '101130809',
        city_name: '阿瓦提县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:13'
      },
      {
        id: 3019,
        pid: 351,
        city_code: '101130808',
        city_name: '柯坪县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:13'
      },
      {
        id: 3021,
        pid: 353,
        city_code: '101130601',
        city_name: '库尔勒',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 17:36:51'
      },
      {
        id: 3022,
        pid: 353,
        city_code: '101130602',
        city_name: '轮台县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:14'
      },
      {
        id: 3023,
        pid: 353,
        city_code: '101130603',
        city_name: '尉犁县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:15'
      },
      {
        id: 3024,
        pid: 353,
        city_code: '101130604',
        city_name: '若羌县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:15'
      },
      {
        id: 3025,
        pid: 353,
        city_code: '101130605',
        city_name: '且末县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:15'
      },
      {
        id: 3026,
        pid: 353,
        city_code: '101130607',
        city_name: '焉耆县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:17'
      },
      {
        id: 3027,
        pid: 353,
        city_code: '101130606',
        city_name: '和静县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:17'
      },
      {
        id: 3028,
        pid: 353,
        city_code: '101130608',
        city_name: '和硕县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:17'
      },
      {
        id: 3029,
        pid: 353,
        city_code: '101130612',
        city_name: '博湖县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:17'
      },
      {
        id: 3030,
        pid: 354,
        city_code: '101131601',
        city_name: '博乐市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:17'
      },
      {
        id: 3031,
        pid: 354,
        city_code: '101131603',
        city_name: '精河县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:18'
      },
      {
        id: 3032,
        pid: 354,
        city_code: '101131602',
        city_name: '温泉县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:18'
      },
      {
        id: 3033,
        pid: 355,
        city_code: '101130402',
        city_name: '呼图壁县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:18'
      },
      {
        id: 3034,
        pid: 355,
        city_code: '101130403',
        city_name: '米泉',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 21:24:27'
      },
      {
        id: 3036,
        pid: 355,
        city_code: '101130404',
        city_name: '阜康市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:19'
      },
      {
        id: 3037,
        pid: 355,
        city_code: '101130407',
        city_name: '玛纳斯县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:20'
      },
      {
        id: 3038,
        pid: 355,
        city_code: '101130406',
        city_name: '奇台县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:21'
      },
      {
        id: 3039,
        pid: 355,
        city_code: '101130405',
        city_name: '吉木萨尔县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:23'
      },
      {
        id: 3040,
        pid: 355,
        city_code: '101130408',
        city_name: '木垒县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:23'
      },
      {
        id: 3042,
        pid: 356,
        city_code: '101131204',
        city_name: '伊吾县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:23'
      },
      {
        id: 3043,
        pid: 356,
        city_code: '101131203',
        city_name: '巴里坤',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 17:36:53'
      },
      {
        id: 3046,
        pid: 357,
        city_code: '101131304',
        city_name: '墨玉县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:28'
      },
      {
        id: 3047,
        pid: 357,
        city_code: '101131302',
        city_name: '皮山县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:28'
      },
      {
        id: 3048,
        pid: 357,
        city_code: '101131305',
        city_name: '洛浦县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:29'
      },
      {
        id: 3049,
        pid: 357,
        city_code: '101131303',
        city_name: '策勒县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:31'
      },
      {
        id: 3050,
        pid: 357,
        city_code: '101131307',
        city_name: '于田县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:32'
      },
      {
        id: 3051,
        pid: 357,
        city_code: '101131306',
        city_name: '民丰县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:32'
      },
      {
        id: 3053,
        pid: 358,
        city_code: '101130911',
        city_name: '疏附县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:34'
      },
      {
        id: 3054,
        pid: 358,
        city_code: '101130912',
        city_name: '疏勒县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:35'
      },
      {
        id: 3055,
        pid: 358,
        city_code: '101130902',
        city_name: '英吉沙县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:35'
      },
      {
        id: 3056,
        pid: 358,
        city_code: '101130907',
        city_name: '泽普县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:36'
      },
      {
        id: 3057,
        pid: 358,
        city_code: '101130905',
        city_name: '莎车县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:36'
      },
      {
        id: 3058,
        pid: 358,
        city_code: '101130906',
        city_name: '叶城县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:37'
      },
      {
        id: 3059,
        pid: 358,
        city_code: '101130904',
        city_name: '麦盖提县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:37'
      },
      {
        id: 3060,
        pid: 358,
        city_code: '101130909',
        city_name: '岳普湖县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:37'
      },
      {
        id: 3061,
        pid: 358,
        city_code: '101130910',
        city_name: '伽师县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:37'
      },
      {
        id: 3062,
        pid: 358,
        city_code: '101130908',
        city_name: '巴楚县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:38'
      },
      {
        id: 3063,
        pid: 358,
        city_code: '101130903',
        city_name: '塔什库尔干',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 17:36:55'
      },
      {
        id: 3065,
        pid: 360,
        city_code: '101131501',
        city_name: '阿图什市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:38'
      },
      {
        id: 3066,
        pid: 360,
        city_code: '101131503',
        city_name: '阿克陶县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:41'
      },
      {
        id: 3067,
        pid: 360,
        city_code: '101131504',
        city_name: '阿合奇县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:41'
      },
      {
        id: 3068,
        pid: 360,
        city_code: '101131502',
        city_name: '乌恰县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:41'
      },
      {
        id: 3072,
        pid: 363,
        city_code: '101130504',
        city_name: '鄯善县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:43'
      },
      {
        id: 3073,
        pid: 363,
        city_code: '101130502',
        city_name: '托克逊县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:43'
      },
      {
        id: 3075,
        pid: 365,
        city_code: '101131401',
        city_name: '阿勒泰',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:43'
      },
      {
        id: 3076,
        pid: 365,
        city_code: '101131104',
        city_name: '和布克赛尔',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 17:36:55'
      },
      {
        id: 3077,
        pid: 365,
        city_code: '101131001',
        city_name: '伊宁市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:44'
      },
      {
        id: 3078,
        pid: 365,
        city_code: '101131406',
        city_name: '布尔津县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:44'
      },
      {
        id: 3079,
        pid: 365,
        city_code: '101131011',
        city_name: '奎屯市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:44'
      },
      {
        id: 3080,
        pid: 365,
        city_code: '101131106',
        city_name: '乌苏市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:44'
      },
      {
        id: 3081,
        pid: 365,
        city_code: '101131103',
        city_name: '额敏县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:45'
      },
      {
        id: 3082,
        pid: 365,
        city_code: '101131408',
        city_name: '富蕴县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:45'
      },
      {
        id: 3083,
        pid: 365,
        city_code: '101131004',
        city_name: '伊宁县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:45'
      },
      {
        id: 3084,
        pid: 365,
        city_code: '101131407',
        city_name: '福海县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:45'
      },
      {
        id: 3085,
        pid: 365,
        city_code: '101131009',
        city_name: '霍城县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:46'
      },
      {
        id: 3086,
        pid: 365,
        city_code: '101131107',
        city_name: '沙湾县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:46'
      },
      {
        id: 3087,
        pid: 365,
        city_code: '101131005',
        city_name: '巩留县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:46'
      },
      {
        id: 3088,
        pid: 365,
        city_code: '101131402',
        city_name: '哈巴河县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:46'
      },
      {
        id: 3089,
        pid: 365,
        city_code: '101131105',
        city_name: '托里县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:47'
      },
      {
        id: 3090,
        pid: 365,
        city_code: '101131409',
        city_name: '青河县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:48'
      },
      {
        id: 3091,
        pid: 365,
        city_code: '101131006',
        city_name: '新源县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:48'
      },
      {
        id: 3092,
        pid: 365,
        city_code: '101131102',
        city_name: '裕民县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:48'
      },
      {
        id: 3094,
        pid: 365,
        city_code: '101131405',
        city_name: '吉木乃县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:48'
      },
      {
        id: 3095,
        pid: 365,
        city_code: '101131007',
        city_name: '昭苏县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:49'
      },
      {
        id: 3096,
        pid: 365,
        city_code: '101131008',
        city_name: '特克斯县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:49'
      },
      {
        id: 3097,
        pid: 365,
        city_code: '101131003',
        city_name: '尼勒克县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:50'
      },
      {
        id: 3098,
        pid: 365,
        city_code: '101131002',
        city_name: '察布查尔',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 17:36:57'
      },
      {
        id: 3103,
        pid: 366,
        city_code: '101290103',
        city_name: '东川区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:50'
      },
      {
        id: 3104,
        pid: 366,
        city_code: '101290112',
        city_name: '安宁市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:50'
      },
      {
        id: 3105,
        pid: 366,
        city_code: '101290108',
        city_name: '呈贡区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 21:24:27'
      },
      {
        id: 3106,
        pid: 366,
        city_code: '101290105',
        city_name: '晋宁县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:51'
      },
      {
        id: 3107,
        pid: 366,
        city_code: '101290109',
        city_name: '富民县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:51'
      },
      {
        id: 3108,
        pid: 366,
        city_code: '101290106',
        city_name: '宜良县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:51'
      },
      {
        id: 3109,
        pid: 366,
        city_code: '101290110',
        city_name: '嵩明县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:51'
      },
      {
        id: 3110,
        pid: 366,
        city_code: '101290107',
        city_name: '石林县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:52'
      },
      {
        id: 3111,
        pid: 366,
        city_code: '101290111',
        city_name: '禄劝县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:52'
      },
      {
        id: 3112,
        pid: 366,
        city_code: '101290104',
        city_name: '寻甸县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:52'
      },
      {
        id: 3113,
        pid: 367,
        city_code: '101291204',
        city_name: '兰坪县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:52'
      },
      {
        id: 3114,
        pid: 367,
        city_code: '101291205',
        city_name: '泸水市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 21:24:27'
      },
      {
        id: 3115,
        pid: 367,
        city_code: '101291203',
        city_name: '福贡县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:53'
      },
      {
        id: 3116,
        pid: 367,
        city_code: '101291207',
        city_name: '贡山县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:53'
      },
      {
        id: 3117,
        pid: 368,
        city_code: '101290912',
        city_name: '宁洱县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:53'
      },
      {
        id: 3118,
        pid: 368,
        city_code: '101290905',
        city_name: '思茅区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:53'
      },
      {
        id: 3119,
        pid: 368,
        city_code: '101290906',
        city_name: '墨江县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:53'
      },
      {
        id: 3120,
        pid: 368,
        city_code: '101290903',
        city_name: '景东县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:54'
      },
      {
        id: 3121,
        pid: 368,
        city_code: '101290902',
        city_name: '景谷县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:54'
      },
      {
        id: 3122,
        pid: 368,
        city_code: '101290911',
        city_name: '镇沅县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:54'
      },
      {
        id: 3123,
        pid: 368,
        city_code: '101290907',
        city_name: '江城县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:55'
      },
      {
        id: 3124,
        pid: 368,
        city_code: '101290908',
        city_name: '孟连县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:55'
      },
      {
        id: 3125,
        pid: 368,
        city_code: '101290904',
        city_name: '澜沧县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:55'
      },
      {
        id: 3126,
        pid: 368,
        city_code: '101290909',
        city_name: '西盟县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:55'
      },
      {
        id: 3128,
        pid: 369,
        city_code: '101291404',
        city_name: '宁蒗县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:57'
      },
      {
        id: 3130,
        pid: 369,
        city_code: '101291402',
        city_name: '永胜县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:57'
      },
      {
        id: 3131,
        pid: 369,
        city_code: '101291403',
        city_name: '华坪县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:58'
      },
      {
        id: 3133,
        pid: 370,
        city_code: '101290504',
        city_name: '施甸县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:36:59'
      },
      {
        id: 3134,
        pid: 370,
        city_code: '101290506',
        city_name: '腾冲市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 21:24:28'
      },
      {
        id: 3135,
        pid: 370,
        city_code: '101290503',
        city_name: '龙陵县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:00'
      },
      {
        id: 3136,
        pid: 370,
        city_code: '101290505',
        city_name: '昌宁县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:01'
      },
      {
        id: 3138,
        pid: 371,
        city_code: '101290809',
        city_name: '双柏县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:02'
      },
      {
        id: 3139,
        pid: 371,
        city_code: '101290805',
        city_name: '牟定县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:03'
      },
      {
        id: 3140,
        pid: 371,
        city_code: '101290806',
        city_name: '南华县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:04'
      },
      {
        id: 3141,
        pid: 371,
        city_code: '101290804',
        city_name: '姚安县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:04'
      },
      {
        id: 3142,
        pid: 371,
        city_code: '101290802',
        city_name: '大姚县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:05'
      },
      {
        id: 3143,
        pid: 371,
        city_code: '101290810',
        city_name: '永仁县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:05'
      },
      {
        id: 3144,
        pid: 371,
        city_code: '101290803',
        city_name: '元谋县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:05'
      },
      {
        id: 3145,
        pid: 371,
        city_code: '101290807',
        city_name: '武定县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:05'
      },
      {
        id: 3146,
        pid: 371,
        city_code: '101290808',
        city_name: '禄丰县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:06'
      },
      {
        id: 3148,
        pid: 372,
        city_code: '101290207',
        city_name: '祥云县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:06'
      },
      {
        id: 3149,
        pid: 372,
        city_code: '101290205',
        city_name: '宾川县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:06'
      },
      {
        id: 3150,
        pid: 372,
        city_code: '101290206',
        city_name: '弥渡县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:08'
      },
      {
        id: 3151,
        pid: 372,
        city_code: '101290204',
        city_name: '永平县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:08'
      },
      {
        id: 3152,
        pid: 372,
        city_code: '101290202',
        city_name: '云龙县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:08'
      },
      {
        id: 3153,
        pid: 372,
        city_code: '101290210',
        city_name: '洱源县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:08'
      },
      {
        id: 3154,
        pid: 372,
        city_code: '101290209',
        city_name: '剑川县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:09'
      },
      {
        id: 3155,
        pid: 372,
        city_code: '101290211',
        city_name: '鹤庆县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:09'
      },
      {
        id: 3156,
        pid: 372,
        city_code: '101290203',
        city_name: '漾濞县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:09'
      },
      {
        id: 3157,
        pid: 372,
        city_code: '101290212',
        city_name: '南涧县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:10'
      },
      {
        id: 3158,
        pid: 372,
        city_code: '101290208',
        city_name: '巍山县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:11'
      },
      {
        id: 3159,
        pid: 373,
        city_code: '101291508',
        city_name: '芒市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 21:24:28'
      },
      {
        id: 3160,
        pid: 373,
        city_code: '101291506',
        city_name: '瑞丽市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:12'
      },
      {
        id: 3161,
        pid: 373,
        city_code: '101291507',
        city_name: '梁河县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:12'
      },
      {
        id: 3162,
        pid: 373,
        city_code: '101291504',
        city_name: '盈江县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:13'
      },
      {
        id: 3163,
        pid: 373,
        city_code: '101291503',
        city_name: '陇川县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:15'
      },
      {
        id: 3164,
        pid: 374,
        city_code: '101291301',
        city_name: '香格里拉市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 21:24:29'
      },
      {
        id: 3165,
        pid: 374,
        city_code: '101291302',
        city_name: '德钦县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:15'
      },
      {
        id: 3166,
        pid: 374,
        city_code: '101291303',
        city_name: '维西县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:16'
      },
      {
        id: 3167,
        pid: 375,
        city_code: '101290311',
        city_name: '泸西县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:17'
      },
      {
        id: 3168,
        pid: 375,
        city_code: '101290309',
        city_name: '蒙自市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:17'
      },
      {
        id: 3169,
        pid: 375,
        city_code: '101290308',
        city_name: '个旧市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:17'
      },
      {
        id: 3170,
        pid: 375,
        city_code: '101290307',
        city_name: '开远市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:17'
      },
      {
        id: 3171,
        pid: 375,
        city_code: '101290306',
        city_name: '绿春县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:18'
      },
      {
        id: 3172,
        pid: 375,
        city_code: '101290303',
        city_name: '建水县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:18'
      },
      {
        id: 3173,
        pid: 375,
        city_code: '101290302',
        city_name: '石屏县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:18'
      },
      {
        id: 3174,
        pid: 375,
        city_code: '101290304',
        city_name: '弥勒市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 21:24:31'
      },
      {
        id: 3175,
        pid: 375,
        city_code: '101290305',
        city_name: '元阳县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:19'
      },
      {
        id: 3177,
        pid: 375,
        city_code: '101290312',
        city_name: '金平县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:20'
      },
      {
        id: 3178,
        pid: 375,
        city_code: '101290313',
        city_name: '河口县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:20'
      },
      {
        id: 3179,
        pid: 375,
        city_code: '101290310',
        city_name: '屏边县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:22'
      },
      {
        id: 3181,
        pid: 376,
        city_code: '101291105',
        city_name: '凤庆县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:22'
      },
      {
        id: 3182,
        pid: 376,
        city_code: '101291107',
        city_name: '云县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:22'
      },
      {
        id: 3183,
        pid: 376,
        city_code: '101291106',
        city_name: '永德县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:22'
      },
      {
        id: 3184,
        pid: 376,
        city_code: '101291108',
        city_name: '镇康县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:24'
      },
      {
        id: 3185,
        pid: 376,
        city_code: '101291104',
        city_name: '双江县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:24'
      },
      {
        id: 3186,
        pid: 376,
        city_code: '101291103',
        city_name: '耿马县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:25'
      },
      {
        id: 3187,
        pid: 376,
        city_code: '101291102',
        city_name: '沧源县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:26'
      },
      {
        id: 3189,
        pid: 377,
        city_code: '101290409',
        city_name: '宣威市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 17:36:59'
      },
      {
        id: 3190,
        pid: 377,
        city_code: '101290405',
        city_name: '马龙县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:28'
      },
      {
        id: 3191,
        pid: 377,
        city_code: '101290403',
        city_name: '陆良县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:28'
      },
      {
        id: 3192,
        pid: 377,
        city_code: '101290406',
        city_name: '师宗县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:28'
      },
      {
        id: 3193,
        pid: 377,
        city_code: '101290407',
        city_name: '罗平县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:29'
      },
      {
        id: 3194,
        pid: 377,
        city_code: '101290404',
        city_name: '富源县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:29'
      },
      {
        id: 3195,
        pid: 377,
        city_code: '101290408',
        city_name: '会泽县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:30'
      },
      {
        id: 3196,
        pid: 377,
        city_code: '101290402',
        city_name: '沾益区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 21:24:32'
      },
      {
        id: 3198,
        pid: 378,
        city_code: '101290605',
        city_name: '砚山县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:31'
      },
      {
        id: 3199,
        pid: 378,
        city_code: '101290602',
        city_name: '西畴县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:31'
      },
      {
        id: 3200,
        pid: 378,
        city_code: '101290604',
        city_name: '麻栗坡县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:32'
      },
      {
        id: 3201,
        pid: 378,
        city_code: '101290603',
        city_name: '马关县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:32'
      },
      {
        id: 3202,
        pid: 378,
        city_code: '101290606',
        city_name: '丘北县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:32'
      },
      {
        id: 3203,
        pid: 378,
        city_code: '101290607',
        city_name: '广南县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:33'
      },
      {
        id: 3204,
        pid: 378,
        city_code: '101290608',
        city_name: '富宁县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:35'
      },
      {
        id: 3205,
        pid: 379,
        city_code: '101291601',
        city_name: '景洪市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:35'
      },
      {
        id: 3206,
        pid: 379,
        city_code: '101291603',
        city_name: '勐海县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:35'
      },
      {
        id: 3207,
        pid: 379,
        city_code: '101291605',
        city_name: '勐腊县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:36'
      },
      {
        id: 3209,
        pid: 380,
        city_code: '101290703',
        city_name: '江川区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 21:24:33'
      },
      {
        id: 3210,
        pid: 380,
        city_code: '101290702',
        city_name: '澄江县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:37'
      },
      {
        id: 3211,
        pid: 380,
        city_code: '101290704',
        city_name: '通海县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:37'
      },
      {
        id: 3212,
        pid: 380,
        city_code: '101290705',
        city_name: '华宁县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:37'
      },
      {
        id: 3213,
        pid: 380,
        city_code: '101290707',
        city_name: '易门县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:37'
      },
      {
        id: 3214,
        pid: 380,
        city_code: '101290708',
        city_name: '峨山县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:38'
      },
      {
        id: 3215,
        pid: 380,
        city_code: '101290706',
        city_name: '新平县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:38'
      },
      {
        id: 3216,
        pid: 380,
        city_code: '101290709',
        city_name: '元江县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:38'
      },
      {
        id: 3218,
        pid: 381,
        city_code: '101291002',
        city_name: '鲁甸县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:39'
      },
      {
        id: 3219,
        pid: 381,
        city_code: '101291006',
        city_name: '巧家县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:40'
      },
      {
        id: 3220,
        pid: 381,
        city_code: '101291009',
        city_name: '盐津县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:40'
      },
      {
        id: 3221,
        pid: 381,
        city_code: '101291010',
        city_name: '大关县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:40'
      },
      {
        id: 3222,
        pid: 381,
        city_code: '101291008',
        city_name: '永善县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:40'
      },
      {
        id: 3223,
        pid: 381,
        city_code: '101291007',
        city_name: '绥江县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:42'
      },
      {
        id: 3224,
        pid: 381,
        city_code: '101291004',
        city_name: '镇雄县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:42'
      },
      {
        id: 3225,
        pid: 381,
        city_code: '101291003',
        city_name: '彝良县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:42'
      },
      {
        id: 3226,
        pid: 381,
        city_code: '101291005',
        city_name: '威信县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:42'
      },
      {
        id: 3227,
        pid: 381,
        city_code: '101291011',
        city_name: '水富县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:42'
      },
      {
        id: 3234,
        pid: 382,
        city_code: '101210102',
        city_name: '萧山区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:44'
      },
      {
        id: 3235,
        pid: 382,
        city_code: '101210106',
        city_name: '余杭区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:44'
      },
      {
        id: 3237,
        pid: 382,
        city_code: '101210105',
        city_name: '建德市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:45'
      },
      {
        id: 3238,
        pid: 382,
        city_code: '101210108',
        city_name: '富阳区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:45'
      },
      {
        id: 3239,
        pid: 382,
        city_code: '101210107',
        city_name: '临安市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:47'
      },
      {
        id: 3240,
        pid: 382,
        city_code: '101210103',
        city_name: '桐庐县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:47'
      },
      {
        id: 3241,
        pid: 382,
        city_code: '101210104',
        city_name: '淳安县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:48'
      },
      {
        id: 3244,
        pid: 383,
        city_code: '101210204',
        city_name: '德清县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:48'
      },
      {
        id: 3245,
        pid: 383,
        city_code: '101210202',
        city_name: '长兴县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:50'
      },
      {
        id: 3246,
        pid: 383,
        city_code: '101210203',
        city_name: '安吉县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:50'
      },
      {
        id: 3249,
        pid: 384,
        city_code: '101210303',
        city_name: '海宁市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:50'
      },
      {
        id: 3250,
        pid: 384,
        city_code: '101210302',
        city_name: '嘉善县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:50'
      },
      {
        id: 3251,
        pid: 384,
        city_code: '101210305',
        city_name: '平湖市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:52'
      },
      {
        id: 3252,
        pid: 384,
        city_code: '101210304',
        city_name: '桐乡市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:53'
      },
      {
        id: 3253,
        pid: 384,
        city_code: '101210306',
        city_name: '海盐县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:53'
      },
      {
        id: 3256,
        pid: 385,
        city_code: '101210903',
        city_name: '兰溪市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:53'
      },
      {
        id: 3257,
        pid: 385,
        city_code: '101210904',
        city_name: '义乌市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:55'
      },
      {
        id: 3259,
        pid: 168,
        city_code: '101050708',
        city_name: '加格达奇',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 21:24:33'
      },
      {
        id: 3261,
        pid: 168,
        city_code: '101050706',
        city_name: '新林',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 21:24:35'
      },
      {
        id: 3262,
        pid: 168,
        city_code: '101050705',
        city_name: '呼中',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 21:24:36'
      },
      {
        id: 3264,
        pid: 385,
        city_code: '101210905',
        city_name: '东阳市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:56'
      },
      {
        id: 3265,
        pid: 385,
        city_code: '101210907',
        city_name: '永康市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:56'
      },
      {
        id: 3266,
        pid: 385,
        city_code: '101210906',
        city_name: '武义县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:57'
      },
      {
        id: 3267,
        pid: 385,
        city_code: '101210902',
        city_name: '浦江县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:57'
      },
      {
        id: 3268,
        pid: 385,
        city_code: '101210908',
        city_name: '磐安县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:57'
      },
      {
        id: 3270,
        pid: 386,
        city_code: '101210803',
        city_name: '龙泉市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:57'
      },
      {
        id: 3271,
        pid: 386,
        city_code: '101210805',
        city_name: '青田县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:58'
      },
      {
        id: 3272,
        pid: 386,
        city_code: '101210804',
        city_name: '缙云县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:58'
      },
      {
        id: 3273,
        pid: 386,
        city_code: '101210802',
        city_name: '遂昌县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:58'
      },
      {
        id: 3274,
        pid: 386,
        city_code: '101210808',
        city_name: '松阳县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:58'
      },
      {
        id: 3275,
        pid: 386,
        city_code: '101210806',
        city_name: '云和县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:59'
      },
      {
        id: 3276,
        pid: 386,
        city_code: '101210807',
        city_name: '庆元县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:59'
      },
      {
        id: 3277,
        pid: 386,
        city_code: '101210809',
        city_name: '景宁县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:59'
      },
      {
        id: 3281,
        pid: 387,
        city_code: '101210412',
        city_name: '镇海区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:37:59'
      },
      {
        id: 3282,
        pid: 387,
        city_code: '101210410',
        city_name: '北仑区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:38:00'
      },
      {
        id: 3283,
        pid: 387,
        city_code: '101210411',
        city_name: '鄞州区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:38:00'
      },
      {
        id: 3284,
        pid: 387,
        city_code: '101210404',
        city_name: '余姚市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:38:00'
      },
      {
        id: 3285,
        pid: 387,
        city_code: '101210403',
        city_name: '慈溪市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:38:00'
      },
      {
        id: 3286,
        pid: 387,
        city_code: '101210405',
        city_name: '奉化市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 21:24:36'
      },
      {
        id: 3287,
        pid: 387,
        city_code: '101210406',
        city_name: '象山县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:38:01'
      },
      {
        id: 3288,
        pid: 387,
        city_code: '101210408',
        city_name: '宁海县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:38:02'
      },
      {
        id: 3290,
        pid: 388,
        city_code: '101210503',
        city_name: '上虞区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:38:02'
      },
      {
        id: 3291,
        pid: 388,
        city_code: '101210505',
        city_name: '嵊州市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:38:03'
      },
      {
        id: 3292,
        pid: 388,
        city_code: '101210501',
        city_name: '越城区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 21:24:36'
      },
      {
        id: 3293,
        pid: 388,
        city_code: '101210504',
        city_name: '新昌县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:38:04'
      },
      {
        id: 3294,
        pid: 388,
        city_code: '101210502',
        city_name: '诸暨市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:38:04'
      },
      {
        id: 3295,
        pid: 389,
        city_code: '101210611',
        city_name: '椒江区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:38:04'
      },
      {
        id: 3296,
        pid: 389,
        city_code: '101210612',
        city_name: '黄岩区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:38:04'
      },
      {
        id: 3297,
        pid: 389,
        city_code: '101210613',
        city_name: '路桥区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:38:05'
      },
      {
        id: 3298,
        pid: 389,
        city_code: '101210607',
        city_name: '温岭市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:38:05'
      },
      {
        id: 3299,
        pid: 389,
        city_code: '101210610',
        city_name: '临海市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:38:06'
      },
      {
        id: 3300,
        pid: 389,
        city_code: '101210603',
        city_name: '玉环县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:38:07'
      },
      {
        id: 3301,
        pid: 389,
        city_code: '101210604',
        city_name: '三门县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:38:08'
      },
      {
        id: 3302,
        pid: 389,
        city_code: '101210605',
        city_name: '天台县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:38:08'
      },
      {
        id: 3303,
        pid: 389,
        city_code: '101210606',
        city_name: '仙居县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:38:10'
      },
      {
        id: 3307,
        pid: 390,
        city_code: '101210705',
        city_name: '瑞安市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:38:10'
      },
      {
        id: 3308,
        pid: 390,
        city_code: '101210707',
        city_name: '乐清市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:38:11'
      },
      {
        id: 3309,
        pid: 390,
        city_code: '101210706',
        city_name: '洞头区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:38:11'
      },
      {
        id: 3310,
        pid: 390,
        city_code: '101210708',
        city_name: '永嘉县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:38:11'
      },
      {
        id: 3311,
        pid: 390,
        city_code: '101210704',
        city_name: '平阳县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:38:11'
      },
      {
        id: 3312,
        pid: 390,
        city_code: '101210709',
        city_name: '苍南县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:38:12'
      },
      {
        id: 3313,
        pid: 390,
        city_code: '101210703',
        city_name: '文成县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:38:12'
      },
      {
        id: 3314,
        pid: 390,
        city_code: '101210702',
        city_name: '泰顺县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:38:12'
      },
      {
        id: 3315,
        pid: 391,
        city_code: '101211106',
        city_name: '定海区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:38:12'
      },
      {
        id: 3316,
        pid: 391,
        city_code: '101021500',
        city_name: '普陀区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:38:13'
      },
      {
        id: 3317,
        pid: 391,
        city_code: '101211104',
        city_name: '岱山县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:38:13'
      },
      {
        id: 3318,
        pid: 391,
        city_code: '101211102',
        city_name: '嵊泗县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:38:13'
      },
      {
        id: 3319,
        pid: 392,
        city_code: '101211006',
        city_name: '衢江区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:38:14'
      },
      {
        id: 3320,
        pid: 392,
        city_code: '101211005',
        city_name: '江山市',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:38:14'
      },
      {
        id: 3321,
        pid: 392,
        city_code: '101211002',
        city_name: '常山县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:38:14'
      },
      {
        id: 3322,
        pid: 392,
        city_code: '101211003',
        city_name: '开化县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:38:14'
      },
      {
        id: 3323,
        pid: 392,
        city_code: '101211004',
        city_name: '龙游县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:38:15'
      },
      {
        id: 3324,
        pid: 31,
        city_code: '101040300',
        city_name: '合川区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:38:15'
      },
      {
        id: 3325,
        pid: 31,
        city_code: '101040500',
        city_name: '江津区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:38:15'
      },
      {
        id: 3326,
        pid: 31,
        city_code: '101040400',
        city_name: '南川区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:38:15'
      },
      {
        id: 3327,
        pid: 31,
        city_code: '101040200',
        city_name: '永川区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:38:16'
      },
      {
        id: 3329,
        pid: 31,
        city_code: '101040700',
        city_name: '渝北区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:38:16'
      },
      {
        id: 3330,
        pid: 31,
        city_code: '101040600',
        city_name: '万盛',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 21:24:37'
      },
      {
        id: 3332,
        pid: 31,
        city_code: '101041300',
        city_name: '万州区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:38:16'
      },
      {
        id: 3333,
        pid: 31,
        city_code: '101040800',
        city_name: '北碚区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:38:17'
      },
      {
        id: 3334,
        pid: 31,
        city_code: '101043800',
        city_name: '沙坪坝区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:38:17'
      },
      {
        id: 3335,
        pid: 31,
        city_code: '101040900',
        city_name: '巴南区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:38:17'
      },
      {
        id: 3336,
        pid: 31,
        city_code: '101041400',
        city_name: '涪陵区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:38:17'
      },
      {
        id: 3340,
        pid: 31,
        city_code: '101041100',
        city_name: '黔江区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:38:18'
      },
      {
        id: 3341,
        pid: 31,
        city_code: '101041000',
        city_name: '长寿区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:38:18'
      },
      {
        id: 3343,
        pid: 31,
        city_code: '101043300',
        city_name: '綦江区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:38:18'
      },
      {
        id: 3344,
        pid: 31,
        city_code: '101042100',
        city_name: '潼南区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:38:18'
      },
      {
        id: 3345,
        pid: 31,
        city_code: '101042800',
        city_name: '铜梁区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:38:18'
      },
      {
        id: 3346,
        pid: 31,
        city_code: '101042600',
        city_name: '大足区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 21:24:37'
      },
      {
        id: 3347,
        pid: 31,
        city_code: '101042700',
        city_name: '荣昌区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:38:19'
      },
      {
        id: 3348,
        pid: 31,
        city_code: '101042900',
        city_name: '璧山区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:38:19'
      },
      {
        id: 3349,
        pid: 31,
        city_code: '101042200',
        city_name: '垫江县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:38:19'
      },
      {
        id: 3350,
        pid: 31,
        city_code: '101043100',
        city_name: '武隆县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:38:20'
      },
      {
        id: 3351,
        pid: 31,
        city_code: '101043000',
        city_name: '丰都县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:38:20'
      },
      {
        id: 3352,
        pid: 31,
        city_code: '101041600',
        city_name: '城口县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:38:20'
      },
      {
        id: 3353,
        pid: 31,
        city_code: '101042300',
        city_name: '梁平县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:38:20'
      },
      {
        id: 3354,
        pid: 31,
        city_code: '101044100',
        city_name: '开州区',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 17:37:05'
      },
      {
        id: 3355,
        pid: 31,
        city_code: '101041800',
        city_name: '巫溪县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:38:26'
      },
      {
        id: 3356,
        pid: 31,
        city_code: '101042000',
        city_name: '巫山县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:38:26'
      },
      {
        id: 3357,
        pid: 31,
        city_code: '101041900',
        city_name: '奉节县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:38:26'
      },
      {
        id: 3358,
        pid: 31,
        city_code: '101041700',
        city_name: '云阳县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:38:27'
      },
      {
        id: 3359,
        pid: 31,
        city_code: '101042400',
        city_name: '忠县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:38:27'
      },
      {
        id: 3360,
        pid: 31,
        city_code: '101042500',
        city_name: '石柱县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:38:27'
      },
      {
        id: 3361,
        pid: 31,
        city_code: '101043200',
        city_name: '彭水县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:38:30'
      },
      {
        id: 3362,
        pid: 31,
        city_code: '101043400',
        city_name: '酉阳县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 17:19:03'
      },
      {
        id: 3363,
        pid: 31,
        city_code: '101043600',
        city_name: '秀山县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:38:36'
      },
      {
        id: 3368,
        pid: 32,
        city_code: '101320102',
        city_name: '九龙',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 21:24:37'
      },
      {
        id: 3383,
        pid: 34,
        city_code: '101340101',
        city_name: '台北',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 17:19:05'
      },
      {
        id: 3384,
        pid: 34,
        city_code: '101340201',
        city_name: '高雄',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 17:19:06'
      },
      {
        id: 3386,
        pid: 34,
        city_code: '101340401',
        city_name: '台中',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:38:51'
      },
      {
        id: 3387,
        pid: 34,
        city_code: '101340203',
        city_name: '台南',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:38:51'
      },
      {
        id: 3388,
        pid: 34,
        city_code: '101340103',
        city_name: '新竹',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:38:52'
      },
      {
        id: 3389,
        pid: 34,
        city_code: '101340202',
        city_name: '嘉义',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 17:19:09'
      },
      {
        id: 3391,
        pid: 34,
        city_code: '101340102',
        city_name: '桃园',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 21:24:38'
      },
      {
        id: 3392,
        pid: 34,
        city_code: '101340402',
        city_name: '苗栗',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 21:24:38'
      },
      {
        id: 3393,
        pid: 34,
        city_code: '101340403',
        city_name: '彰化',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:24:00'
      },
      {
        id: 3394,
        pid: 34,
        city_code: '101340404',
        city_name: '南投',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 21:24:38'
      },
      {
        id: 3395,
        pid: 34,
        city_code: '101340406',
        city_name: '云林',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 21:24:39'
      },
      {
        id: 3396,
        pid: 34,
        city_code: '101340205',
        city_name: '屏东',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 21:24:39'
      },
      {
        id: 3397,
        pid: 34,
        city_code: '101340204',
        city_name: '台东县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:24:00'
      },
      {
        id: 3398,
        pid: 34,
        city_code: '101340405',
        city_name: '花莲',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:24:00'
      },
      {
        id: 3400,
        pid: 2,
        city_code: '101220101',
        city_name: '合肥',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 17:37:11'
      },
      {
        id: 3405,
        pid: 3400,
        city_code: '101220102',
        city_name: '长丰县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:39:10'
      },
      {
        id: 3406,
        pid: 3400,
        city_code: '101220103',
        city_name: '肥东县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 16:39:11'
      },
      {
        id: 3407,
        pid: 3400,
        city_code: '101220104',
        city_name: '肥西县',
        post_code: null,
        area_code: null,
        ctime: '2019-07-11 17:19:23'
      }
    ]
    return citys
  }
}
